import { jsx as u, Fragment as ut, jsxs as Q } from "react/jsx-runtime";
import * as d from "react";
import D, { useState as qn, useLayoutEffect as Xs, useMemo as mn, useContext as Zs, createContext as Qs, forwardRef as Js, createElement as br, useCallback as Re, useRef as Vn, useEffect as Vf } from "react";
import * as fo from "react-dom";
import Uf from "react-dom";
function ei(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = ei(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function ti() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = ei(e)) && (o && (o += " "), o += t);
  return o;
}
const jf = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let o = 0; o < e.length; o++)
    n[o] = e[o];
  for (let o = 0; o < t.length; o++)
    n[e.length + o] = t[o];
  return n;
}, Kf = (e, t) => ({
  classGroupId: e,
  validator: t
}), ni = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), Xn = "-", Ua = [], qf = "arbitrary..", Xf = (e) => {
  const t = Qf(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (s) => {
      if (s.startsWith("[") && s.endsWith("]"))
        return Zf(s);
      const i = s.split(Xn), l = i[0] === "" && i.length > 1 ? 1 : 0;
      return oi(i, l, t);
    },
    getConflictingClassGroupIds: (s, i) => {
      if (i) {
        const l = o[s], c = n[s];
        return l ? c ? jf(c, l) : l : c || Ua;
      }
      return n[s] || Ua;
    }
  };
}, oi = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const r = e[t], a = n.nextPart.get(r);
  if (a) {
    const c = oi(e, t + 1, a);
    if (c) return c;
  }
  const s = n.validators;
  if (s === null)
    return;
  const i = t === 0 ? e.join(Xn) : e.slice(t).join(Xn), l = s.length;
  for (let c = 0; c < l; c++) {
    const p = s[c];
    if (p.validator(i))
      return p.classGroupId;
  }
}, Zf = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), o = t.slice(0, n);
  return o ? qf + o : void 0;
})(), Qf = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return Jf(n, t);
}, Jf = (e, t) => {
  const n = ni();
  for (const o in e) {
    const r = e[o];
    zr(r, n, o, t);
  }
  return n;
}, zr = (e, t, n, o) => {
  const r = e.length;
  for (let a = 0; a < r; a++) {
    const s = e[a];
    ep(s, t, n, o);
  }
}, ep = (e, t, n, o) => {
  if (typeof e == "string") {
    tp(e, t, n);
    return;
  }
  if (typeof e == "function") {
    np(e, t, n, o);
    return;
  }
  op(e, t, n, o);
}, tp = (e, t, n) => {
  const o = e === "" ? t : ri(t, e);
  o.classGroupId = n;
}, np = (e, t, n, o) => {
  if (rp(e)) {
    zr(e(o), t, n, o);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(Kf(n, e));
}, op = (e, t, n, o) => {
  const r = Object.entries(e), a = r.length;
  for (let s = 0; s < a; s++) {
    const [i, l] = r[s];
    zr(l, ri(t, i), n, o);
  }
}, ri = (e, t) => {
  let n = e;
  const o = t.split(Xn), r = o.length;
  for (let a = 0; a < r; a++) {
    const s = o[a];
    let i = n.nextPart.get(s);
    i || (i = ni(), n.nextPart.set(s, i)), n = i;
  }
  return n;
}, rp = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, ap = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  const r = (a, s) => {
    n[a] = s, t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(a) {
      let s = n[a];
      if (s !== void 0)
        return s;
      if ((s = o[a]) !== void 0)
        return r(a, s), s;
    },
    set(a, s) {
      a in n ? n[a] = s : r(a, s);
    }
  };
}, yr = "!", ja = ":", sp = [], Ka = (e, t, n, o, r) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: o,
  isExternal: r
}), ip = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let o = (r) => {
    const a = [];
    let s = 0, i = 0, l = 0, c;
    const p = r.length;
    for (let g = 0; g < p; g++) {
      const v = r[g];
      if (s === 0 && i === 0) {
        if (v === ja) {
          a.push(r.slice(l, g)), l = g + 1;
          continue;
        }
        if (v === "/") {
          c = g;
          continue;
        }
      }
      v === "[" ? s++ : v === "]" ? s-- : v === "(" ? i++ : v === ")" && i--;
    }
    const f = a.length === 0 ? r : r.slice(l);
    let m = f, h = !1;
    f.endsWith(yr) ? (m = f.slice(0, -1), h = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      f.startsWith(yr) && (m = f.slice(1), h = !0)
    );
    const b = c && c > l ? c - l : void 0;
    return Ka(a, h, m, b);
  };
  if (t) {
    const r = t + ja, a = o;
    o = (s) => s.startsWith(r) ? a(s.slice(r.length)) : Ka(sp, !1, s, void 0, !0);
  }
  if (n) {
    const r = o;
    o = (a) => n({
      className: a,
      parseClassName: r
    });
  }
  return o;
}, lp = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, o) => {
    t.set(n, 1e6 + o);
  }), (n) => {
    const o = [];
    let r = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a], i = s[0] === "[", l = t.has(s);
      i || l ? (r.length > 0 && (r.sort(), o.push(...r), r = []), o.push(s)) : r.push(s);
    }
    return r.length > 0 && (r.sort(), o.push(...r)), o;
  };
}, cp = (e) => ({
  cache: ap(e.cacheSize),
  parseClassName: ip(e),
  sortModifiers: lp(e),
  ...Xf(e)
}), dp = /\s+/, up = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: o,
    getConflictingClassGroupIds: r,
    sortModifiers: a
  } = t, s = [], i = e.trim().split(dp);
  let l = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const p = i[c], {
      isExternal: f,
      modifiers: m,
      hasImportantModifier: h,
      baseClassName: b,
      maybePostfixModifierPosition: g
    } = n(p);
    if (f) {
      l = p + (l.length > 0 ? " " + l : l);
      continue;
    }
    let v = !!g, y = o(v ? b.substring(0, g) : b);
    if (!y) {
      if (!v) {
        l = p + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (y = o(b), !y) {
        l = p + (l.length > 0 ? " " + l : l);
        continue;
      }
      v = !1;
    }
    const w = m.length === 0 ? "" : m.length === 1 ? m[0] : a(m).join(":"), x = h ? w + yr : w, S = x + y;
    if (s.indexOf(S) > -1)
      continue;
    s.push(S);
    const k = r(y, v);
    for (let C = 0; C < k.length; ++C) {
      const P = k[C];
      s.push(x + P);
    }
    l = p + (l.length > 0 ? " " + l : l);
  }
  return l;
}, fp = (...e) => {
  let t = 0, n, o, r = "";
  for (; t < e.length; )
    (n = e[t++]) && (o = ai(n)) && (r && (r += " "), r += o);
  return r;
}, ai = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (t = ai(e[o])) && (n && (n += " "), n += t);
  return n;
}, pp = (e, ...t) => {
  let n, o, r, a;
  const s = (l) => {
    const c = t.reduce((p, f) => f(p), e());
    return n = cp(c), o = n.cache.get, r = n.cache.set, a = i, i(l);
  }, i = (l) => {
    const c = o(l);
    if (c)
      return c;
    const p = up(l, n);
    return r(l, p), p;
  };
  return a = s, (...l) => a(fp(...l));
}, mp = [], ge = (e) => {
  const t = (n) => n[e] || mp;
  return t.isThemeGetter = !0, t;
}, si = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, ii = /^\((?:(\w[\w-]*):)?(.+)\)$/i, hp = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, gp = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, vp = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, bp = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, yp = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, wp = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, st = (e) => hp.test(e), q = (e) => !!e && !Number.isNaN(Number(e)), it = (e) => !!e && Number.isInteger(Number(e)), Qo = (e) => e.endsWith("%") && q(e.slice(0, -1)), Qe = (e) => gp.test(e), li = () => !0, xp = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  vp.test(e) && !bp.test(e)
), $r = () => !1, Sp = (e) => yp.test(e), Cp = (e) => wp.test(e), kp = (e) => !$(e) && !B(e), Mp = (e) => ht(e, ui, $r), $ = (e) => si.test(e), kt = (e) => ht(e, fi, xp), qa = (e) => ht(e, Tp, q), Ep = (e) => ht(e, mi, li), Pp = (e) => ht(e, pi, $r), Xa = (e) => ht(e, ci, $r), Dp = (e) => ht(e, di, Cp), Wn = (e) => ht(e, hi, Sp), B = (e) => ii.test(e), sn = (e) => Nt(e, fi), _p = (e) => Nt(e, pi), Za = (e) => Nt(e, ci), Op = (e) => Nt(e, ui), Np = (e) => Nt(e, di), Fn = (e) => Nt(e, hi, !0), Rp = (e) => Nt(e, mi, !0), ht = (e, t, n) => {
  const o = si.exec(e);
  return o ? o[1] ? t(o[1]) : n(o[2]) : !1;
}, Nt = (e, t, n = !1) => {
  const o = ii.exec(e);
  return o ? o[1] ? t(o[1]) : n : !1;
}, ci = (e) => e === "position" || e === "percentage", di = (e) => e === "image" || e === "url", ui = (e) => e === "length" || e === "size" || e === "bg-size", fi = (e) => e === "length", Tp = (e) => e === "number", pi = (e) => e === "family-name", mi = (e) => e === "number" || e === "weight", hi = (e) => e === "shadow", Ap = () => {
  const e = ge("color"), t = ge("font"), n = ge("text"), o = ge("font-weight"), r = ge("tracking"), a = ge("leading"), s = ge("breakpoint"), i = ge("container"), l = ge("spacing"), c = ge("radius"), p = ge("shadow"), f = ge("inset-shadow"), m = ge("text-shadow"), h = ge("drop-shadow"), b = ge("blur"), g = ge("perspective"), v = ge("aspect"), y = ge("ease"), w = ge("animate"), x = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], S = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], k = () => [...S(), B, $], C = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", "contain", "none"], M = () => [B, $, l], _ = () => [st, "full", "auto", ...M()], O = () => [it, "none", "subgrid", B, $], A = () => ["auto", {
    span: ["full", it, B, $]
  }, it, B, $], Y = () => [it, "auto", B, $], G = () => ["auto", "min", "max", "fr", B, $], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], j = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], F = () => ["auto", ...M()], V = () => [st, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...M()], L = () => [st, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...M()], R = () => [st, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...M()], T = () => [e, B, $], le = () => [...S(), Za, Xa, {
    position: [B, $]
  }], ye = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Ce = () => ["auto", "cover", "contain", Op, Mp, {
    size: [B, $]
  }], me = () => [Qo, sn, kt], ae = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    B,
    $
  ], te = () => ["", q, sn, kt], I = () => ["solid", "dashed", "dotted", "double"], se = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Z = () => [q, Qo, Za, Xa], ee = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    B,
    $
  ], oe = () => ["none", q, B, $], de = () => ["none", q, B, $], we = () => [q, B, $], Pe = () => [st, "full", ...M()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Qe],
      breakpoint: [Qe],
      color: [li],
      container: [Qe],
      "drop-shadow": [Qe],
      ease: ["in", "out", "in-out"],
      font: [kp],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Qe],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Qe],
      shadow: [Qe],
      spacing: ["px", q],
      text: [Qe],
      "text-shadow": [Qe],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", st, $, B, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [q, $, B, i]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": x()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": x()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: k()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: _()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": _()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": _()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": _(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: _()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": _(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: _()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": _()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": _()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: _()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: _()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: _()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: _()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [it, "auto", B, $]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [st, "full", "auto", i, ...M()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [q, st, "auto", "initial", "none", $]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", q, B, $]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", q, B, $]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [it, "first", "last", "none", B, $]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": O()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: A()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Y()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Y()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": O()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: A()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Y()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Y()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": G()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": G()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: M()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": M()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": M()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...H(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...j(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...j()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...j(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...j(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": H()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...j(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...j()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: M()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: M()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: M()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: M()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: M()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: M()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: M()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: M()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: M()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: M()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: M()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: F()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: F()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: F()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: F()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: F()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: F()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: F()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: F()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: F()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: F()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: F()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": M()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": M()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: V()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...L()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...L()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...L()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...R()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...R()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...R()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [i, "screen", ...V()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          i,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...V()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          i,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [s]
          },
          ...V()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...V()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...V()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...V()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, sn, kt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, Rp, Ep]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Qo, $]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [_p, Pp, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [$]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [r, B, $]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [q, "none", B, qa]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...M()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", B, $]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", B, $]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: T()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: T()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...I(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [q, "from-font", "auto", B, kt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: T()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [q, "auto", B, $]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", B, $]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", B, $]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: le()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ye()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Ce()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, it, B, $],
          radial: ["", B, $],
          conic: [it, B, $]
        }, Np, Dp]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: T()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: me()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: me()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: me()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: T()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: T()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: T()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ae()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ae()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ae()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ae()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ae()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ae()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ae()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ae()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ae()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ae()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ae()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ae()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ae()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ae()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ae()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: te()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": te()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": te()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": te()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": te()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": te()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": te()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": te()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": te()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": te()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": te()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": te()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": te()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...I(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...I(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: T()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": T()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": T()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": T()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": T()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": T()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": T()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": T()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": T()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": T()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": T()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: T()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...I(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [q, B, $]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", q, sn, kt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: T()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          Fn,
          Wn
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: T()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", f, Fn, Wn]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": T()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: te()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: T()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [q, kt]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": T()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": te()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": T()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, Fn, Wn]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": T()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [q, B, $]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...se(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": se()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [q]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": Z()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": Z()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": T()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": T()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": Z()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": Z()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": T()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": T()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": Z()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": Z()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": T()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": T()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": Z()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": Z()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": T()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": T()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": Z()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": Z()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": T()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": T()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": Z()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": Z()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": T()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": T()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": Z()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": Z()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": T()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": T()
      }],
      "mask-image-radial": [{
        "mask-radial": [B, $]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": Z()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": Z()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": T()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": T()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": S()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [q]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": Z()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": Z()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": T()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": T()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: le()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ye()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Ce()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", B, $]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          B,
          $
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: ee()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [q, B, $]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [q, B, $]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          Fn,
          Wn
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": T()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", q, B, $]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [q, B, $]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", q, B, $]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [q, B, $]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", q, B, $]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          B,
          $
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": ee()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [q, B, $]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [q, B, $]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", q, B, $]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [q, B, $]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", q, B, $]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [q, B, $]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [q, B, $]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", q, B, $]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": M()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": M()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": M()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", B, $]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [q, "initial", B, $]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", y, B, $]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [q, B, $]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", w, B, $]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, B, $]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": k()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: oe()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": oe()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": oe()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": oe()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: de()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": de()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": de()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": de()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: we()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": we()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": we()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [B, $, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: k()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Pe()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Pe()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Pe()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Pe()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: T()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: T()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", B, $]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": M()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": M()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", B, $]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...T()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [q, sn, kt, qa]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...T()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Ip = /* @__PURE__ */ pp(Ap);
function E(...e) {
  return Ip(ti(e));
}
const Qa = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ja = ti, Xt = (e, t) => (n) => {
  var o;
  if (t?.variants == null) return Ja(e, n?.class, n?.className);
  const { variants: r, defaultVariants: a } = t, s = Object.keys(r).map((c) => {
    const p = n?.[c], f = a?.[c];
    if (p === null) return null;
    const m = Qa(p) || Qa(f);
    return r[c][m];
  }), i = n && Object.entries(n).reduce((c, p) => {
    let [f, m] = p;
    return m === void 0 || (c[f] = m), c;
  }, {}), l = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((c, p) => {
    let { class: f, className: m, ...h } = p;
    return Object.entries(h).every((b) => {
      let [g, v] = b;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...i
      }[g]) : {
        ...a,
        ...i
      }[g] === v;
    }) ? [
      ...c,
      f,
      m
    ] : c;
  }, []);
  return Ja(e, s, l, n?.class, n?.className);
};
function es(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function po(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const a = es(r, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const a = o[r];
          typeof a == "function" ? a() : es(e[r], null);
        }
      };
  };
}
function U(...e) {
  return d.useCallback(po(...e), e);
}
// @__NO_SIDE_EFFECTS__
function ft(e) {
  const t = /* @__PURE__ */ Wp(e), n = d.forwardRef((o, r) => {
    const { children: a, ...s } = o, i = d.Children.toArray(a), l = i.find(Fp);
    if (l) {
      const c = l.props.children, p = i.map((f) => f === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ u(t, { ...s, ref: r, children: d.isValidElement(c) ? d.cloneElement(c, void 0, p) : null });
    }
    return /* @__PURE__ */ u(t, { ...s, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var gi = /* @__PURE__ */ ft("Slot");
// @__NO_SIDE_EFFECTS__
function Wp(e) {
  const t = d.forwardRef((n, o) => {
    const { children: r, ...a } = n;
    if (d.isValidElement(r)) {
      const s = zp(r), i = Lp(a, r.props);
      return r.type !== d.Fragment && (i.ref = o ? po(o, s) : s), d.cloneElement(r, i);
    }
    return d.Children.count(r) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var vi = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function bi(e) {
  const t = ({ children: n }) => /* @__PURE__ */ u(ut, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = vi, t;
}
function Fp(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === vi;
}
function Lp(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...i) => {
      const l = a(...i);
      return r(...i), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function zp(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $p = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], z = $p.reduce((e, t) => {
  const n = /* @__PURE__ */ ft(`Primitive.${t}`), o = d.forwardRef((r, a) => {
    const { asChild: s, ...i } = r, l = s ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(l, { ...i, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function yi(e, t) {
  e && fo.flushSync(() => e.dispatchEvent(t));
}
var wi = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Bp = "VisuallyHidden", xi = d.forwardRef(
  (e, t) => /* @__PURE__ */ u(
    z.span,
    {
      ...e,
      ref: t,
      style: { ...wi, ...e.style }
    }
  )
);
xi.displayName = Bp;
var Yp = xi;
function Hp(e, t) {
  const n = d.createContext(t), o = (a) => {
    const { children: s, ...i } = a, l = d.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ u(n.Provider, { value: l, children: s });
  };
  o.displayName = e + "Provider";
  function r(a) {
    const s = d.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function be(e, t = []) {
  let n = [];
  function o(a, s) {
    const i = d.createContext(s), l = n.length;
    n = [...n, s];
    const c = (f) => {
      const { scope: m, children: h, ...b } = f, g = m?.[e]?.[l] || i, v = d.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ u(g.Provider, { value: v, children: h });
    };
    c.displayName = a + "Provider";
    function p(f, m) {
      const h = m?.[e]?.[l] || i, b = d.useContext(h);
      if (b) return b;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [c, p];
  }
  const r = () => {
    const a = n.map((s) => d.createContext(s));
    return function(i) {
      const l = i?.[e] || a;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return r.scopeName = e, [o, Gp(r, ...t)];
}
function Gp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const s = o.reduce((i, { useScope: l, scopeName: c }) => {
        const f = l(a)[`__scope${c}`];
        return { ...i, ...f };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Sn(e) {
  const t = e + "CollectionProvider", [n, o] = be(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: y } = g, w = D.useRef(null), x = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u(r, { scope: v, itemMap: x, collectionRef: w, children: y });
  };
  s.displayName = t;
  const i = e + "CollectionSlot", l = /* @__PURE__ */ ft(i), c = D.forwardRef(
    (g, v) => {
      const { scope: y, children: w } = g, x = a(i, y), S = U(v, x.collectionRef);
      return /* @__PURE__ */ u(l, { ref: S, children: w });
    }
  );
  c.displayName = i;
  const p = e + "CollectionItemSlot", f = "data-radix-collection-item", m = /* @__PURE__ */ ft(p), h = D.forwardRef(
    (g, v) => {
      const { scope: y, children: w, ...x } = g, S = D.useRef(null), k = U(v, S), C = a(p, y);
      return D.useEffect(() => (C.itemMap.set(S, { ref: S, ...x }), () => {
        C.itemMap.delete(S);
      })), /* @__PURE__ */ u(m, { [f]: "", ref: k, children: w });
    }
  );
  h.displayName = p;
  function b(g) {
    const v = a(e + "CollectionConsumer", g);
    return D.useCallback(() => {
      const w = v.collectionRef.current;
      if (!w) return [];
      const x = Array.from(w.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (C, P) => x.indexOf(C.ref.current) - x.indexOf(P.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: h },
    b,
    o
  ];
}
function N(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e?.(r), n === !1 || !r.defaultPrevented)
      return t?.(r);
  };
}
var pe = globalThis?.document ? d.useLayoutEffect : () => {
}, Vp = d[" useInsertionEffect ".trim().toString()] || pe;
function Se({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, a, s] = Up({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : r;
  {
    const p = d.useRef(e !== void 0);
    d.useEffect(() => {
      const f = p.current;
      f !== i && console.warn(
        `${o} is changing from ${f ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), p.current = i;
    }, [i, o]);
  }
  const c = d.useCallback(
    (p) => {
      if (i) {
        const f = jp(p) ? p(e) : p;
        f !== e && s.current?.(f);
      } else
        a(p);
    },
    [i, e, a, s]
  );
  return [l, c];
}
function Up({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = d.useState(e), r = d.useRef(n), a = d.useRef(t);
  return Vp(() => {
    a.current = t;
  }, [t]), d.useEffect(() => {
    r.current !== n && (a.current?.(n), r.current = n);
  }, [n, r]), [n, o, a];
}
function jp(e) {
  return typeof e == "function";
}
function Kp(e, t) {
  return d.useReducer((n, o) => t[n][o] ?? n, e);
}
var xe = (e) => {
  const { present: t, children: n } = e, o = qp(t), r = typeof n == "function" ? n({ present: o.isPresent }) : d.Children.only(n), a = U(o.ref, Xp(r));
  return typeof n == "function" || o.isPresent ? d.cloneElement(r, { ref: a }) : null;
};
xe.displayName = "Presence";
function qp(e) {
  const [t, n] = d.useState(), o = d.useRef(null), r = d.useRef(e), a = d.useRef("none"), s = e ? "mounted" : "unmounted", [i, l] = Kp(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const c = Ln(o.current);
    a.current = i === "mounted" ? c : "none";
  }, [i]), pe(() => {
    const c = o.current, p = r.current;
    if (p !== e) {
      const m = a.current, h = Ln(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(p && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), pe(() => {
    if (t) {
      let c;
      const p = t.ownerDocument.defaultView ?? window, f = (h) => {
        const g = Ln(o.current).includes(CSS.escape(h.animationName));
        if (h.target === t && g && (l("ANIMATION_END"), !r.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, m = (h) => {
        h.target === t && (a.current = Ln(o.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        p.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: d.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Ln(e) {
  return e?.animationName || "none";
}
function Xp(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Zp = d[" useId ".trim().toString()] || (() => {
}), Qp = 0;
function Ee(e) {
  const [t, n] = d.useState(Zp());
  return pe(() => {
    n((o) => o ?? String(Qp++));
  }, [e]), t ? `radix-${t}` : "";
}
var mo = "Collapsible", [Jp, Si] = be(mo), [em, Br] = Jp(mo), Ci = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: o,
      defaultOpen: r,
      disabled: a,
      onOpenChange: s,
      ...i
    } = e, [l, c] = Se({
      prop: o,
      defaultProp: r ?? !1,
      onChange: s,
      caller: mo
    });
    return /* @__PURE__ */ u(
      em,
      {
        scope: n,
        disabled: a,
        contentId: Ee(),
        open: l,
        onOpenToggle: d.useCallback(() => c((p) => !p), [c]),
        children: /* @__PURE__ */ u(
          z.div,
          {
            "data-state": Vr(l),
            "data-disabled": a ? "" : void 0,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
Ci.displayName = mo;
var ki = "CollapsibleTrigger", Yr = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...o } = e, r = Br(ki, n);
    return /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": Vr(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...o,
        ref: t,
        onClick: N(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Yr.displayName = ki;
var Hr = "CollapsibleContent", Gr = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Br(Hr, e.__scopeCollapsible);
    return /* @__PURE__ */ u(xe, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ u(tm, { ...o, ref: t, present: a }) });
  }
);
Gr.displayName = Hr;
var tm = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...a } = e, s = Br(Hr, n), [i, l] = d.useState(o), c = d.useRef(null), p = U(t, c), f = d.useRef(0), m = f.current, h = d.useRef(0), b = h.current, g = s.open || i, v = d.useRef(g), y = d.useRef(void 0);
  return d.useEffect(() => {
    const w = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), pe(() => {
    const w = c.current;
    if (w) {
      y.current = y.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const x = w.getBoundingClientRect();
      f.current = x.height, h.current = x.width, v.current || (w.style.transitionDuration = y.current.transitionDuration, w.style.animationName = y.current.animationName), l(o);
    }
  }, [s.open, o]), /* @__PURE__ */ u(
    z.div,
    {
      "data-state": Vr(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !g,
      ...a,
      ref: p,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": b ? `${b}px` : void 0,
        ...e.style
      },
      children: g && r
    }
  );
});
function Vr(e) {
  return e ? "open" : "closed";
}
var Mi = Ci, nm = Yr, om = Gr, rm = d.createContext(void 0);
function Rt(e) {
  const t = d.useContext(rm);
  return e || t || "ltr";
}
var Be = "Accordion", am = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Ur, sm, im] = Sn(Be), [ho] = be(Be, [
  im,
  Si
]), jr = Si(), Ei = D.forwardRef(
  (e, t) => {
    const { type: n, ...o } = e, r = o, a = o;
    return /* @__PURE__ */ u(Ur.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ u(um, { ...a, ref: t }) : /* @__PURE__ */ u(dm, { ...r, ref: t }) });
  }
);
Ei.displayName = Be;
var [Pi, lm] = ho(Be), [Di, cm] = ho(
  Be,
  { collapsible: !1 }
), dm = D.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: o,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...s
    } = e, [i, l] = Se({
      prop: n,
      defaultProp: o ?? "",
      onChange: r,
      caller: Be
    });
    return /* @__PURE__ */ u(
      Pi,
      {
        scope: e.__scopeAccordion,
        value: D.useMemo(() => i ? [i] : [], [i]),
        onItemOpen: l,
        onItemClose: D.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ u(Di, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ u(_i, { ...s, ref: t }) })
      }
    );
  }
), um = D.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [s, i] = Se({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: Be
  }), l = D.useCallback(
    (p) => i((f = []) => [...f, p]),
    [i]
  ), c = D.useCallback(
    (p) => i((f = []) => f.filter((m) => m !== p)),
    [i]
  );
  return /* @__PURE__ */ u(
    Pi,
    {
      scope: e.__scopeAccordion,
      value: s,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ u(Di, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ u(_i, { ...a, ref: t }) })
    }
  );
}), [fm, go] = ho(Be), _i = D.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: o, dir: r, orientation: a = "vertical", ...s } = e, i = D.useRef(null), l = U(i, t), c = sm(n), f = Rt(r) === "ltr", m = N(e.onKeyDown, (h) => {
      if (!am.includes(h.key)) return;
      const b = h.target, g = c().filter((M) => !M.ref.current?.disabled), v = g.findIndex((M) => M.ref.current === b), y = g.length;
      if (v === -1) return;
      h.preventDefault();
      let w = v;
      const x = 0, S = y - 1, k = () => {
        w = v + 1, w > S && (w = x);
      }, C = () => {
        w = v - 1, w < x && (w = S);
      };
      switch (h.key) {
        case "Home":
          w = x;
          break;
        case "End":
          w = S;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? k() : C());
          break;
        case "ArrowDown":
          a === "vertical" && k();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? C() : k());
          break;
        case "ArrowUp":
          a === "vertical" && C();
          break;
      }
      const P = w % y;
      g[P].ref.current?.focus();
    });
    return /* @__PURE__ */ u(
      fm,
      {
        scope: n,
        disabled: o,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ u(Ur.Slot, { scope: n, children: /* @__PURE__ */ u(
          z.div,
          {
            ...s,
            "data-orientation": a,
            ref: l,
            onKeyDown: o ? void 0 : m
          }
        ) })
      }
    );
  }
), Zn = "AccordionItem", [pm, Kr] = ho(Zn), Oi = D.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: o, ...r } = e, a = go(Zn, n), s = lm(Zn, n), i = jr(n), l = Ee(), c = o && s.value.includes(o) || !1, p = a.disabled || e.disabled;
    return /* @__PURE__ */ u(
      pm,
      {
        scope: n,
        open: c,
        disabled: p,
        triggerId: l,
        children: /* @__PURE__ */ u(
          Mi,
          {
            "data-orientation": a.orientation,
            "data-state": Wi(c),
            ...i,
            ...r,
            ref: t,
            disabled: p,
            open: c,
            onOpenChange: (f) => {
              f ? s.onItemOpen(o) : s.onItemClose(o);
            }
          }
        )
      }
    );
  }
);
Oi.displayName = Zn;
var Ni = "AccordionHeader", Ri = D.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = go(Be, n), a = Kr(Ni, n);
    return /* @__PURE__ */ u(
      z.h3,
      {
        "data-orientation": r.orientation,
        "data-state": Wi(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Ri.displayName = Ni;
var wr = "AccordionTrigger", Ti = D.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = go(Be, n), a = Kr(wr, n), s = cm(wr, n), i = jr(n);
    return /* @__PURE__ */ u(Ur.ItemSlot, { scope: n, children: /* @__PURE__ */ u(
      nm,
      {
        "aria-disabled": a.open && !s.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...i,
        ...o,
        ref: t
      }
    ) });
  }
);
Ti.displayName = wr;
var Ai = "AccordionContent", Ii = D.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = go(Be, n), a = Kr(Ai, n), s = jr(n);
    return /* @__PURE__ */ u(
      om,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...s,
        ...o,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Ii.displayName = Ai;
function Wi(e) {
  return e ? "open" : "closed";
}
var mm = Ei, hm = Oi, gm = Ri, vm = Ti, bm = Ii;
function ve(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => t.current?.(...n), []);
}
function ym(e, t = globalThis?.document) {
  const n = ve(e);
  d.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var wm = "DismissableLayer", xr = "dismissableLayer.update", xm = "dismissableLayer.pointerDownOutside", Sm = "dismissableLayer.focusOutside", ts, Fi = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zt = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...l
    } = e, c = d.useContext(Fi), [p, f] = d.useState(null), m = p?.ownerDocument ?? globalThis?.document, [, h] = d.useState({}), b = U(t, (P) => f(P)), g = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(v), w = p ? g.indexOf(p) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, S = w >= y, k = Mm((P) => {
      const M = P.target, _ = [...c.branches].some((O) => O.contains(M));
      !S || _ || (r?.(P), s?.(P), P.defaultPrevented || i?.());
    }, m), C = Em((P) => {
      const M = P.target;
      [...c.branches].some((O) => O.contains(M)) || (a?.(P), s?.(P), P.defaultPrevented || i?.());
    }, m);
    return ym((P) => {
      w === c.layers.size - 1 && (o?.(P), !P.defaultPrevented && i && (P.preventDefault(), i()));
    }, m), d.useEffect(() => {
      if (p)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (ts = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(p)), c.layers.add(p), ns(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = ts);
        };
    }, [p, m, n, c]), d.useEffect(() => () => {
      p && (c.layers.delete(p), c.layersWithOutsidePointerEventsDisabled.delete(p), ns());
    }, [p, c]), d.useEffect(() => {
      const P = () => h({});
      return document.addEventListener(xr, P), () => document.removeEventListener(xr, P);
    }, []), /* @__PURE__ */ u(
      z.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: x ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: N(e.onFocusCapture, C.onFocusCapture),
        onBlurCapture: N(e.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: N(
          e.onPointerDownCapture,
          k.onPointerDownCapture
        )
      }
    );
  }
);
Zt.displayName = wm;
var Cm = "DismissableLayerBranch", km = d.forwardRef((e, t) => {
  const n = d.useContext(Fi), o = d.useRef(null), r = U(t, o);
  return d.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ u(z.div, { ...e, ref: r });
});
km.displayName = Cm;
function Mm(e, t = globalThis?.document) {
  const n = ve(e), o = d.useRef(!1), r = d.useRef(() => {
  });
  return d.useEffect(() => {
    const a = (i) => {
      if (i.target && !o.current) {
        let l = function() {
          Li(
            xm,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Em(e, t = globalThis?.document) {
  const n = ve(e), o = d.useRef(!1);
  return d.useEffect(() => {
    const r = (a) => {
      a.target && !o.current && Li(Sm, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function ns() {
  const e = new CustomEvent(xr);
  document.dispatchEvent(e);
}
function Li(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? yi(r, a) : r.dispatchEvent(a);
}
var Jo = "focusScope.autoFocusOnMount", er = "focusScope.autoFocusOnUnmount", os = { bubbles: !1, cancelable: !0 }, Pm = "FocusScope", Cn = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...s
  } = e, [i, l] = d.useState(null), c = ve(r), p = ve(a), f = d.useRef(null), m = U(t, (g) => l(g)), h = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (o) {
      let g = function(x) {
        if (h.paused || !i) return;
        const S = x.target;
        i.contains(S) ? f.current = S : ct(f.current, { select: !0 });
      }, v = function(x) {
        if (h.paused || !i) return;
        const S = x.relatedTarget;
        S !== null && (i.contains(S) || ct(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const k of x)
            k.removedNodes.length > 0 && ct(i);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const w = new MutationObserver(y);
      return i && w.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), w.disconnect();
      };
    }
  }, [o, i, h.paused]), d.useEffect(() => {
    if (i) {
      as.add(h);
      const g = document.activeElement;
      if (!i.contains(g)) {
        const y = new CustomEvent(Jo, os);
        i.addEventListener(Jo, c), i.dispatchEvent(y), y.defaultPrevented || (Dm(Tm(zi(i)), { select: !0 }), document.activeElement === g && ct(i));
      }
      return () => {
        i.removeEventListener(Jo, c), setTimeout(() => {
          const y = new CustomEvent(er, os);
          i.addEventListener(er, p), i.dispatchEvent(y), y.defaultPrevented || ct(g ?? document.body, { select: !0 }), i.removeEventListener(er, p), as.remove(h);
        }, 0);
      };
    }
  }, [i, c, p, h]);
  const b = d.useCallback(
    (g) => {
      if (!n && !o || h.paused) return;
      const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (v && y) {
        const w = g.currentTarget, [x, S] = _m(w);
        x && S ? !g.shiftKey && y === S ? (g.preventDefault(), n && ct(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), n && ct(S, { select: !0 })) : y === w && g.preventDefault();
      }
    },
    [n, o, h.paused]
  );
  return /* @__PURE__ */ u(z.div, { tabIndex: -1, ...s, ref: m, onKeyDown: b });
});
Cn.displayName = Pm;
function Dm(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (ct(o, { select: t }), document.activeElement !== n) return;
}
function _m(e) {
  const t = zi(e), n = rs(t, e), o = rs(t.reverse(), e);
  return [n, o];
}
function zi(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function rs(e, t) {
  for (const n of e)
    if (!Om(n, { upTo: t })) return n;
}
function Om(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Nm(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ct(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Nm(e) && t && e.select();
  }
}
var as = Rm();
function Rm() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = ss(e, t), e.unshift(t);
    },
    remove(t) {
      e = ss(e, t), e[0]?.resume();
    }
  };
}
function ss(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Tm(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Am = "Portal", Qt = d.forwardRef((e, t) => {
  const { container: n, ...o } = e, [r, a] = d.useState(!1);
  pe(() => a(!0), []);
  const s = n || r && globalThis?.document?.body;
  return s ? Uf.createPortal(/* @__PURE__ */ u(z.div, { ...o, ref: t }), s) : null;
});
Qt.displayName = Am;
var tr = 0;
function vo() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? is()), document.body.insertAdjacentElement("beforeend", e[1] ?? is()), tr++, () => {
      tr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), tr--;
    };
  }, []);
}
function is() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ve = function() {
  return Ve = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Ve.apply(this, arguments);
};
function $i(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function Im(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, a; o < r; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Un = "right-scroll-bar-position", jn = "width-before-scroll-bar", Wm = "with-scroll-bars-hidden", Fm = "--removed-body-scroll-bar-size";
function nr(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Lm(e, t) {
  var n = qn(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var zm = typeof window < "u" ? d.useLayoutEffect : d.useEffect, ls = /* @__PURE__ */ new WeakMap();
function $m(e, t) {
  var n = Lm(null, function(o) {
    return e.forEach(function(r) {
      return nr(r, o);
    });
  });
  return zm(function() {
    var o = ls.get(n);
    if (o) {
      var r = new Set(o), a = new Set(e), s = n.current;
      r.forEach(function(i) {
        a.has(i) || nr(i, null);
      }), a.forEach(function(i) {
        r.has(i) || nr(i, s);
      });
    }
    ls.set(n, e);
  }, [e]), n;
}
function Bm(e) {
  return e;
}
function Ym(e, t) {
  t === void 0 && (t = Bm);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, o);
      return n.push(s), function() {
        n = n.filter(function(i) {
          return i !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (o = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      o = !0;
      var s = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(a), s = n;
      }
      var l = function() {
        var p = s;
        s = [], p.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(p) {
          s.push(p), c();
        },
        filter: function(p) {
          return s = s.filter(p), n;
        }
      };
    }
  };
  return r;
}
function Hm(e) {
  e === void 0 && (e = {});
  var t = Ym(null);
  return t.options = Ve({ async: !0, ssr: !1 }, e), t;
}
var Bi = function(e) {
  var t = e.sideCar, n = $i(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return d.createElement(o, Ve({}, n));
};
Bi.isSideCarExport = !0;
function Gm(e, t) {
  return e.useMedium(t), Bi;
}
var Yi = Hm(), or = function() {
}, bo = d.forwardRef(function(e, t) {
  var n = d.useRef(null), o = d.useState({
    onScrollCapture: or,
    onWheelCapture: or,
    onTouchMoveCapture: or
  }), r = o[0], a = o[1], s = e.forwardProps, i = e.children, l = e.className, c = e.removeScrollBar, p = e.enabled, f = e.shards, m = e.sideCar, h = e.noRelative, b = e.noIsolation, g = e.inert, v = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, x = e.gapMode, S = $i(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = m, C = $m([n, t]), P = Ve(Ve({}, S), r);
  return d.createElement(
    d.Fragment,
    null,
    p && d.createElement(k, { sideCar: Yi, removeScrollBar: c, shards: f, noRelative: h, noIsolation: b, inert: g, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: x }),
    s ? d.cloneElement(d.Children.only(i), Ve(Ve({}, P), { ref: C })) : d.createElement(w, Ve({}, P, { className: l, ref: C }), i)
  );
});
bo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
bo.classNames = {
  fullWidth: jn,
  zeroRight: Un
};
var Vm = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Um() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Vm();
  return t && e.setAttribute("nonce", t), e;
}
function jm(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Km(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var qm = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Um()) && (jm(t, n), Km(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Xm = function() {
  var e = qm();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Hi = function() {
  var e = Xm(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, Zm = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, rr = function(e) {
  return parseInt(e || "", 10) || 0;
}, Qm = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [rr(n), rr(o), rr(r)];
}, Jm = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Zm;
  var t = Qm(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, eh = Hi(), Yt = "data-scroll-locked", th = function(e, t, n, o) {
  var r = e.left, a = e.top, s = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Wm, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(i, "px ").concat(o, `;
  }
  body[`).concat(Yt, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Un, ` {
    right: `).concat(i, "px ").concat(o, `;
  }
  
  .`).concat(jn, ` {
    margin-right: `).concat(i, "px ").concat(o, `;
  }
  
  .`).concat(Un, " .").concat(Un, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(jn, " .").concat(jn, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Yt, `] {
    `).concat(Fm, ": ").concat(i, `px;
  }
`);
}, cs = function() {
  var e = parseInt(document.body.getAttribute(Yt) || "0", 10);
  return isFinite(e) ? e : 0;
}, nh = function() {
  d.useEffect(function() {
    return document.body.setAttribute(Yt, (cs() + 1).toString()), function() {
      var e = cs() - 1;
      e <= 0 ? document.body.removeAttribute(Yt) : document.body.setAttribute(Yt, e.toString());
    };
  }, []);
}, oh = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  nh();
  var a = d.useMemo(function() {
    return Jm(r);
  }, [r]);
  return d.createElement(eh, { styles: th(a, !t, r, n ? "" : "!important") });
}, Sr = !1;
if (typeof window < "u")
  try {
    var zn = Object.defineProperty({}, "passive", {
      get: function() {
        return Sr = !0, !0;
      }
    });
    window.addEventListener("test", zn, zn), window.removeEventListener("test", zn, zn);
  } catch {
    Sr = !1;
  }
var Wt = Sr ? { passive: !1 } : !1, rh = function(e) {
  return e.tagName === "TEXTAREA";
}, Gi = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !rh(e) && n[t] === "visible")
  );
}, ah = function(e) {
  return Gi(e, "overflowY");
}, sh = function(e) {
  return Gi(e, "overflowX");
}, ds = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = Vi(e, o);
    if (r) {
      var a = Ui(e, o), s = a[1], i = a[2];
      if (s > i)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, ih = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, lh = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Vi = function(e, t) {
  return e === "v" ? ah(t) : sh(t);
}, Ui = function(e, t) {
  return e === "v" ? ih(t) : lh(t);
}, ch = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, dh = function(e, t, n, o, r) {
  var a = ch(e, window.getComputedStyle(t).direction), s = a * o, i = n.target, l = t.contains(i), c = !1, p = s > 0, f = 0, m = 0;
  do {
    if (!i)
      break;
    var h = Ui(e, i), b = h[0], g = h[1], v = h[2], y = g - v - a * b;
    (b || y) && Vi(e, i) && (f += y, m += b);
    var w = i.parentNode;
    i = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !l && i !== document.body || // self content
    l && (t.contains(i) || t === i)
  );
  return (p && Math.abs(f) < 1 || !p && Math.abs(m) < 1) && (c = !0), c;
}, $n = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, us = function(e) {
  return [e.deltaX, e.deltaY];
}, fs = function(e) {
  return e && "current" in e ? e.current : e;
}, uh = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, fh = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ph = 0, Ft = [];
function mh(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), o = d.useRef(), r = d.useState(ph++)[0], a = d.useState(Hi)[0], s = d.useRef(e);
  d.useEffect(function() {
    s.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var g = Im([e.lockRef.current], (e.shards || []).map(fs), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = d.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = $n(g), w = n.current, x = "deltaX" in g ? g.deltaX : w[0] - y[0], S = "deltaY" in g ? g.deltaY : w[1] - y[1], k, C = g.target, P = Math.abs(x) > Math.abs(S) ? "h" : "v";
    if ("touches" in g && P === "h" && C.type === "range")
      return !1;
    var M = window.getSelection(), _ = M && M.anchorNode, O = _ ? _ === C || _.contains(C) : !1;
    if (O)
      return !1;
    var A = ds(P, C);
    if (!A)
      return !0;
    if (A ? k = P : (k = P === "v" ? "h" : "v", A = ds(P, C)), !A)
      return !1;
    if (!o.current && "changedTouches" in g && (x || S) && (o.current = k), !k)
      return !0;
    var Y = o.current || k;
    return dh(Y, v, g, Y === "h" ? x : S);
  }, []), l = d.useCallback(function(g) {
    var v = g;
    if (!(!Ft.length || Ft[Ft.length - 1] !== a)) {
      var y = "deltaY" in v ? us(v) : $n(v), w = t.current.filter(function(k) {
        return k.name === v.type && (k.target === v.target || v.target === k.shadowParent) && uh(k.delta, y);
      })[0];
      if (w && w.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!w) {
        var x = (s.current.shards || []).map(fs).filter(Boolean).filter(function(k) {
          return k.contains(v.target);
        }), S = x.length > 0 ? i(v, x[0]) : !s.current.noIsolation;
        S && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = d.useCallback(function(g, v, y, w) {
    var x = { name: g, delta: v, target: y, should: w, shadowParent: hh(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== x;
      });
    }, 1);
  }, []), p = d.useCallback(function(g) {
    n.current = $n(g), o.current = void 0;
  }, []), f = d.useCallback(function(g) {
    c(g.type, us(g), g.target, i(g, e.lockRef.current));
  }, []), m = d.useCallback(function(g) {
    c(g.type, $n(g), g.target, i(g, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Ft.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, Wt), document.addEventListener("touchmove", l, Wt), document.addEventListener("touchstart", p, Wt), function() {
      Ft = Ft.filter(function(g) {
        return g !== a;
      }), document.removeEventListener("wheel", l, Wt), document.removeEventListener("touchmove", l, Wt), document.removeEventListener("touchstart", p, Wt);
    };
  }, []);
  var h = e.removeScrollBar, b = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    b ? d.createElement(a, { styles: fh(r) }) : null,
    h ? d.createElement(oh, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function hh(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const gh = Gm(Yi, mh);
var kn = d.forwardRef(function(e, t) {
  return d.createElement(bo, Ve({}, e, { ref: t, sideCar: gh }));
});
kn.classNames = bo.classNames;
var vh = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Lt = /* @__PURE__ */ new WeakMap(), Bn = /* @__PURE__ */ new WeakMap(), Yn = {}, ar = 0, ji = function(e) {
  return e && (e.host || ji(e.parentNode));
}, bh = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = ji(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, yh = function(e, t, n, o) {
  var r = bh(t, Array.isArray(e) ? e : [e]);
  Yn[n] || (Yn[n] = /* @__PURE__ */ new WeakMap());
  var a = Yn[n], s = [], i = /* @__PURE__ */ new Set(), l = new Set(r), c = function(f) {
    !f || i.has(f) || (i.add(f), c(f.parentNode));
  };
  r.forEach(c);
  var p = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(m) {
      if (i.has(m))
        p(m);
      else
        try {
          var h = m.getAttribute(o), b = h !== null && h !== "false", g = (Lt.get(m) || 0) + 1, v = (a.get(m) || 0) + 1;
          Lt.set(m, g), a.set(m, v), s.push(m), g === 1 && b && Bn.set(m, !0), v === 1 && m.setAttribute(n, "true"), b || m.setAttribute(o, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", m, y);
        }
    });
  };
  return p(t), i.clear(), ar++, function() {
    s.forEach(function(f) {
      var m = Lt.get(f) - 1, h = a.get(f) - 1;
      Lt.set(f, m), a.set(f, h), m || (Bn.has(f) || f.removeAttribute(o), Bn.delete(f)), h || f.removeAttribute(n);
    }), ar--, ar || (Lt = /* @__PURE__ */ new WeakMap(), Lt = /* @__PURE__ */ new WeakMap(), Bn = /* @__PURE__ */ new WeakMap(), Yn = {});
  };
}, yo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = vh(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), yh(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, wo = "Dialog", [Ki, qi] = be(wo), [wh, Ye] = Ki(wo), Xi = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: s = !0
  } = e, i = d.useRef(null), l = d.useRef(null), [c, p] = Se({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: wo
  });
  return /* @__PURE__ */ u(
    wh,
    {
      scope: t,
      triggerRef: i,
      contentRef: l,
      contentId: Ee(),
      titleId: Ee(),
      descriptionId: Ee(),
      open: c,
      onOpenChange: p,
      onOpenToggle: d.useCallback(() => p((f) => !f), [p]),
      modal: s,
      children: n
    }
  );
};
Xi.displayName = wo;
var Zi = "DialogTrigger", Qi = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Ye(Zi, n), a = U(t, r.triggerRef);
    return /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Zr(r.open),
        ...o,
        ref: a,
        onClick: N(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Qi.displayName = Zi;
var qr = "DialogPortal", [xh, Ji] = Ki(qr, {
  forceMount: void 0
}), el = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, a = Ye(qr, t);
  return /* @__PURE__ */ u(xh, { scope: t, forceMount: n, children: d.Children.map(o, (s) => /* @__PURE__ */ u(xe, { present: n || a.open, children: /* @__PURE__ */ u(Qt, { asChild: !0, container: r, children: s }) })) });
};
el.displayName = qr;
var Qn = "DialogOverlay", tl = d.forwardRef(
  (e, t) => {
    const n = Ji(Qn, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Ye(Qn, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u(xe, { present: o || a.open, children: /* @__PURE__ */ u(Ch, { ...r, ref: t }) }) : null;
  }
);
tl.displayName = Qn;
var Sh = /* @__PURE__ */ ft("DialogOverlay.RemoveScroll"), Ch = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Ye(Qn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u(kn, { as: Sh, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ u(
        z.div,
        {
          "data-state": Zr(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Pt = "DialogContent", nl = d.forwardRef(
  (e, t) => {
    const n = Ji(Pt, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Ye(Pt, e.__scopeDialog);
    return /* @__PURE__ */ u(xe, { present: o || a.open, children: a.modal ? /* @__PURE__ */ u(kh, { ...r, ref: t }) : /* @__PURE__ */ u(Mh, { ...r, ref: t }) });
  }
);
nl.displayName = Pt;
var kh = d.forwardRef(
  (e, t) => {
    const n = Ye(Pt, e.__scopeDialog), o = d.useRef(null), r = U(t, n.contentRef, o);
    return d.useEffect(() => {
      const a = o.current;
      if (a) return yo(a);
    }, []), /* @__PURE__ */ u(
      ol,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: N(e.onPointerDownOutside, (a) => {
          const s = a.detail.originalEvent, i = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: N(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Mh = d.forwardRef(
  (e, t) => {
    const n = Ye(Pt, e.__scopeDialog), o = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ u(
      ol,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (o.current || n.triggerRef.current?.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const s = a.target;
          n.triggerRef.current?.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), ol = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: a, ...s } = e, i = Ye(Pt, n), l = d.useRef(null), c = U(t, l);
    return vo(), /* @__PURE__ */ Q(ut, { children: [
      /* @__PURE__ */ u(
        Cn,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ u(
            Zt,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Zr(i.open),
              ...s,
              ref: c,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Q(ut, { children: [
        /* @__PURE__ */ u(Ph, { titleId: i.titleId }),
        /* @__PURE__ */ u(_h, { contentRef: l, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), Xr = "DialogTitle", rl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Ye(Xr, n);
    return /* @__PURE__ */ u(z.h2, { id: r.titleId, ...o, ref: t });
  }
);
rl.displayName = Xr;
var al = "DialogDescription", sl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Ye(al, n);
    return /* @__PURE__ */ u(z.p, { id: r.descriptionId, ...o, ref: t });
  }
);
sl.displayName = al;
var il = "DialogClose", ll = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Ye(il, n);
    return /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: N(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
ll.displayName = il;
function Zr(e) {
  return e ? "open" : "closed";
}
var cl = "DialogTitleWarning", [Eh, dl] = Hp(cl, {
  contentName: Pt,
  titleName: Xr,
  docsSlug: "dialog"
}), Ph = ({ titleId: e }) => {
  const t = dl(cl), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Dh = "DialogDescriptionWarning", _h = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${dl(Dh).contentName}}.`;
  return d.useEffect(() => {
    const r = e.current?.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, Qr = Xi, Jr = Qi, ea = el, ta = tl, na = nl, oa = rl, ra = sl, Tt = ll, ul = "AlertDialog", [Oh] = be(ul, [
  qi
]), rt = qi(), fl = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, o = rt(t);
  return /* @__PURE__ */ u(Qr, { ...o, ...n, modal: !0 });
};
fl.displayName = ul;
var Nh = "AlertDialogTrigger", pl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = rt(n);
    return /* @__PURE__ */ u(Jr, { ...r, ...o, ref: t });
  }
);
pl.displayName = Nh;
var Rh = "AlertDialogPortal", ml = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, o = rt(t);
  return /* @__PURE__ */ u(ea, { ...o, ...n });
};
ml.displayName = Rh;
var Th = "AlertDialogOverlay", hl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = rt(n);
    return /* @__PURE__ */ u(ta, { ...r, ...o, ref: t });
  }
);
hl.displayName = Th;
var Ht = "AlertDialogContent", [Ah, Ih] = Oh(Ht), Wh = /* @__PURE__ */ bi("AlertDialogContent"), gl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: o, ...r } = e, a = rt(n), s = d.useRef(null), i = U(t, s), l = d.useRef(null);
    return /* @__PURE__ */ u(
      Eh,
      {
        contentName: Ht,
        titleName: vl,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ u(Ah, { scope: n, cancelRef: l, children: /* @__PURE__ */ Q(
          na,
          {
            role: "alertdialog",
            ...a,
            ...r,
            ref: i,
            onOpenAutoFocus: N(r.onOpenAutoFocus, (c) => {
              c.preventDefault(), l.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (c) => c.preventDefault(),
            onInteractOutside: (c) => c.preventDefault(),
            children: [
              /* @__PURE__ */ u(Wh, { children: o }),
              /* @__PURE__ */ u(Lh, { contentRef: s })
            ]
          }
        ) })
      }
    );
  }
);
gl.displayName = Ht;
var vl = "AlertDialogTitle", bl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = rt(n);
    return /* @__PURE__ */ u(oa, { ...r, ...o, ref: t });
  }
);
bl.displayName = vl;
var yl = "AlertDialogDescription", wl = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...o } = e, r = rt(n);
  return /* @__PURE__ */ u(ra, { ...r, ...o, ref: t });
});
wl.displayName = yl;
var Fh = "AlertDialogAction", xl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = rt(n);
    return /* @__PURE__ */ u(Tt, { ...r, ...o, ref: t });
  }
);
xl.displayName = Fh;
var Sl = "AlertDialogCancel", Cl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, { cancelRef: r } = Ih(Sl, n), a = rt(n), s = U(t, r);
    return /* @__PURE__ */ u(Tt, { ...a, ...o, ref: s });
  }
);
Cl.displayName = Sl;
var Lh = ({ contentRef: e }) => {
  const t = `\`${Ht}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${Ht}\` by passing a \`${yl}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${Ht}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    document.getElementById(
      e.current?.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, zh = fl, $h = pl, Bh = ml, Yh = hl, Hh = gl, Gh = xl, Vh = Cl, Uh = bl, jh = wl, Hn = { exports: {} }, sr = {};
var ps;
function Kh() {
  if (ps) return sr;
  ps = 1;
  var e = D;
  function t(f, m) {
    return f === m && (f !== 0 || 1 / f === 1 / m) || f !== f && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, r = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function i(f, m) {
    var h = m(), b = o({ inst: { value: h, getSnapshot: m } }), g = b[0].inst, v = b[1];
    return a(
      function() {
        g.value = h, g.getSnapshot = m, l(g) && v({ inst: g });
      },
      [f, h, m]
    ), r(
      function() {
        return l(g) && v({ inst: g }), f(function() {
          l(g) && v({ inst: g });
        });
      },
      [f]
    ), s(h), h;
  }
  function l(f) {
    var m = f.getSnapshot;
    f = f.value;
    try {
      var h = m();
      return !n(f, h);
    } catch {
      return !0;
    }
  }
  function c(f, m) {
    return m();
  }
  var p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : i;
  return sr.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, sr;
}
var ir = {};
var ms;
function qh() {
  return ms || (ms = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(h, b) {
      return h === b && (h !== 0 || 1 / h === 1 / b) || h !== h && b !== b;
    }
    function t(h, b) {
      p || r.startTransition === void 0 || (p = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = b();
      if (!f) {
        var v = b();
        a(g, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      v = s({
        inst: { value: g, getSnapshot: b }
      });
      var y = v[0].inst, w = v[1];
      return l(
        function() {
          y.value = g, y.getSnapshot = b, n(y) && w({ inst: y });
        },
        [h, g, b]
      ), i(
        function() {
          return n(y) && w({ inst: y }), h(function() {
            n(y) && w({ inst: y });
          });
        },
        [h]
      ), c(g), g;
    }
    function n(h) {
      var b = h.getSnapshot;
      h = h.value;
      try {
        var g = b();
        return !a(h, g);
      } catch {
        return !0;
      }
    }
    function o(h, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = D, a = typeof Object.is == "function" ? Object.is : e, s = r.useState, i = r.useEffect, l = r.useLayoutEffect, c = r.useDebugValue, p = !1, f = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : t;
    ir.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), ir;
}
var hs;
function Xh() {
  return hs || (hs = 1, process.env.NODE_ENV === "production" ? Hn.exports = Kh() : Hn.exports = qh()), Hn.exports;
}
var Zh = Xh();
function Qh() {
  return Zh.useSyncExternalStore(
    Jh,
    () => !0,
    () => !1
  );
}
function Jh() {
  return () => {
  };
}
var aa = "Avatar", [eg] = be(aa), [tg, kl] = eg(aa), Ml = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...o } = e, [r, a] = d.useState("idle");
    return /* @__PURE__ */ u(
      tg,
      {
        scope: n,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ u(z.span, { ...o, ref: t })
      }
    );
  }
);
Ml.displayName = aa;
var El = "AvatarImage", Pl = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: o, onLoadingStatusChange: r = () => {
    }, ...a } = e, s = kl(El, n), i = ng(o, a), l = ve((c) => {
      r(c), s.onImageLoadingStatusChange(c);
    });
    return pe(() => {
      i !== "idle" && l(i);
    }, [i, l]), i === "loaded" ? /* @__PURE__ */ u(z.img, { ...a, ref: t, src: o }) : null;
  }
);
Pl.displayName = El;
var Dl = "AvatarFallback", _l = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: o, ...r } = e, a = kl(Dl, n), [s, i] = d.useState(o === void 0);
    return d.useEffect(() => {
      if (o !== void 0) {
        const l = window.setTimeout(() => i(!0), o);
        return () => window.clearTimeout(l);
      }
    }, [o]), s && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ u(z.span, { ...r, ref: t }) : null;
  }
);
_l.displayName = Dl;
function gs(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function ng(e, { referrerPolicy: t, crossOrigin: n }) {
  const o = Qh(), r = d.useRef(null), a = o ? (r.current || (r.current = new window.Image()), r.current) : null, [s, i] = d.useState(
    () => gs(a, e)
  );
  return pe(() => {
    i(gs(a, e));
  }, [a, e]), pe(() => {
    const l = (f) => () => {
      i(f);
    };
    if (!a) return;
    const c = l("loaded"), p = l("error");
    return a.addEventListener("load", c), a.addEventListener("error", p), t && (a.referrerPolicy = t), typeof n == "string" && (a.crossOrigin = n), () => {
      a.removeEventListener("load", c), a.removeEventListener("error", p);
    };
  }, [a, n, t]), s;
}
var og = Ml, rg = Pl, ag = _l;
function xo(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function So(e) {
  const [t, n] = d.useState(void 0);
  return pe(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let s, i;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, i = c.blockSize;
        } else
          s = e.offsetWidth, i = e.offsetHeight;
        n({ width: s, height: i });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Co = "Checkbox", [sg] = be(Co), [ig, sa] = sg(Co);
function lg(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: o,
    defaultChecked: r,
    disabled: a,
    form: s,
    name: i,
    onCheckedChange: l,
    required: c,
    value: p = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [m, h] = Se({
    prop: n,
    defaultProp: r ?? !1,
    onChange: l,
    caller: Co
  }), [b, g] = d.useState(null), [v, y] = d.useState(null), w = d.useRef(!1), x = b ? !!s || !!b.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), S = {
    checked: m,
    disabled: a,
    setChecked: h,
    control: b,
    setControl: g,
    name: i,
    form: s,
    value: p,
    hasConsumerStoppedPropagationRef: w,
    required: c,
    defaultChecked: dt(r) ? !1 : r,
    isFormControl: x,
    bubbleInput: v,
    setBubbleInput: y
  };
  return /* @__PURE__ */ u(
    ig,
    {
      scope: t,
      ...S,
      children: cg(f) ? f(S) : o
    }
  );
}
var Ol = "CheckboxTrigger", Nl = d.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...o }, r) => {
    const {
      control: a,
      value: s,
      disabled: i,
      checked: l,
      required: c,
      setControl: p,
      setChecked: f,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: h,
      bubbleInput: b
    } = sa(Ol, e), g = U(r, p), v = d.useRef(l);
    return d.useEffect(() => {
      const y = a?.form;
      if (y) {
        const w = () => f(v.current);
        return y.addEventListener("reset", w), () => y.removeEventListener("reset", w);
      }
    }, [a, f]), /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": dt(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": Fl(l),
        "data-disabled": i ? "" : void 0,
        disabled: i,
        value: s,
        ...o,
        ref: g,
        onKeyDown: N(t, (y) => {
          y.key === "Enter" && y.preventDefault();
        }),
        onClick: N(n, (y) => {
          f((w) => dt(w) ? !0 : !w), b && h && (m.current = y.isPropagationStopped(), m.current || y.stopPropagation());
        })
      }
    );
  }
);
Nl.displayName = Ol;
var Rl = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: s,
      disabled: i,
      value: l,
      onCheckedChange: c,
      form: p,
      ...f
    } = e;
    return /* @__PURE__ */ u(
      lg,
      {
        __scopeCheckbox: n,
        checked: r,
        defaultChecked: a,
        disabled: i,
        required: s,
        onCheckedChange: c,
        name: o,
        form: p,
        value: l,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ Q(ut, { children: [
          /* @__PURE__ */ u(
            Nl,
            {
              ...f,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          m && /* @__PURE__ */ u(
            Wl,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
Rl.displayName = Co;
var Tl = "CheckboxIndicator", Al = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: o, ...r } = e, a = sa(Tl, n);
    return /* @__PURE__ */ u(
      xe,
      {
        present: o || dt(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u(
          z.span,
          {
            "data-state": Fl(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...r,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Al.displayName = Tl;
var Il = "CheckboxBubbleInput", Wl = d.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: o,
      hasConsumerStoppedPropagationRef: r,
      checked: a,
      defaultChecked: s,
      required: i,
      disabled: l,
      name: c,
      value: p,
      form: f,
      bubbleInput: m,
      setBubbleInput: h
    } = sa(Il, e), b = U(n, h), g = xo(a), v = So(o);
    d.useEffect(() => {
      const w = m;
      if (!w) return;
      const x = window.HTMLInputElement.prototype, k = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, C = !r.current;
      if (g !== a && k) {
        const P = new Event("click", { bubbles: C });
        w.indeterminate = dt(a), k.call(w, dt(a) ? !1 : a), w.dispatchEvent(P);
      }
    }, [m, g, a, r]);
    const y = d.useRef(dt(a) ? !1 : a);
    return /* @__PURE__ */ u(
      z.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: s ?? y.current,
        required: i,
        disabled: l,
        name: c,
        value: p,
        form: f,
        ...t,
        tabIndex: -1,
        ref: b,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Wl.displayName = Il;
function cg(e) {
  return typeof e == "function";
}
function dt(e) {
  return e === "indeterminate";
}
function Fl(e) {
  return dt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const dg = ["top", "right", "bottom", "left"], pt = Math.min, _e = Math.max, Jn = Math.round, Gn = Math.floor, Ke = (e) => ({
  x: e,
  y: e
}), ug = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Cr(e, t, n) {
  return _e(e, pt(t, n));
}
function nt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ot(e) {
  return e.split("-")[0];
}
function Jt(e) {
  return e.split("-")[1];
}
function ia(e) {
  return e === "x" ? "y" : "x";
}
function la(e) {
  return e === "y" ? "height" : "width";
}
function Ue(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function ca(e) {
  return ia(Ue(e));
}
function fg(e, t, n) {
  n === void 0 && (n = !1);
  const o = Jt(e), r = ca(e), a = la(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = eo(s)), [s, eo(s)];
}
function pg(e) {
  const t = eo(e);
  return [kr(e), t, kr(t)];
}
function kr(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const vs = ["left", "right"], bs = ["right", "left"], mg = ["top", "bottom"], hg = ["bottom", "top"];
function gg(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? bs : vs : t ? vs : bs;
    case "left":
    case "right":
      return t ? mg : hg;
    default:
      return [];
  }
}
function vg(e, t, n, o) {
  const r = Jt(e);
  let a = gg(ot(e), n === "start", o);
  return r && (a = a.map((s) => s + "-" + r), t && (a = a.concat(a.map(kr)))), a;
}
function eo(e) {
  const t = ot(e);
  return ug[t] + e.slice(t.length);
}
function bg(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ll(e) {
  return typeof e != "number" ? bg(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function to(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function ys(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = Ue(t), s = ca(t), i = la(s), l = ot(t), c = a === "y", p = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, m = o[i] / 2 - r[i] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: p,
        y: o.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (Jt(t)) {
    case "start":
      h[s] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += m * (n && c ? -1 : 1);
      break;
  }
  return h;
}
async function yg(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: s,
    elements: i,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = nt(t, e), b = Ll(h), v = i[m ? f === "floating" ? "reference" : "floating" : f], y = to(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: p,
    strategy: l
  })), w = f === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), S = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = to(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (y.top - k.top + b.top) / S.y,
    bottom: (k.bottom - y.bottom + b.bottom) / S.y,
    left: (y.left - k.left + b.left) / S.x,
    right: (k.right - y.right + b.right) / S.x
  };
}
const wg = 50, xg = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: s
  } = n, i = s.detectOverflow ? s : {
    ...s,
    detectOverflow: yg
  }, l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: p,
    y: f
  } = ys(c, o, l), m = o, h = 0;
  const b = {};
  for (let g = 0; g < a.length; g++) {
    const v = a[g];
    if (!v)
      continue;
    const {
      name: y,
      fn: w
    } = v, {
      x,
      y: S,
      data: k,
      reset: C
    } = await w({
      x: p,
      y: f,
      initialPlacement: o,
      placement: m,
      strategy: r,
      middlewareData: b,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = x ?? p, f = S ?? f, b[y] = {
      ...b[y],
      ...k
    }, C && h < wg && (h++, typeof C == "object" && (C.placement && (m = C.placement), C.rects && (c = C.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : C.rects), {
      x: p,
      y: f
    } = ys(c, m, l)), g = -1);
  }
  return {
    x: p,
    y: f,
    placement: m,
    strategy: r,
    middlewareData: b
  };
}, Sg = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: s,
      elements: i,
      middlewareData: l
    } = t, {
      element: c,
      padding: p = 0
    } = nt(e, t) || {};
    if (c == null)
      return {};
    const f = Ll(p), m = {
      x: n,
      y: o
    }, h = ca(r), b = la(h), g = await s.getDimensions(c), v = h === "y", y = v ? "top" : "left", w = v ? "bottom" : "right", x = v ? "clientHeight" : "clientWidth", S = a.reference[b] + a.reference[h] - m[h] - a.floating[b], k = m[h] - a.reference[h], C = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let P = C ? C[x] : 0;
    (!P || !await (s.isElement == null ? void 0 : s.isElement(C))) && (P = i.floating[x] || a.floating[b]);
    const M = S / 2 - k / 2, _ = P / 2 - g[b] / 2 - 1, O = pt(f[y], _), A = pt(f[w], _), Y = O, G = P - g[b] - A, H = P / 2 - g[b] / 2 + M, j = Cr(Y, H, G), F = !l.arrow && Jt(r) != null && H !== j && a.reference[b] / 2 - (H < Y ? O : A) - g[b] / 2 < 0, V = F ? H < Y ? H - Y : H - G : 0;
    return {
      [h]: m[h] + V,
      data: {
        [h]: j,
        centerOffset: H - j - V,
        ...F && {
          alignmentOffset: V
        }
      },
      reset: F
    };
  }
}), Cg = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: c
      } = t, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: g = !0,
        ...v
      } = nt(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = ot(r), w = Ue(i), x = ot(i) === i, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), k = m || (x || !g ? [eo(i)] : pg(i)), C = b !== "none";
      !m && C && k.push(...vg(i, g, b, S));
      const P = [i, ...k], M = await l.detectOverflow(t, v), _ = [];
      let O = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (p && _.push(M[y]), f) {
        const H = fg(r, s, S);
        _.push(M[H[0]], M[H[1]]);
      }
      if (O = [...O, {
        placement: r,
        overflows: _
      }], !_.every((H) => H <= 0)) {
        var A, Y;
        const H = (((A = a.flip) == null ? void 0 : A.index) || 0) + 1, j = P[H];
        if (j && (!(f === "alignment" ? w !== Ue(j) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        O.every((L) => Ue(L.placement) === w ? L.overflows[0] > 0 : !0)))
          return {
            data: {
              index: H,
              overflows: O
            },
            reset: {
              placement: j
            }
          };
        let F = (Y = O.filter((V) => V.overflows[0] <= 0).sort((V, L) => V.overflows[1] - L.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!F)
          switch (h) {
            case "bestFit": {
              var G;
              const V = (G = O.filter((L) => {
                if (C) {
                  const R = Ue(L.placement);
                  return R === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  R === "y";
                }
                return !0;
              }).map((L) => [L.placement, L.overflows.filter((R) => R > 0).reduce((R, T) => R + T, 0)]).sort((L, R) => L[1] - R[1])[0]) == null ? void 0 : G[0];
              V && (F = V);
              break;
            }
            case "initialPlacement":
              F = i;
              break;
          }
        if (r !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
function ws(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function xs(e) {
  return dg.some((t) => e[t] >= 0);
}
const kg = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: o
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = nt(e, t);
      switch (r) {
        case "referenceHidden": {
          const s = await o.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), i = ws(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: xs(i)
            }
          };
        }
        case "escaped": {
          const s = await o.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), i = ws(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: xs(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, zl = /* @__PURE__ */ new Set(["left", "top"]);
async function Mg(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = ot(n), i = Jt(n), l = Ue(n) === "y", c = zl.has(s) ? -1 : 1, p = a && l ? -1 : 1, f = nt(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: b
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof b == "number" && (h = i === "end" ? b * -1 : b), l ? {
    x: h * p,
    y: m * c
  } : {
    x: m * c,
    y: h * p
  };
}
const Eg = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: s,
        middlewareData: i
      } = t, l = await Mg(t, e);
      return s === ((n = i.offset) == null ? void 0 : n.placement) && (o = i.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, Pg = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: a
      } = t, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (y) => {
            let {
              x: w,
              y: x
            } = y;
            return {
              x: w,
              y: x
            };
          }
        },
        ...c
      } = nt(e, t), p = {
        x: n,
        y: o
      }, f = await a.detectOverflow(t, c), m = Ue(ot(r)), h = ia(m);
      let b = p[h], g = p[m];
      if (s) {
        const y = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", x = b + f[y], S = b - f[w];
        b = Cr(x, b, S);
      }
      if (i) {
        const y = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", x = g + f[y], S = g - f[w];
        g = Cr(x, g, S);
      }
      const v = l.fn({
        ...t,
        [h]: b,
        [m]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - o,
          enabled: {
            [h]: s,
            [m]: i
          }
        }
      };
    }
  };
}, Dg = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: a,
        middlewareData: s
      } = t, {
        offset: i = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = nt(e, t), p = {
        x: n,
        y: o
      }, f = Ue(r), m = ia(f);
      let h = p[m], b = p[f];
      const g = nt(i, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const x = m === "y" ? "height" : "width", S = a.reference[m] - a.floating[x] + v.mainAxis, k = a.reference[m] + a.reference[x] - v.mainAxis;
        h < S ? h = S : h > k && (h = k);
      }
      if (c) {
        var y, w;
        const x = m === "y" ? "width" : "height", S = zl.has(ot(r)), k = a.reference[f] - a.floating[x] + (S && ((y = s.offset) == null ? void 0 : y[f]) || 0) + (S ? 0 : v.crossAxis), C = a.reference[f] + a.reference[x] + (S ? 0 : ((w = s.offset) == null ? void 0 : w[f]) || 0) - (S ? v.crossAxis : 0);
        b < k ? b = k : b > C && (b = C);
      }
      return {
        [m]: h,
        [f]: b
      };
    }
  };
}, _g = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: a,
        platform: s,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...c
      } = nt(e, t), p = await s.detectOverflow(t, c), f = ot(r), m = Jt(r), h = Ue(r) === "y", {
        width: b,
        height: g
      } = a.floating;
      let v, y;
      f === "top" || f === "bottom" ? (v = f, y = m === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (y = f, v = m === "end" ? "top" : "bottom");
      const w = g - p.top - p.bottom, x = b - p.left - p.right, S = pt(g - p[v], w), k = pt(b - p[y], x), C = !t.middlewareData.shift;
      let P = S, M = k;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (M = x), (o = t.middlewareData.shift) != null && o.enabled.y && (P = w), C && !m) {
        const O = _e(p.left, 0), A = _e(p.right, 0), Y = _e(p.top, 0), G = _e(p.bottom, 0);
        h ? M = b - 2 * (O !== 0 || A !== 0 ? O + A : _e(p.left, p.right)) : P = g - 2 * (Y !== 0 || G !== 0 ? Y + G : _e(p.top, p.bottom));
      }
      await l({
        ...t,
        availableWidth: M,
        availableHeight: P
      });
      const _ = await s.getDimensions(i.floating);
      return b !== _.width || g !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ko() {
  return typeof window < "u";
}
function en(e) {
  return $l(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Oe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function qe(e) {
  var t;
  return (t = ($l(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function $l(e) {
  return ko() ? e instanceof Node || e instanceof Oe(e).Node : !1;
}
function ze(e) {
  return ko() ? e instanceof Element || e instanceof Oe(e).Element : !1;
}
function at(e) {
  return ko() ? e instanceof HTMLElement || e instanceof Oe(e).HTMLElement : !1;
}
function Ss(e) {
  return !ko() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Oe(e).ShadowRoot;
}
function Mn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = $e(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && r !== "inline" && r !== "contents";
}
function Og(e) {
  return /^(table|td|th)$/.test(en(e));
}
function Mo(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Ng = /transform|translate|scale|rotate|perspective|filter/, Rg = /paint|layout|strict|content/, Mt = (e) => !!e && e !== "none";
let lr;
function da(e) {
  const t = ze(e) ? $e(e) : e;
  return Mt(t.transform) || Mt(t.translate) || Mt(t.scale) || Mt(t.rotate) || Mt(t.perspective) || !ua() && (Mt(t.backdropFilter) || Mt(t.filter)) || Ng.test(t.willChange || "") || Rg.test(t.contain || "");
}
function Tg(e) {
  let t = mt(e);
  for (; at(t) && !Vt(t); ) {
    if (da(t))
      return t;
    if (Mo(t))
      return null;
    t = mt(t);
  }
  return null;
}
function ua() {
  return lr == null && (lr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), lr;
}
function Vt(e) {
  return /^(html|body|#document)$/.test(en(e));
}
function $e(e) {
  return Oe(e).getComputedStyle(e);
}
function Eo(e) {
  return ze(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function mt(e) {
  if (en(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ss(e) && e.host || // Fallback.
    qe(e)
  );
  return Ss(t) ? t.host : t;
}
function Bl(e) {
  const t = mt(e);
  return Vt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : at(t) && Mn(t) ? t : Bl(t);
}
function hn(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Bl(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), s = Oe(r);
  if (a) {
    const i = Mr(s);
    return t.concat(s, s.visualViewport || [], Mn(r) ? r : [], i && n ? hn(i) : []);
  } else
    return t.concat(r, hn(r, [], n));
}
function Mr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Yl(e) {
  const t = $e(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = at(e), a = r ? e.offsetWidth : n, s = r ? e.offsetHeight : o, i = Jn(n) !== a || Jn(o) !== s;
  return i && (n = a, o = s), {
    width: n,
    height: o,
    $: i
  };
}
function fa(e) {
  return ze(e) ? e : e.contextElement;
}
function Gt(e) {
  const t = fa(e);
  if (!at(t))
    return Ke(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = Yl(t);
  let s = (a ? Jn(n.width) : n.width) / o, i = (a ? Jn(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const Ag = /* @__PURE__ */ Ke(0);
function Hl(e) {
  const t = Oe(e);
  return !ua() || !t.visualViewport ? Ag : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ig(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Oe(e) ? !1 : t;
}
function Dt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = fa(e);
  let s = Ke(1);
  t && (o ? ze(o) && (s = Gt(o)) : s = Gt(e));
  const i = Ig(a, n, o) ? Hl(a) : Ke(0);
  let l = (r.left + i.x) / s.x, c = (r.top + i.y) / s.y, p = r.width / s.x, f = r.height / s.y;
  if (a) {
    const m = Oe(a), h = o && ze(o) ? Oe(o) : o;
    let b = m, g = Mr(b);
    for (; g && o && h !== b; ) {
      const v = Gt(g), y = g.getBoundingClientRect(), w = $e(g), x = y.left + (g.clientLeft + parseFloat(w.paddingLeft)) * v.x, S = y.top + (g.clientTop + parseFloat(w.paddingTop)) * v.y;
      l *= v.x, c *= v.y, p *= v.x, f *= v.y, l += x, c += S, b = Oe(g), g = Mr(b);
    }
  }
  return to({
    width: p,
    height: f,
    x: l,
    y: c
  });
}
function Po(e, t) {
  const n = Eo(e).scrollLeft;
  return t ? t.left + n : Dt(qe(e)).left + n;
}
function Gl(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - Po(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function Wg(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", s = qe(o), i = t ? Mo(t.floating) : !1;
  if (o === s || i && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ke(1);
  const p = Ke(0), f = at(o);
  if ((f || !f && !a) && ((en(o) !== "body" || Mn(s)) && (l = Eo(o)), f)) {
    const h = Dt(o);
    c = Gt(o), p.x = h.x + o.clientLeft, p.y = h.y + o.clientTop;
  }
  const m = s && !f && !a ? Gl(s, l) : Ke(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + p.x + m.x,
    y: n.y * c.y - l.scrollTop * c.y + p.y + m.y
  };
}
function Fg(e) {
  return Array.from(e.getClientRects());
}
function Lg(e) {
  const t = qe(e), n = Eo(e), o = e.ownerDocument.body, r = _e(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = _e(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Po(e);
  const i = -n.scrollTop;
  return $e(o).direction === "rtl" && (s += _e(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: s,
    y: i
  };
}
const Cs = 25;
function zg(e, t) {
  const n = Oe(e), o = qe(e), r = n.visualViewport;
  let a = o.clientWidth, s = o.clientHeight, i = 0, l = 0;
  if (r) {
    a = r.width, s = r.height;
    const p = ua();
    (!p || p && t === "fixed") && (i = r.offsetLeft, l = r.offsetTop);
  }
  const c = Po(o);
  if (c <= 0) {
    const p = o.ownerDocument, f = p.body, m = getComputedStyle(f), h = p.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, b = Math.abs(o.clientWidth - f.clientWidth - h);
    b <= Cs && (a -= b);
  } else c <= Cs && (a += c);
  return {
    width: a,
    height: s,
    x: i,
    y: l
  };
}
function $g(e, t) {
  const n = Dt(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = at(e) ? Gt(e) : Ke(1), s = e.clientWidth * a.x, i = e.clientHeight * a.y, l = r * a.x, c = o * a.y;
  return {
    width: s,
    height: i,
    x: l,
    y: c
  };
}
function ks(e, t, n) {
  let o;
  if (t === "viewport")
    o = zg(e, n);
  else if (t === "document")
    o = Lg(qe(e));
  else if (ze(t))
    o = $g(t, n);
  else {
    const r = Hl(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return to(o);
}
function Vl(e, t) {
  const n = mt(e);
  return n === t || !ze(n) || Vt(n) ? !1 : $e(n).position === "fixed" || Vl(n, t);
}
function Bg(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = hn(e, [], !1).filter((i) => ze(i) && en(i) !== "body"), r = null;
  const a = $e(e).position === "fixed";
  let s = a ? mt(e) : e;
  for (; ze(s) && !Vt(s); ) {
    const i = $e(s), l = da(s);
    !l && i.position === "fixed" && (r = null), (a ? !l && !r : !l && i.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || Mn(s) && !l && Vl(e, s)) ? o = o.filter((p) => p !== s) : r = i, s = mt(s);
  }
  return t.set(e, o), o;
}
function Yg(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const s = [...n === "clippingAncestors" ? Mo(t) ? [] : Bg(t, this._c) : [].concat(n), o], i = ks(t, s[0], r);
  let l = i.top, c = i.right, p = i.bottom, f = i.left;
  for (let m = 1; m < s.length; m++) {
    const h = ks(t, s[m], r);
    l = _e(h.top, l), c = pt(h.right, c), p = pt(h.bottom, p), f = _e(h.left, f);
  }
  return {
    width: c - f,
    height: p - l,
    x: f,
    y: l
  };
}
function Hg(e) {
  const {
    width: t,
    height: n
  } = Yl(e);
  return {
    width: t,
    height: n
  };
}
function Gg(e, t, n) {
  const o = at(t), r = qe(t), a = n === "fixed", s = Dt(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ke(0);
  function c() {
    l.x = Po(r);
  }
  if (o || !o && !a)
    if ((en(t) !== "body" || Mn(r)) && (i = Eo(t)), o) {
      const h = Dt(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else r && c();
  a && !o && r && c();
  const p = r && !o && !a ? Gl(r, i) : Ke(0), f = s.left + i.scrollLeft - l.x - p.x, m = s.top + i.scrollTop - l.y - p.y;
  return {
    x: f,
    y: m,
    width: s.width,
    height: s.height
  };
}
function cr(e) {
  return $e(e).position === "static";
}
function Ms(e, t) {
  if (!at(e) || $e(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return qe(e) === n && (n = n.ownerDocument.body), n;
}
function Ul(e, t) {
  const n = Oe(e);
  if (Mo(e))
    return n;
  if (!at(e)) {
    let r = mt(e);
    for (; r && !Vt(r); ) {
      if (ze(r) && !cr(r))
        return r;
      r = mt(r);
    }
    return n;
  }
  let o = Ms(e, t);
  for (; o && Og(o) && cr(o); )
    o = Ms(o, t);
  return o && Vt(o) && cr(o) && !da(o) ? n : o || Tg(e) || n;
}
const Vg = async function(e) {
  const t = this.getOffsetParent || Ul, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Gg(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Ug(e) {
  return $e(e).direction === "rtl";
}
const jg = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Wg,
  getDocumentElement: qe,
  getClippingRect: Yg,
  getOffsetParent: Ul,
  getElementRects: Vg,
  getClientRects: Fg,
  getDimensions: Hg,
  getScale: Gt,
  isElement: ze,
  isRTL: Ug
};
function jl(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Kg(e, t) {
  let n = null, o;
  const r = qe(e);
  function a() {
    var i;
    clearTimeout(o), (i = n) == null || i.disconnect(), n = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), a();
    const c = e.getBoundingClientRect(), {
      left: p,
      top: f,
      width: m,
      height: h
    } = c;
    if (i || t(), !m || !h)
      return;
    const b = Gn(f), g = Gn(r.clientWidth - (p + m)), v = Gn(r.clientHeight - (f + h)), y = Gn(p), x = {
      rootMargin: -b + "px " + -g + "px " + -v + "px " + -y + "px",
      threshold: _e(0, pt(1, l)) || 1
    };
    let S = !0;
    function k(C) {
      const P = C[0].intersectionRatio;
      if (P !== l) {
        if (!S)
          return s();
        P ? s(!1, P) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !jl(c, e.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...x,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, x);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function qg(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = fa(e), p = r || a ? [...c ? hn(c) : [], ...t ? hn(t) : []] : [];
  p.forEach((y) => {
    r && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const f = c && i ? Kg(c, n) : null;
  let m = -1, h = null;
  s && (h = new ResizeObserver((y) => {
    let [w] = y;
    w && w.target === c && h && t && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), c && !l && h.observe(c), t && h.observe(t));
  let b, g = l ? Dt(e) : null;
  l && v();
  function v() {
    const y = Dt(e);
    g && !jl(g, y) && n(), g = y, b = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    p.forEach((w) => {
      r && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), f?.(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(b);
  };
}
const Xg = Eg, Zg = Pg, Qg = Cg, Jg = _g, ev = kg, Es = Sg, tv = Dg, nv = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: jg,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return xg(e, t, {
    ...r,
    platform: a
  });
};
var ov = typeof document < "u", rv = function() {
}, Kn = ov ? Xs : rv;
function no(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!no(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && e.$$typeof) && !no(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Kl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ps(e, t) {
  const n = Kl(e);
  return Math.round(t * n) / n;
}
function dr(e) {
  const t = d.useRef(e);
  return Kn(() => {
    t.current = e;
  }), t;
}
function av(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: c
  } = e, [p, f] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = d.useState(o);
  no(m, o) || h(o);
  const [b, g] = d.useState(null), [v, y] = d.useState(null), w = d.useCallback((L) => {
    L !== C.current && (C.current = L, g(L));
  }, []), x = d.useCallback((L) => {
    L !== P.current && (P.current = L, y(L));
  }, []), S = a || b, k = s || v, C = d.useRef(null), P = d.useRef(null), M = d.useRef(p), _ = l != null, O = dr(l), A = dr(r), Y = dr(c), G = d.useCallback(() => {
    if (!C.current || !P.current)
      return;
    const L = {
      placement: t,
      strategy: n,
      middleware: m
    };
    A.current && (L.platform = A.current), nv(C.current, P.current, L).then((R) => {
      const T = {
        ...R,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Y.current !== !1
      };
      H.current && !no(M.current, T) && (M.current = T, fo.flushSync(() => {
        f(T);
      }));
    });
  }, [m, t, n, A, Y]);
  Kn(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, f((L) => ({
      ...L,
      isPositioned: !1
    })));
  }, [c]);
  const H = d.useRef(!1);
  Kn(() => (H.current = !0, () => {
    H.current = !1;
  }), []), Kn(() => {
    if (S && (C.current = S), k && (P.current = k), S && k) {
      if (O.current)
        return O.current(S, k, G);
      G();
    }
  }, [S, k, G, O, _]);
  const j = d.useMemo(() => ({
    reference: C,
    floating: P,
    setReference: w,
    setFloating: x
  }), [w, x]), F = d.useMemo(() => ({
    reference: S,
    floating: k
  }), [S, k]), V = d.useMemo(() => {
    const L = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return L;
    const R = Ps(F.floating, p.x), T = Ps(F.floating, p.y);
    return i ? {
      ...L,
      transform: "translate(" + R + "px, " + T + "px)",
      ...Kl(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: R,
      top: T
    };
  }, [n, i, F.floating, p.x, p.y]);
  return d.useMemo(() => ({
    ...p,
    update: G,
    refs: j,
    elements: F,
    floatingStyles: V
  }), [p, G, j, F, V]);
}
const sv = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Es({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Es({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, iv = (e, t) => {
  const n = Xg(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, lv = (e, t) => {
  const n = Zg(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, cv = (e, t) => ({
  fn: tv(e).fn,
  options: [e, t]
}), dv = (e, t) => {
  const n = Qg(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, uv = (e, t) => {
  const n = Jg(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, fv = (e, t) => {
  const n = ev(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, pv = (e, t) => {
  const n = sv(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var mv = "Arrow", ql = d.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ u(
    z.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ u("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ql.displayName = mv;
var hv = ql, pa = "Popper", [Xl, gt] = be(pa), [gv, Zl] = Xl(pa), Ql = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = d.useState(null);
  return /* @__PURE__ */ u(gv, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Ql.displayName = pa;
var Jl = "PopperAnchor", ec = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = Zl(Jl, n), s = d.useRef(null), i = U(t, s), l = d.useRef(null);
    return d.useEffect(() => {
      const c = l.current;
      l.current = o?.current || s.current, c !== l.current && a.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ u(z.div, { ...r, ref: i });
  }
);
ec.displayName = Jl;
var ma = "PopperContent", [vv, bv] = Xl(ma), tc = d.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: p = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: b,
      ...g
    } = e, v = Zl(ma, n), [y, w] = d.useState(null), x = U(t, (I) => w(I)), [S, k] = d.useState(null), C = So(S), P = C?.width ?? 0, M = C?.height ?? 0, _ = o + (a !== "center" ? "-" + a : ""), O = typeof p == "number" ? p : { top: 0, right: 0, bottom: 0, left: 0, ...p }, A = Array.isArray(c) ? c : [c], Y = A.length > 0, G = {
      padding: O,
      boundary: A.filter(wv),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Y
    }, { refs: H, floatingStyles: j, placement: F, isPositioned: V, middlewareData: L } = av({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...I) => qg(...I, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        iv({ mainAxis: r + M, alignmentAxis: s }),
        l && lv({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? cv() : void 0,
          ...G
        }),
        l && dv({ ...G }),
        uv({
          ...G,
          apply: ({ elements: I, rects: se, availableWidth: Z, availableHeight: ee }) => {
            const { width: oe, height: de } = se.reference, we = I.floating.style;
            we.setProperty("--radix-popper-available-width", `${Z}px`), we.setProperty("--radix-popper-available-height", `${ee}px`), we.setProperty("--radix-popper-anchor-width", `${oe}px`), we.setProperty("--radix-popper-anchor-height", `${de}px`);
          }
        }),
        S && pv({ element: S, padding: i }),
        xv({ arrowWidth: P, arrowHeight: M }),
        m && fv({ strategy: "referenceHidden", ...G })
      ]
    }), [R, T] = rc(F), le = ve(b);
    pe(() => {
      V && le?.();
    }, [V, le]);
    const ye = L.arrow?.x, Ce = L.arrow?.y, me = L.arrow?.centerOffset !== 0, [ae, te] = d.useState();
    return pe(() => {
      y && te(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ u(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: V ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ae,
          "--radix-popper-transform-origin": [
            L.transformOrigin?.x,
            L.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...L.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ u(
          vv,
          {
            scope: n,
            placedSide: R,
            onArrowChange: k,
            arrowX: ye,
            arrowY: Ce,
            shouldHideArrow: me,
            children: /* @__PURE__ */ u(
              z.div,
              {
                "data-side": R,
                "data-align": T,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
tc.displayName = ma;
var nc = "PopperArrow", yv = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, oc = d.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = bv(nc, o), s = yv[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ u(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ u(
          hv,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
oc.displayName = nc;
function wv(e) {
  return e !== null;
}
var xv = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: o, middlewareData: r } = t, s = r.arrow?.centerOffset !== 0, i = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [c, p] = rc(n), f = { start: "0%", center: "50%", end: "100%" }[p], m = (r.arrow?.x ?? 0) + i / 2, h = (r.arrow?.y ?? 0) + l / 2;
    let b = "", g = "";
    return c === "bottom" ? (b = s ? f : `${m}px`, g = `${-l}px`) : c === "top" ? (b = s ? f : `${m}px`, g = `${o.floating.height + l}px`) : c === "right" ? (b = `${-l}px`, g = s ? f : `${h}px`) : c === "left" && (b = `${o.floating.width + l}px`, g = s ? f : `${h}px`), { data: { x: b, y: g } };
  }
});
function rc(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var En = Ql, Pn = ec, Do = tc, _o = oc, ur = "rovingFocusGroup.onEntryFocus", Sv = { bubbles: !1, cancelable: !0 }, Dn = "RovingFocusGroup", [Er, ac, Cv] = Sn(Dn), [kv, Oo] = be(
  Dn,
  [Cv]
), [Mv, Ev] = kv(Dn), sc = d.forwardRef(
  (e, t) => /* @__PURE__ */ u(Er.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(Er.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(Pv, { ...e, ref: t }) }) })
);
sc.displayName = Dn;
var Pv = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: p = !1,
    ...f
  } = e, m = d.useRef(null), h = U(t, m), b = Rt(a), [g, v] = Se({
    prop: s,
    defaultProp: i ?? null,
    onChange: l,
    caller: Dn
  }), [y, w] = d.useState(!1), x = ve(c), S = ac(n), k = d.useRef(!1), [C, P] = d.useState(0);
  return d.useEffect(() => {
    const M = m.current;
    if (M)
      return M.addEventListener(ur, x), () => M.removeEventListener(ur, x);
  }, [x]), /* @__PURE__ */ u(
    Mv,
    {
      scope: n,
      orientation: o,
      dir: b,
      loop: r,
      currentTabStopId: g,
      onItemFocus: d.useCallback(
        (M) => v(M),
        [v]
      ),
      onItemShiftTab: d.useCallback(() => w(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => P((M) => M + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => P((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ u(
        z.div,
        {
          tabIndex: y || C === 0 ? -1 : 0,
          "data-orientation": o,
          ...f,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: N(e.onMouseDown, () => {
            k.current = !0;
          }),
          onFocus: N(e.onFocus, (M) => {
            const _ = !k.current;
            if (M.target === M.currentTarget && _ && !y) {
              const O = new CustomEvent(ur, Sv);
              if (M.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const A = S().filter((F) => F.focusable), Y = A.find((F) => F.active), G = A.find((F) => F.id === g), j = [Y, G, ...A].filter(
                  Boolean
                ).map((F) => F.ref.current);
                cc(j, p);
              }
            }
            k.current = !1;
          }),
          onBlur: N(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), ic = "RovingFocusGroupItem", lc = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      children: s,
      ...i
    } = e, l = Ee(), c = a || l, p = Ev(ic, n), f = p.currentTabStopId === c, m = ac(n), { onFocusableItemAdd: h, onFocusableItemRemove: b, currentTabStopId: g } = p;
    return d.useEffect(() => {
      if (o)
        return h(), () => b();
    }, [o, h, b]), /* @__PURE__ */ u(
      Er.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ u(
          z.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": p.orientation,
            ...i,
            ref: t,
            onMouseDown: N(e.onMouseDown, (v) => {
              o ? p.onItemFocus(c) : v.preventDefault();
            }),
            onFocus: N(e.onFocus, () => p.onItemFocus(c)),
            onKeyDown: N(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                p.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const y = Ov(v, p.orientation, p.dir);
              if (y !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let x = m().filter((S) => S.focusable).map((S) => S.ref.current);
                if (y === "last") x.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && x.reverse();
                  const S = x.indexOf(v.currentTarget);
                  x = p.loop ? Nv(x, S + 1) : x.slice(S + 1);
                }
                setTimeout(() => cc(x));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: f, hasTabStop: g != null }) : s
          }
        )
      }
    );
  }
);
lc.displayName = ic;
var Dv = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function _v(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Ov(e, t, n) {
  const o = _v(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Dv[o];
}
function cc(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Nv(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var dc = sc, uc = lc, Pr = ["Enter", " "], Rv = ["ArrowDown", "PageUp", "Home"], fc = ["ArrowUp", "PageDown", "End"], Tv = [...Rv, ...fc], Av = {
  ltr: [...Pr, "ArrowRight"],
  rtl: [...Pr, "ArrowLeft"]
}, Iv = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, _n = "Menu", [gn, Wv, Fv] = Sn(_n), [At, pc] = be(_n, [
  Fv,
  gt,
  Oo
]), On = gt(), mc = Oo(), [hc, vt] = At(_n), [Lv, Nn] = At(_n), gc = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: a, modal: s = !0 } = e, i = On(t), [l, c] = d.useState(null), p = d.useRef(!1), f = ve(a), m = Rt(r);
  return d.useEffect(() => {
    const h = () => {
      p.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => p.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ u(En, { ...i, children: /* @__PURE__ */ u(
    hc,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ u(
        Lv,
        {
          scope: t,
          onClose: d.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: p,
          dir: m,
          modal: s,
          children: o
        }
      )
    }
  ) });
};
gc.displayName = _n;
var zv = "MenuAnchor", ha = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = On(n);
    return /* @__PURE__ */ u(Pn, { ...r, ...o, ref: t });
  }
);
ha.displayName = zv;
var ga = "MenuPortal", [$v, vc] = At(ga, {
  forceMount: void 0
}), bc = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, a = vt(ga, t);
  return /* @__PURE__ */ u($v, { scope: t, forceMount: n, children: /* @__PURE__ */ u(xe, { present: n || a.open, children: /* @__PURE__ */ u(Qt, { asChild: !0, container: r, children: o }) }) });
};
bc.displayName = ga;
var Ae = "MenuContent", [Bv, va] = At(Ae), yc = d.forwardRef(
  (e, t) => {
    const n = vc(Ae, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = vt(Ae, e.__scopeMenu), s = Nn(Ae, e.__scopeMenu);
    return /* @__PURE__ */ u(gn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(xe, { present: o || a.open, children: /* @__PURE__ */ u(gn.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ u(Yv, { ...r, ref: t }) : /* @__PURE__ */ u(Hv, { ...r, ref: t }) }) }) });
  }
), Yv = d.forwardRef(
  (e, t) => {
    const n = vt(Ae, e.__scopeMenu), o = d.useRef(null), r = U(t, o);
    return d.useEffect(() => {
      const a = o.current;
      if (a) return yo(a);
    }, []), /* @__PURE__ */ u(
      ba,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: N(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Hv = d.forwardRef((e, t) => {
  const n = vt(Ae, e.__scopeMenu);
  return /* @__PURE__ */ u(
    ba,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Gv = /* @__PURE__ */ ft("MenuContent.ScrollLock"), ba = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: o = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: i,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: p,
      onFocusOutside: f,
      onInteractOutside: m,
      onDismiss: h,
      disableOutsideScroll: b,
      ...g
    } = e, v = vt(Ae, n), y = Nn(Ae, n), w = On(n), x = mc(n), S = Wv(n), [k, C] = d.useState(null), P = d.useRef(null), M = U(t, P, v.onContentChange), _ = d.useRef(0), O = d.useRef(""), A = d.useRef(0), Y = d.useRef(null), G = d.useRef("right"), H = d.useRef(0), j = b ? kn : d.Fragment, F = b ? { as: Gv, allowPinchZoom: !0 } : void 0, V = (R) => {
      const T = O.current + R, le = S().filter((I) => !I.disabled), ye = document.activeElement, Ce = le.find((I) => I.ref.current === ye)?.textValue, me = le.map((I) => I.textValue), ae = nb(me, T, Ce), te = le.find((I) => I.textValue === ae)?.ref.current;
      (function I(se) {
        O.current = se, window.clearTimeout(_.current), se !== "" && (_.current = window.setTimeout(() => I(""), 1e3));
      })(T), te && setTimeout(() => te.focus());
    };
    d.useEffect(() => () => window.clearTimeout(_.current), []), vo();
    const L = d.useCallback((R) => G.current === Y.current?.side && rb(R, Y.current?.area), []);
    return /* @__PURE__ */ u(
      Bv,
      {
        scope: n,
        searchRef: O,
        onItemEnter: d.useCallback(
          (R) => {
            L(R) && R.preventDefault();
          },
          [L]
        ),
        onItemLeave: d.useCallback(
          (R) => {
            L(R) || (P.current?.focus(), C(null));
          },
          [L]
        ),
        onTriggerLeave: d.useCallback(
          (R) => {
            L(R) && R.preventDefault();
          },
          [L]
        ),
        pointerGraceTimerRef: A,
        onPointerGraceIntentChange: d.useCallback((R) => {
          Y.current = R;
        }, []),
        children: /* @__PURE__ */ u(j, { ...F, children: /* @__PURE__ */ u(
          Cn,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: N(a, (R) => {
              R.preventDefault(), P.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ u(
              Zt,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: c,
                onPointerDownOutside: p,
                onFocusOutside: f,
                onInteractOutside: m,
                onDismiss: h,
                children: /* @__PURE__ */ u(
                  dc,
                  {
                    asChild: !0,
                    ...x,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: o,
                    currentTabStopId: k,
                    onCurrentTabStopIdChange: C,
                    onEntryFocus: N(l, (R) => {
                      y.isUsingKeyboardRef.current || R.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ u(
                      Do,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Wc(v.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...w,
                        ...g,
                        ref: M,
                        style: { outline: "none", ...g.style },
                        onKeyDown: N(g.onKeyDown, (R) => {
                          const le = R.target.closest("[data-radix-menu-content]") === R.currentTarget, ye = R.ctrlKey || R.altKey || R.metaKey, Ce = R.key.length === 1;
                          le && (R.key === "Tab" && R.preventDefault(), !ye && Ce && V(R.key));
                          const me = P.current;
                          if (R.target !== me || !Tv.includes(R.key)) return;
                          R.preventDefault();
                          const te = S().filter((I) => !I.disabled).map((I) => I.ref.current);
                          fc.includes(R.key) && te.reverse(), eb(te);
                        }),
                        onBlur: N(e.onBlur, (R) => {
                          R.currentTarget.contains(R.target) || (window.clearTimeout(_.current), O.current = "");
                        }),
                        onPointerMove: N(
                          e.onPointerMove,
                          vn((R) => {
                            const T = R.target, le = H.current !== R.clientX;
                            if (R.currentTarget.contains(T) && le) {
                              const ye = R.clientX > H.current ? "right" : "left";
                              G.current = ye, H.current = R.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
yc.displayName = Ae;
var Vv = "MenuGroup", ya = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ u(z.div, { role: "group", ...o, ref: t });
  }
);
ya.displayName = Vv;
var Uv = "MenuLabel", wc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ u(z.div, { ...o, ref: t });
  }
);
wc.displayName = Uv;
var oo = "MenuItem", Ds = "menu.itemSelect", No = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: o, ...r } = e, a = d.useRef(null), s = Nn(oo, e.__scopeMenu), i = va(oo, e.__scopeMenu), l = U(t, a), c = d.useRef(!1), p = () => {
      const f = a.current;
      if (!n && f) {
        const m = new CustomEvent(Ds, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Ds, (h) => o?.(h), { once: !0 }), yi(f, m), m.defaultPrevented ? c.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ u(
      xc,
      {
        ...r,
        ref: l,
        disabled: n,
        onClick: N(e.onClick, p),
        onPointerDown: (f) => {
          e.onPointerDown?.(f), c.current = !0;
        },
        onPointerUp: N(e.onPointerUp, (f) => {
          c.current || f.currentTarget?.click();
        }),
        onKeyDown: N(e.onKeyDown, (f) => {
          const m = i.searchRef.current !== "";
          n || m && f.key === " " || Pr.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
No.displayName = oo;
var xc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: o = !1, textValue: r, ...a } = e, s = va(oo, n), i = mc(n), l = d.useRef(null), c = U(t, l), [p, f] = d.useState(!1), [m, h] = d.useState("");
    return d.useEffect(() => {
      const b = l.current;
      b && h((b.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ u(
      gn.ItemSlot,
      {
        scope: n,
        disabled: o,
        textValue: r ?? m,
        children: /* @__PURE__ */ u(uc, { asChild: !0, ...i, focusable: !o, children: /* @__PURE__ */ u(
          z.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": o || void 0,
            "data-disabled": o ? "" : void 0,
            ...a,
            ref: c,
            onPointerMove: N(
              e.onPointerMove,
              vn((b) => {
                o ? s.onItemLeave(b) : (s.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: N(
              e.onPointerLeave,
              vn((b) => s.onItemLeave(b))
            ),
            onFocus: N(e.onFocus, () => f(!0)),
            onBlur: N(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), jv = "MenuCheckboxItem", Sc = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: o, ...r } = e;
    return /* @__PURE__ */ u(Pc, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ u(
      No,
      {
        role: "menuitemcheckbox",
        "aria-checked": ro(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": Sa(n),
        onSelect: N(
          r.onSelect,
          () => o?.(ro(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Sc.displayName = jv;
var Cc = "MenuRadioGroup", [Kv, qv] = At(
  Cc,
  { value: void 0, onValueChange: () => {
  } }
), kc = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: o, ...r } = e, a = ve(o);
    return /* @__PURE__ */ u(Kv, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ u(ya, { ...r, ref: t }) });
  }
);
kc.displayName = Cc;
var Mc = "MenuRadioItem", Ec = d.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = qv(Mc, e.__scopeMenu), a = n === r.value;
    return /* @__PURE__ */ u(Pc, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ u(
      No,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...o,
        ref: t,
        "data-state": Sa(a),
        onSelect: N(
          o.onSelect,
          () => r.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ec.displayName = Mc;
var wa = "MenuItemIndicator", [Pc, Xv] = At(
  wa,
  { checked: !1 }
), Dc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: o, ...r } = e, a = Xv(wa, n);
    return /* @__PURE__ */ u(
      xe,
      {
        present: o || ro(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u(
          z.span,
          {
            ...r,
            ref: t,
            "data-state": Sa(a.checked)
          }
        )
      }
    );
  }
);
Dc.displayName = wa;
var Zv = "MenuSeparator", _c = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ u(
      z.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...o,
        ref: t
      }
    );
  }
);
_c.displayName = Zv;
var Qv = "MenuArrow", Oc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = On(n);
    return /* @__PURE__ */ u(_o, { ...r, ...o, ref: t });
  }
);
Oc.displayName = Qv;
var xa = "MenuSub", [Jv, Nc] = At(xa), Rc = (e) => {
  const { __scopeMenu: t, children: n, open: o = !1, onOpenChange: r } = e, a = vt(xa, t), s = On(t), [i, l] = d.useState(null), [c, p] = d.useState(null), f = ve(r);
  return d.useEffect(() => (a.open === !1 && f(!1), () => f(!1)), [a.open, f]), /* @__PURE__ */ u(En, { ...s, children: /* @__PURE__ */ u(
    hc,
    {
      scope: t,
      open: o,
      onOpenChange: f,
      content: c,
      onContentChange: p,
      children: /* @__PURE__ */ u(
        Jv,
        {
          scope: t,
          contentId: Ee(),
          triggerId: Ee(),
          trigger: i,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Rc.displayName = xa;
var dn = "MenuSubTrigger", Tc = d.forwardRef(
  (e, t) => {
    const n = vt(dn, e.__scopeMenu), o = Nn(dn, e.__scopeMenu), r = Nc(dn, e.__scopeMenu), a = va(dn, e.__scopeMenu), s = d.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: l } = a, c = { __scopeMenu: e.__scopeMenu }, p = d.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return d.useEffect(() => p, [p]), d.useEffect(() => {
      const f = i.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [i, l]), /* @__PURE__ */ u(ha, { asChild: !0, ...c, children: /* @__PURE__ */ u(
      xc,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": Wc(n.open),
        ...e,
        ref: po(t, r.onTriggerChange),
        onClick: (f) => {
          e.onClick?.(f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: N(
          e.onPointerMove,
          vn((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (a.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: N(
          e.onPointerLeave,
          vn((f) => {
            p();
            const m = n.content?.getBoundingClientRect();
            if (m) {
              const h = n.content?.dataset.side, b = h === "right", g = b ? -5 : 5, v = m[b ? "left" : "right"], y = m[b ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + g, y: f.clientY },
                  { x: v, y: m.top },
                  { x: y, y: m.top },
                  { x: y, y: m.bottom },
                  { x: v, y: m.bottom }
                ],
                side: h
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: N(e.onKeyDown, (f) => {
          const m = a.searchRef.current !== "";
          e.disabled || m && f.key === " " || Av[o.dir].includes(f.key) && (n.onOpenChange(!0), n.content?.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Tc.displayName = dn;
var Ac = "MenuSubContent", Ic = d.forwardRef(
  (e, t) => {
    const n = vc(Ae, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = vt(Ae, e.__scopeMenu), s = Nn(Ae, e.__scopeMenu), i = Nc(Ac, e.__scopeMenu), l = d.useRef(null), c = U(t, l);
    return /* @__PURE__ */ u(gn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(xe, { present: o || a.open, children: /* @__PURE__ */ u(gn.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(
      ba,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...r,
        ref: c,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          s.isUsingKeyboardRef.current && l.current?.focus(), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: N(e.onFocusOutside, (p) => {
          p.target !== i.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: N(e.onEscapeKeyDown, (p) => {
          s.onClose(), p.preventDefault();
        }),
        onKeyDown: N(e.onKeyDown, (p) => {
          const f = p.currentTarget.contains(p.target), m = Iv[s.dir].includes(p.key);
          f && m && (a.onOpenChange(!1), i.trigger?.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
Ic.displayName = Ac;
function Wc(e) {
  return e ? "open" : "closed";
}
function ro(e) {
  return e === "indeterminate";
}
function Sa(e) {
  return ro(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function eb(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function tb(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
function nb(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = tb(e, Math.max(a, 0));
  r.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function ob(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], l = t[s], c = i.x, p = i.y, f = l.x, m = l.y;
    p > o != m > o && n < (f - c) * (o - p) / (m - p) + c && (r = !r);
  }
  return r;
}
function rb(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return ob(n, t);
}
function vn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var ab = gc, sb = ha, ib = bc, lb = yc, cb = ya, db = wc, ub = No, fb = Sc, pb = kc, mb = Ec, hb = Dc, gb = _c, vb = Oc, bb = Rc, yb = Tc, wb = Ic, Ro = "DropdownMenu", [xb] = be(
  Ro,
  [pc]
), Me = pc(), [Sb, Fc] = xb(Ro), Lc = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: o,
    open: r,
    defaultOpen: a,
    onOpenChange: s,
    modal: i = !0
  } = e, l = Me(t), c = d.useRef(null), [p, f] = Se({
    prop: r,
    defaultProp: a ?? !1,
    onChange: s,
    caller: Ro
  });
  return /* @__PURE__ */ u(
    Sb,
    {
      scope: t,
      triggerId: Ee(),
      triggerRef: c,
      contentId: Ee(),
      open: p,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((m) => !m), [f]),
      modal: i,
      children: /* @__PURE__ */ u(ab, { ...l, open: p, onOpenChange: f, dir: o, modal: i, children: n })
    }
  );
};
Lc.displayName = Ro;
var zc = "DropdownMenuTrigger", $c = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, a = Fc(zc, n), s = Me(n);
    return /* @__PURE__ */ u(sb, { asChild: !0, ...s, children: /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": o ? "" : void 0,
        disabled: o,
        ...r,
        ref: po(t, a.triggerRef),
        onPointerDown: N(e.onPointerDown, (i) => {
          !o && i.button === 0 && i.ctrlKey === !1 && (a.onOpenToggle(), a.open || i.preventDefault());
        }),
        onKeyDown: N(e.onKeyDown, (i) => {
          o || (["Enter", " "].includes(i.key) && a.onOpenToggle(), i.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
$c.displayName = zc;
var Cb = "DropdownMenuPortal", Bc = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = Me(t);
  return /* @__PURE__ */ u(ib, { ...o, ...n });
};
Bc.displayName = Cb;
var Yc = "DropdownMenuContent", Hc = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Fc(Yc, n), a = Me(n), s = d.useRef(!1);
    return /* @__PURE__ */ u(
      lb,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...o,
        ref: t,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (i) => {
          s.current || r.triggerRef.current?.focus(), s.current = !1, i.preventDefault();
        }),
        onInteractOutside: N(e.onInteractOutside, (i) => {
          const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, p = l.button === 2 || c;
          (!r.modal || p) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Hc.displayName = Yc;
var kb = "DropdownMenuGroup", Gc = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
    return /* @__PURE__ */ u(cb, { ...r, ...o, ref: t });
  }
);
Gc.displayName = kb;
var Mb = "DropdownMenuLabel", Vc = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
    return /* @__PURE__ */ u(db, { ...r, ...o, ref: t });
  }
);
Vc.displayName = Mb;
var Eb = "DropdownMenuItem", Uc = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
    return /* @__PURE__ */ u(ub, { ...r, ...o, ref: t });
  }
);
Uc.displayName = Eb;
var Pb = "DropdownMenuCheckboxItem", jc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(fb, { ...r, ...o, ref: t });
});
jc.displayName = Pb;
var Db = "DropdownMenuRadioGroup", Kc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(pb, { ...r, ...o, ref: t });
});
Kc.displayName = Db;
var _b = "DropdownMenuRadioItem", qc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(mb, { ...r, ...o, ref: t });
});
qc.displayName = _b;
var Ob = "DropdownMenuItemIndicator", Xc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(hb, { ...r, ...o, ref: t });
});
Xc.displayName = Ob;
var Nb = "DropdownMenuSeparator", Zc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(gb, { ...r, ...o, ref: t });
});
Zc.displayName = Nb;
var Rb = "DropdownMenuArrow", Tb = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
    return /* @__PURE__ */ u(vb, { ...r, ...o, ref: t });
  }
);
Tb.displayName = Rb;
var Ab = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: o, onOpenChange: r, defaultOpen: a } = e, s = Me(t), [i, l] = Se({
    prop: o,
    defaultProp: a ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ u(bb, { ...s, open: i, onOpenChange: l, children: n });
}, Ib = "DropdownMenuSubTrigger", Qc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(yb, { ...r, ...o, ref: t });
});
Qc.displayName = Ib;
var Wb = "DropdownMenuSubContent", Jc = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Me(n);
  return /* @__PURE__ */ u(
    wb,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Jc.displayName = Wb;
var Fb = Lc, Lb = $c, ed = Bc, zb = Hc, $b = Gc, Bb = Vc, Yb = Uc, Hb = jc, Gb = Kc, Vb = qc, td = Xc, Ub = Zc, jb = Ab, Kb = Qc, qb = Jc, Xb = "Label", nd = d.forwardRef((e, t) => /* @__PURE__ */ u(
  z.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
nd.displayName = Xb;
var Zb = nd;
function bn(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var To = "Popover", [od] = be(To, [
  gt
]), Rn = gt(), [Qb, bt] = od(To), rd = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: s = !1
  } = e, i = Rn(t), l = d.useRef(null), [c, p] = d.useState(!1), [f, m] = Se({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: To
  });
  return /* @__PURE__ */ u(En, { ...i, children: /* @__PURE__ */ u(
    Qb,
    {
      scope: t,
      contentId: Ee(),
      triggerRef: l,
      open: f,
      onOpenChange: m,
      onOpenToggle: d.useCallback(() => m((h) => !h), [m]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: d.useCallback(() => p(!0), []),
      onCustomAnchorRemove: d.useCallback(() => p(!1), []),
      modal: s,
      children: n
    }
  ) });
};
rd.displayName = To;
var ad = "PopoverAnchor", Jb = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = bt(ad, n), a = Rn(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: i } = r;
    return d.useEffect(() => (s(), () => i()), [s, i]), /* @__PURE__ */ u(Pn, { ...a, ...o, ref: t });
  }
);
Jb.displayName = ad;
var sd = "PopoverTrigger", id = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = bt(sd, n), a = Rn(n), s = U(t, r.triggerRef), i = /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": fd(r.open),
        ...o,
        ref: s,
        onClick: N(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? i : /* @__PURE__ */ u(Pn, { asChild: !0, ...a, children: i });
  }
);
id.displayName = sd;
var Ca = "PopoverPortal", [ey, ty] = od(Ca, {
  forceMount: void 0
}), ld = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, a = bt(Ca, t);
  return /* @__PURE__ */ u(ey, { scope: t, forceMount: n, children: /* @__PURE__ */ u(xe, { present: n || a.open, children: /* @__PURE__ */ u(Qt, { asChild: !0, container: r, children: o }) }) });
};
ld.displayName = Ca;
var Ut = "PopoverContent", cd = d.forwardRef(
  (e, t) => {
    const n = ty(Ut, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, a = bt(Ut, e.__scopePopover);
    return /* @__PURE__ */ u(xe, { present: o || a.open, children: a.modal ? /* @__PURE__ */ u(oy, { ...r, ref: t }) : /* @__PURE__ */ u(ry, { ...r, ref: t }) });
  }
);
cd.displayName = Ut;
var ny = /* @__PURE__ */ ft("PopoverContent.RemoveScroll"), oy = d.forwardRef(
  (e, t) => {
    const n = bt(Ut, e.__scopePopover), o = d.useRef(null), r = U(t, o), a = d.useRef(!1);
    return d.useEffect(() => {
      const s = o.current;
      if (s) return yo(s);
    }, []), /* @__PURE__ */ u(kn, { as: ny, allowPinchZoom: !0, children: /* @__PURE__ */ u(
      dd,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (s) => {
          s.preventDefault(), a.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: N(
          e.onPointerDownOutside,
          (s) => {
            const i = s.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0, c = i.button === 2 || l;
            a.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: N(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), ry = d.forwardRef(
  (e, t) => {
    const n = bt(Ut, e.__scopePopover), o = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ u(
      dd,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (o.current || n.triggerRef.current?.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const s = a.target;
          n.triggerRef.current?.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), dd = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: o,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: p,
      ...f
    } = e, m = bt(Ut, n), h = Rn(n);
    return vo(), /* @__PURE__ */ u(
      Cn,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u(
          Zt,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: p,
            onEscapeKeyDown: i,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ u(
              Do,
              {
                "data-state": fd(m.open),
                role: "dialog",
                id: m.contentId,
                ...h,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), ud = "PopoverClose", ay = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = bt(ud, n);
    return /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: N(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
ay.displayName = ud;
var sy = "PopoverArrow", iy = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = Rn(n);
    return /* @__PURE__ */ u(_o, { ...r, ...o, ref: t });
  }
);
iy.displayName = sy;
function fd(e) {
  return e ? "open" : "closed";
}
var ly = rd, cy = id, dy = ld, uy = cd, ka = "Progress", Ma = 100, [fy] = be(ka), [py, my] = fy(ka), pd = d.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: o = null,
      max: r,
      getValueLabel: a = hy,
      ...s
    } = e;
    (r || r === 0) && !_s(r) && console.error(gy(`${r}`, "Progress"));
    const i = _s(r) ? r : Ma;
    o !== null && !Os(o, i) && console.error(vy(`${o}`, "Progress"));
    const l = Os(o, i) ? o : null, c = ao(l) ? a(l, i) : void 0;
    return /* @__PURE__ */ u(py, { scope: n, value: l, max: i, children: /* @__PURE__ */ u(
      z.div,
      {
        "aria-valuemax": i,
        "aria-valuemin": 0,
        "aria-valuenow": ao(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": gd(l, i),
        "data-value": l ?? void 0,
        "data-max": i,
        ...s,
        ref: t
      }
    ) });
  }
);
pd.displayName = ka;
var md = "ProgressIndicator", hd = d.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...o } = e, r = my(md, n);
    return /* @__PURE__ */ u(
      z.div,
      {
        "data-state": gd(r.value, r.max),
        "data-value": r.value ?? void 0,
        "data-max": r.max,
        ...o,
        ref: t
      }
    );
  }
);
hd.displayName = md;
function hy(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function gd(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function ao(e) {
  return typeof e == "number";
}
function _s(e) {
  return ao(e) && !isNaN(e) && e > 0;
}
function Os(e, t) {
  return ao(e) && !isNaN(e) && e <= t && e >= 0;
}
function gy(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Ma}\`.`;
}
function vy(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Ma} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var by = pd, yy = hd;
function wy(e, t) {
  return d.useReducer((n, o) => t[n][o] ?? n, e);
}
var Ea = "ScrollArea", [vd] = be(Ea), [xy, Ie] = vd(Ea), bd = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: r,
      scrollHideDelay: a = 600,
      ...s
    } = e, [i, l] = d.useState(null), [c, p] = d.useState(null), [f, m] = d.useState(null), [h, b] = d.useState(null), [g, v] = d.useState(null), [y, w] = d.useState(0), [x, S] = d.useState(0), [k, C] = d.useState(!1), [P, M] = d.useState(!1), _ = U(t, (A) => l(A)), O = Rt(r);
    return /* @__PURE__ */ u(
      xy,
      {
        scope: n,
        type: o,
        dir: O,
        scrollHideDelay: a,
        scrollArea: i,
        viewport: c,
        onViewportChange: p,
        content: f,
        onContentChange: m,
        scrollbarX: h,
        onScrollbarXChange: b,
        scrollbarXEnabled: k,
        onScrollbarXEnabledChange: C,
        scrollbarY: g,
        onScrollbarYChange: v,
        scrollbarYEnabled: P,
        onScrollbarYEnabledChange: M,
        onCornerWidthChange: w,
        onCornerHeightChange: S,
        children: /* @__PURE__ */ u(
          z.div,
          {
            dir: O,
            ...s,
            ref: _,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": y + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
bd.displayName = Ea;
var yd = "ScrollAreaViewport", wd = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: r, ...a } = e, s = Ie(yd, n), i = d.useRef(null), l = U(t, i, s.onViewportChange);
    return /* @__PURE__ */ Q(ut, { children: [
      /* @__PURE__ */ u(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ u(
        z.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ u("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
wd.displayName = yd;
var Xe = "ScrollAreaScrollbar", xd = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Ie(Xe, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: s } = r, i = e.orientation === "horizontal";
    return d.useEffect(() => (i ? a(!0) : s(!0), () => {
      i ? a(!1) : s(!1);
    }), [i, a, s]), r.type === "hover" ? /* @__PURE__ */ u(Sy, { ...o, ref: t, forceMount: n }) : r.type === "scroll" ? /* @__PURE__ */ u(Cy, { ...o, ref: t, forceMount: n }) : r.type === "auto" ? /* @__PURE__ */ u(Sd, { ...o, ref: t, forceMount: n }) : r.type === "always" ? /* @__PURE__ */ u(Pa, { ...o, ref: t }) : null;
  }
);
xd.displayName = Xe;
var Sy = d.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Ie(Xe, e.__scopeScrollArea), [a, s] = d.useState(!1);
  return d.useEffect(() => {
    const i = r.scrollArea;
    let l = 0;
    if (i) {
      const c = () => {
        window.clearTimeout(l), s(!0);
      }, p = () => {
        l = window.setTimeout(() => s(!1), r.scrollHideDelay);
      };
      return i.addEventListener("pointerenter", c), i.addEventListener("pointerleave", p), () => {
        window.clearTimeout(l), i.removeEventListener("pointerenter", c), i.removeEventListener("pointerleave", p);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ u(xe, { present: n || a, children: /* @__PURE__ */ u(
    Sd,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Cy = d.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Ie(Xe, e.__scopeScrollArea), a = e.orientation === "horizontal", s = Io(() => l("SCROLL_END"), 100), [i, l] = wy("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (i === "idle") {
      const c = window.setTimeout(() => l("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [i, r.scrollHideDelay, l]), d.useEffect(() => {
    const c = r.viewport, p = a ? "scrollLeft" : "scrollTop";
    if (c) {
      let f = c[p];
      const m = () => {
        const h = c[p];
        f !== h && (l("SCROLL"), s()), f = h;
      };
      return c.addEventListener("scroll", m), () => c.removeEventListener("scroll", m);
    }
  }, [r.viewport, a, l, s]), /* @__PURE__ */ u(xe, { present: n || i !== "hidden", children: /* @__PURE__ */ u(
    Pa,
    {
      "data-state": i === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: N(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: N(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Sd = d.forwardRef((e, t) => {
  const n = Ie(Xe, e.__scopeScrollArea), { forceMount: o, ...r } = e, [a, s] = d.useState(!1), i = e.orientation === "horizontal", l = Io(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, p = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(i ? c : p);
    }
  }, 10);
  return jt(n.viewport, l), jt(n.content, l), /* @__PURE__ */ u(xe, { present: o || a, children: /* @__PURE__ */ u(
    Pa,
    {
      "data-state": a ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), Pa = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, r = Ie(Xe, e.__scopeScrollArea), a = d.useRef(null), s = d.useRef(0), [i, l] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Pd(i.viewport, i.content), p = {
    ...o,
    sizes: i,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (m) => a.current = m,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (m) => s.current = m
  };
  function f(m, h) {
    return _y(m, s.current, i, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ u(
    ky,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollLeft, h = Ns(m, i, r.dir);
          a.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = f(m, r.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ u(
    My,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollTop, h = Ns(m, i);
          a.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = f(m));
      }
    }
  ) : null;
}), ky = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = Ie(Xe, e.__scopeScrollArea), [s, i] = d.useState(), l = d.useRef(null), c = U(t, l, a.onScrollbarXChange);
  return d.useEffect(() => {
    l.current && i(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ u(
    kd,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Ao(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.x),
      onDragScroll: (p) => e.onDragScroll(p.x),
      onWheelScroll: (p, f) => {
        if (a.viewport) {
          const m = a.viewport.scrollLeft + p.deltaX;
          e.onWheelScroll(m), _d(m, f) && p.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && s && o({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: io(s.paddingLeft),
            paddingEnd: io(s.paddingRight)
          }
        });
      }
    }
  );
}), My = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = Ie(Xe, e.__scopeScrollArea), [s, i] = d.useState(), l = d.useRef(null), c = U(t, l, a.onScrollbarYChange);
  return d.useEffect(() => {
    l.current && i(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ u(
    kd,
    {
      "data-orientation": "vertical",
      ...r,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Ao(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.y),
      onDragScroll: (p) => e.onDragScroll(p.y),
      onWheelScroll: (p, f) => {
        if (a.viewport) {
          const m = a.viewport.scrollTop + p.deltaY;
          e.onWheelScroll(m), _d(m, f) && p.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && s && o({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: io(s.paddingTop),
            paddingEnd: io(s.paddingBottom)
          }
        });
      }
    }
  );
}), [Ey, Cd] = vd(Xe), kd = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: r,
    onThumbChange: a,
    onThumbPointerUp: s,
    onThumbPointerDown: i,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: p,
    onResize: f,
    ...m
  } = e, h = Ie(Xe, n), [b, g] = d.useState(null), v = U(t, (_) => g(_)), y = d.useRef(null), w = d.useRef(""), x = h.viewport, S = o.content - o.viewport, k = ve(p), C = ve(l), P = Io(f, 10);
  function M(_) {
    if (y.current) {
      const O = _.clientX - y.current.left, A = _.clientY - y.current.top;
      c({ x: O, y: A });
    }
  }
  return d.useEffect(() => {
    const _ = (O) => {
      const A = O.target;
      b?.contains(A) && k(O, S);
    };
    return document.addEventListener("wheel", _, { passive: !1 }), () => document.removeEventListener("wheel", _, { passive: !1 });
  }, [x, b, S, k]), d.useEffect(C, [o, C]), jt(b, P), jt(h.content, P), /* @__PURE__ */ u(
    Ey,
    {
      scope: n,
      scrollbar: b,
      hasThumb: r,
      onThumbChange: ve(a),
      onThumbPointerUp: ve(s),
      onThumbPositionChange: C,
      onThumbPointerDown: ve(i),
      children: /* @__PURE__ */ u(
        z.div,
        {
          ...m,
          ref: v,
          style: { position: "absolute", ...m.style },
          onPointerDown: N(e.onPointerDown, (_) => {
            _.button === 0 && (_.target.setPointerCapture(_.pointerId), y.current = b.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), M(_));
          }),
          onPointerMove: N(e.onPointerMove, M),
          onPointerUp: N(e.onPointerUp, (_) => {
            const O = _.target;
            O.hasPointerCapture(_.pointerId) && O.releasePointerCapture(_.pointerId), document.body.style.webkitUserSelect = w.current, h.viewport && (h.viewport.style.scrollBehavior = ""), y.current = null;
          })
        }
      )
    }
  );
}), so = "ScrollAreaThumb", Md = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Cd(so, e.__scopeScrollArea);
    return /* @__PURE__ */ u(xe, { present: n || r.hasThumb, children: /* @__PURE__ */ u(Py, { ref: t, ...o }) });
  }
), Py = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...r } = e, a = Ie(so, n), s = Cd(so, n), { onThumbPositionChange: i } = s, l = U(
      t,
      (f) => s.onThumbChange(f)
    ), c = d.useRef(void 0), p = Io(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const f = a.viewport;
      if (f) {
        const m = () => {
          if (p(), !c.current) {
            const h = Oy(f, i);
            c.current = h, i();
          }
        };
        return i(), f.addEventListener("scroll", m), () => f.removeEventListener("scroll", m);
      }
    }, [a.viewport, p, i]), /* @__PURE__ */ u(
      z.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...r,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: N(e.onPointerDownCapture, (f) => {
          const h = f.target.getBoundingClientRect(), b = f.clientX - h.left, g = f.clientY - h.top;
          s.onThumbPointerDown({ x: b, y: g });
        }),
        onPointerUp: N(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
Md.displayName = so;
var Da = "ScrollAreaCorner", Ed = d.forwardRef(
  (e, t) => {
    const n = Ie(Da, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ u(Dy, { ...e, ref: t }) : null;
  }
);
Ed.displayName = Da;
var Dy = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, r = Ie(Da, n), [a, s] = d.useState(0), [i, l] = d.useState(0), c = !!(a && i);
  return jt(r.scrollbarX, () => {
    const p = r.scrollbarX?.offsetHeight || 0;
    r.onCornerHeightChange(p), l(p);
  }), jt(r.scrollbarY, () => {
    const p = r.scrollbarY?.offsetWidth || 0;
    r.onCornerWidthChange(p), s(p);
  }), c ? /* @__PURE__ */ u(
    z.div,
    {
      ...o,
      ref: t,
      style: {
        width: a,
        height: i,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function io(e) {
  return e ? parseInt(e, 10) : 0;
}
function Pd(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Ao(e) {
  const t = Pd(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function _y(e, t, n, o = "ltr") {
  const r = Ao(n), a = r / 2, s = t || a, i = r - s, l = n.scrollbar.paddingStart + s, c = n.scrollbar.size - n.scrollbar.paddingEnd - i, p = n.content - n.viewport, f = o === "ltr" ? [0, p] : [p * -1, 0];
  return Dd([l, c], f)(e);
}
function Ns(e, t, n = "ltr") {
  const o = Ao(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - r, s = t.content - t.viewport, i = a - o, l = n === "ltr" ? [0, s] : [s * -1, 0], c = bn(e, l);
  return Dd([0, s], [0, i])(c);
}
function Dd(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function _d(e, t) {
  return e > 0 && e < t;
}
var Oy = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return (function r() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== a.left, i = n.top !== a.top;
    (s || i) && t(), n = a, o = window.requestAnimationFrame(r);
  })(), () => window.cancelAnimationFrame(o);
};
function Io(e, t) {
  const n = ve(e), o = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(o.current), []), d.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function jt(e, t) {
  const n = ve(t);
  pe(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
var Ny = bd, Ry = wd, Ty = Ed, Ay = [" ", "Enter", "ArrowUp", "ArrowDown"], Iy = [" ", "Enter"], _t = "Select", [Wo, Fo, Wy] = Sn(_t), [tn] = be(_t, [
  Wy,
  gt
]), Lo = gt(), [Fy, yt] = tn(_t), [Ly, zy] = tn(_t), Od = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    value: s,
    defaultValue: i,
    onValueChange: l,
    dir: c,
    name: p,
    autoComplete: f,
    disabled: m,
    required: h,
    form: b
  } = e, g = Lo(t), [v, y] = d.useState(null), [w, x] = d.useState(null), [S, k] = d.useState(!1), C = Rt(c), [P, M] = Se({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: _t
  }), [_, O] = Se({
    prop: s,
    defaultProp: i,
    onChange: l,
    caller: _t
  }), A = d.useRef(null), Y = v ? b || !!v.closest("form") : !0, [G, H] = d.useState(/* @__PURE__ */ new Set()), j = Array.from(G).map((F) => F.props.value).join(";");
  return /* @__PURE__ */ u(En, { ...g, children: /* @__PURE__ */ Q(
    Fy,
    {
      required: h,
      scope: t,
      trigger: v,
      onTriggerChange: y,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: k,
      contentId: Ee(),
      value: _,
      onValueChange: O,
      open: P,
      onOpenChange: M,
      dir: C,
      triggerPointerDownPosRef: A,
      disabled: m,
      children: [
        /* @__PURE__ */ u(Wo.Provider, { scope: t, children: /* @__PURE__ */ u(
          Ly,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((F) => {
              H((V) => new Set(V).add(F));
            }, []),
            onNativeOptionRemove: d.useCallback((F) => {
              H((V) => {
                const L = new Set(V);
                return L.delete(F), L;
              });
            }, []),
            children: n
          }
        ) }),
        Y ? /* @__PURE__ */ Q(
          tu,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: p,
            autoComplete: f,
            value: _,
            onChange: (F) => O(F.target.value),
            disabled: m,
            form: b,
            children: [
              _ === void 0 ? /* @__PURE__ */ u("option", { value: "" }) : null,
              Array.from(G)
            ]
          },
          j
        ) : null
      ]
    }
  ) });
};
Od.displayName = _t;
var Nd = "SelectTrigger", Rd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, a = Lo(n), s = yt(Nd, n), i = s.disabled || o, l = U(t, s.onTriggerChange), c = Fo(n), p = d.useRef("touch"), [f, m, h] = ou((g) => {
      const v = c().filter((x) => !x.disabled), y = v.find((x) => x.value === s.value), w = ru(v, g, y);
      w !== void 0 && s.onValueChange(w.value);
    }), b = (g) => {
      i || (s.onOpenChange(!0), h()), g && (s.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ u(Pn, { asChild: !0, ...a, children: /* @__PURE__ */ u(
      z.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": nu(s.value) ? "" : void 0,
        ...r,
        ref: l,
        onClick: N(r.onClick, (g) => {
          g.currentTarget.focus(), p.current !== "mouse" && b(g);
        }),
        onPointerDown: N(r.onPointerDown, (g) => {
          p.current = g.pointerType;
          const v = g.target;
          v.hasPointerCapture(g.pointerId) && v.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (b(g), g.preventDefault());
        }),
        onKeyDown: N(r.onKeyDown, (g) => {
          const v = f.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && m(g.key), !(v && g.key === " ") && Ay.includes(g.key) && (b(), g.preventDefault());
        })
      }
    ) });
  }
);
Rd.displayName = Nd;
var Td = "SelectValue", Ad = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: a, placeholder: s = "", ...i } = e, l = yt(Td, n), { onValueNodeHasChildrenChange: c } = l, p = a !== void 0, f = U(t, l.onValueNodeChange);
    return pe(() => {
      c(p);
    }, [c, p]), /* @__PURE__ */ u(
      z.span,
      {
        ...i,
        ref: f,
        style: { pointerEvents: "none" },
        children: nu(l.value) ? /* @__PURE__ */ u(ut, { children: s }) : a
      }
    );
  }
);
Ad.displayName = Td;
var $y = "SelectIcon", Id = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ u(z.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
Id.displayName = $y;
var By = "SelectPortal", Wd = (e) => /* @__PURE__ */ u(Qt, { asChild: !0, ...e });
Wd.displayName = By;
var Ot = "SelectContent", Fd = d.forwardRef(
  (e, t) => {
    const n = yt(Ot, e.__scopeSelect), [o, r] = d.useState();
    if (pe(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? fo.createPortal(
        /* @__PURE__ */ u(Ld, { scope: e.__scopeSelect, children: /* @__PURE__ */ u(Wo.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ u("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ u(zd, { ...e, ref: t });
  }
);
Fd.displayName = Ot;
var Fe = 10, [Ld, wt] = tn(Ot), Yy = "SelectContentImpl", Hy = /* @__PURE__ */ ft("SelectContent.RemoveScroll"), zd = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: i,
      sideOffset: l,
      align: c,
      alignOffset: p,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: b,
      hideWhenDetached: g,
      avoidCollisions: v,
      //
      ...y
    } = e, w = yt(Ot, n), [x, S] = d.useState(null), [k, C] = d.useState(null), P = U(t, (I) => S(I)), [M, _] = d.useState(null), [O, A] = d.useState(
      null
    ), Y = Fo(n), [G, H] = d.useState(!1), j = d.useRef(!1);
    d.useEffect(() => {
      if (x) return yo(x);
    }, [x]), vo();
    const F = d.useCallback(
      (I) => {
        const [se, ...Z] = Y().map((de) => de.ref.current), [ee] = Z.slice(-1), oe = document.activeElement;
        for (const de of I)
          if (de === oe || (de?.scrollIntoView({ block: "nearest" }), de === se && k && (k.scrollTop = 0), de === ee && k && (k.scrollTop = k.scrollHeight), de?.focus(), document.activeElement !== oe)) return;
      },
      [Y, k]
    ), V = d.useCallback(
      () => F([M, x]),
      [F, M, x]
    );
    d.useEffect(() => {
      G && V();
    }, [G, V]);
    const { onOpenChange: L, triggerPointerDownPosRef: R } = w;
    d.useEffect(() => {
      if (x) {
        let I = { x: 0, y: 0 };
        const se = (ee) => {
          I = {
            x: Math.abs(Math.round(ee.pageX) - (R.current?.x ?? 0)),
            y: Math.abs(Math.round(ee.pageY) - (R.current?.y ?? 0))
          };
        }, Z = (ee) => {
          I.x <= 10 && I.y <= 10 ? ee.preventDefault() : x.contains(ee.target) || L(!1), document.removeEventListener("pointermove", se), R.current = null;
        };
        return R.current !== null && (document.addEventListener("pointermove", se), document.addEventListener("pointerup", Z, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", se), document.removeEventListener("pointerup", Z, { capture: !0 });
        };
      }
    }, [x, L, R]), d.useEffect(() => {
      const I = () => L(!1);
      return window.addEventListener("blur", I), window.addEventListener("resize", I), () => {
        window.removeEventListener("blur", I), window.removeEventListener("resize", I);
      };
    }, [L]);
    const [T, le] = ou((I) => {
      const se = Y().filter((oe) => !oe.disabled), Z = se.find((oe) => oe.ref.current === document.activeElement), ee = ru(se, I, Z);
      ee && setTimeout(() => ee.ref.current.focus());
    }), ye = d.useCallback(
      (I, se, Z) => {
        const ee = !j.current && !Z;
        (w.value !== void 0 && w.value === se || ee) && (_(I), ee && (j.current = !0));
      },
      [w.value]
    ), Ce = d.useCallback(() => x?.focus(), [x]), me = d.useCallback(
      (I, se, Z) => {
        const ee = !j.current && !Z;
        (w.value !== void 0 && w.value === se || ee) && A(I);
      },
      [w.value]
    ), ae = o === "popper" ? Dr : $d, te = ae === Dr ? {
      side: i,
      sideOffset: l,
      align: c,
      alignOffset: p,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: b,
      hideWhenDetached: g,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ u(
      Ld,
      {
        scope: n,
        content: x,
        viewport: k,
        onViewportChange: C,
        itemRefCallback: ye,
        selectedItem: M,
        onItemLeave: Ce,
        itemTextRefCallback: me,
        focusSelectedItem: V,
        selectedItemText: O,
        position: o,
        isPositioned: G,
        searchRef: T,
        children: /* @__PURE__ */ u(kn, { as: Hy, allowPinchZoom: !0, children: /* @__PURE__ */ u(
          Cn,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (I) => {
              I.preventDefault();
            },
            onUnmountAutoFocus: N(r, (I) => {
              w.trigger?.focus({ preventScroll: !0 }), I.preventDefault();
            }),
            children: /* @__PURE__ */ u(
              Zt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: s,
                onFocusOutside: (I) => I.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ u(
                  ae,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (I) => I.preventDefault(),
                    ...y,
                    ...te,
                    onPlaced: () => H(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: N(y.onKeyDown, (I) => {
                      const se = I.ctrlKey || I.altKey || I.metaKey;
                      if (I.key === "Tab" && I.preventDefault(), !se && I.key.length === 1 && le(I.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(I.key)) {
                        let ee = Y().filter((oe) => !oe.disabled).map((oe) => oe.ref.current);
                        if (["ArrowUp", "End"].includes(I.key) && (ee = ee.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(I.key)) {
                          const oe = I.target, de = ee.indexOf(oe);
                          ee = ee.slice(de + 1);
                        }
                        setTimeout(() => F(ee)), I.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
zd.displayName = Yy;
var Gy = "SelectItemAlignedPosition", $d = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, a = yt(Ot, n), s = wt(Ot, n), [i, l] = d.useState(null), [c, p] = d.useState(null), f = U(t, (P) => p(P)), m = Fo(n), h = d.useRef(!1), b = d.useRef(!0), { viewport: g, selectedItem: v, selectedItemText: y, focusSelectedItem: w } = s, x = d.useCallback(() => {
    if (a.trigger && a.valueNode && i && c && g && v && y) {
      const P = a.trigger.getBoundingClientRect(), M = c.getBoundingClientRect(), _ = a.valueNode.getBoundingClientRect(), O = y.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const oe = O.left - M.left, de = _.left - oe, we = P.left - de, Pe = P.width + we, It = Math.max(Pe, M.width), rn = window.innerWidth - Fe, an = bn(de, [
          Fe,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Fe, rn - It)
        ]);
        i.style.minWidth = Pe + "px", i.style.left = an + "px";
      } else {
        const oe = M.right - O.right, de = window.innerWidth - _.right - oe, we = window.innerWidth - P.right - de, Pe = P.width + we, It = Math.max(Pe, M.width), rn = window.innerWidth - Fe, an = bn(de, [
          Fe,
          Math.max(Fe, rn - It)
        ]);
        i.style.minWidth = Pe + "px", i.style.right = an + "px";
      }
      const A = m(), Y = window.innerHeight - Fe * 2, G = g.scrollHeight, H = window.getComputedStyle(c), j = parseInt(H.borderTopWidth, 10), F = parseInt(H.paddingTop, 10), V = parseInt(H.borderBottomWidth, 10), L = parseInt(H.paddingBottom, 10), R = j + F + G + L + V, T = Math.min(v.offsetHeight * 5, R), le = window.getComputedStyle(g), ye = parseInt(le.paddingTop, 10), Ce = parseInt(le.paddingBottom, 10), me = P.top + P.height / 2 - Fe, ae = Y - me, te = v.offsetHeight / 2, I = v.offsetTop + te, se = j + F + I, Z = R - se;
      if (se <= me) {
        const oe = A.length > 0 && v === A[A.length - 1].ref.current;
        i.style.bottom = "0px";
        const de = c.clientHeight - g.offsetTop - g.offsetHeight, we = Math.max(
          ae,
          te + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (oe ? Ce : 0) + de + V
        ), Pe = se + we;
        i.style.height = Pe + "px";
      } else {
        const oe = A.length > 0 && v === A[0].ref.current;
        i.style.top = "0px";
        const we = Math.max(
          me,
          j + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (oe ? ye : 0) + te
        ) + Z;
        i.style.height = we + "px", g.scrollTop = se - me + g.offsetTop;
      }
      i.style.margin = `${Fe}px 0`, i.style.minHeight = T + "px", i.style.maxHeight = Y + "px", o?.(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    i,
    c,
    g,
    v,
    y,
    a.dir,
    o
  ]);
  pe(() => x(), [x]);
  const [S, k] = d.useState();
  pe(() => {
    c && k(window.getComputedStyle(c).zIndex);
  }, [c]);
  const C = d.useCallback(
    (P) => {
      P && b.current === !0 && (x(), w?.(), b.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ u(
    Uy,
    {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: C,
      children: /* @__PURE__ */ u(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ u(
            z.div,
            {
              ...r,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
$d.displayName = Gy;
var Vy = "SelectPopperPosition", Dr = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = Fe,
    ...a
  } = e, s = Lo(n);
  return /* @__PURE__ */ u(
    Do,
    {
      ...s,
      ...a,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Dr.displayName = Vy;
var [Uy, _a] = tn(Ot, {}), _r = "SelectViewport", Bd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, a = wt(_r, n), s = _a(_r, n), i = U(t, a.onViewportChange), l = d.useRef(0);
    return /* @__PURE__ */ Q(ut, { children: [
      /* @__PURE__ */ u(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ u(Wo.Slot, { scope: n, children: /* @__PURE__ */ u(
        z.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: N(r.onScroll, (c) => {
            const p = c.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: m } = s;
            if (m?.current && f) {
              const h = Math.abs(l.current - p.scrollTop);
              if (h > 0) {
                const b = window.innerHeight - Fe * 2, g = parseFloat(f.style.minHeight), v = parseFloat(f.style.height), y = Math.max(g, v);
                if (y < b) {
                  const w = y + h, x = Math.min(b, w), S = w - x;
                  f.style.height = x + "px", f.style.bottom === "0px" && (p.scrollTop = S > 0 ? S : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = p.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Bd.displayName = _r;
var Yd = "SelectGroup", [jy, Ky] = tn(Yd), Hd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Ee();
    return /* @__PURE__ */ u(jy, { scope: n, id: r, children: /* @__PURE__ */ u(z.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
Hd.displayName = Yd;
var Gd = "SelectLabel", Vd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Ky(Gd, n);
    return /* @__PURE__ */ u(z.div, { id: r.id, ...o, ref: t });
  }
);
Vd.displayName = Gd;
var lo = "SelectItem", [qy, Ud] = tn(lo), jd = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: a,
      ...s
    } = e, i = yt(lo, n), l = wt(lo, n), c = i.value === o, [p, f] = d.useState(a ?? ""), [m, h] = d.useState(!1), b = U(
      t,
      (w) => l.itemRefCallback?.(w, o, r)
    ), g = Ee(), v = d.useRef("touch"), y = () => {
      r || (i.onValueChange(o), i.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ u(
      qy,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: g,
        isSelected: c,
        onItemTextChange: d.useCallback((w) => {
          f((x) => x || (w?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ u(
          Wo.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: p,
            children: /* @__PURE__ */ u(
              z.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...s,
                ref: b,
                onFocus: N(s.onFocus, () => h(!0)),
                onBlur: N(s.onBlur, () => h(!1)),
                onClick: N(s.onClick, () => {
                  v.current !== "mouse" && y();
                }),
                onPointerUp: N(s.onPointerUp, () => {
                  v.current === "mouse" && y();
                }),
                onPointerDown: N(s.onPointerDown, (w) => {
                  v.current = w.pointerType;
                }),
                onPointerMove: N(s.onPointerMove, (w) => {
                  v.current = w.pointerType, r ? l.onItemLeave?.() : v.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: N(s.onPointerLeave, (w) => {
                  w.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: N(s.onKeyDown, (w) => {
                  l.searchRef?.current !== "" && w.key === " " || (Iy.includes(w.key) && y(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
jd.displayName = lo;
var un = "SelectItemText", Kd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...a } = e, s = yt(un, n), i = wt(un, n), l = Ud(un, n), c = zy(un, n), [p, f] = d.useState(null), m = U(
      t,
      (y) => f(y),
      l.onItemTextChange,
      (y) => i.itemTextRefCallback?.(y, l.value, l.disabled)
    ), h = p?.textContent, b = d.useMemo(
      () => /* @__PURE__ */ u("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: v } = c;
    return pe(() => (g(b), () => v(b)), [g, v, b]), /* @__PURE__ */ Q(ut, { children: [
      /* @__PURE__ */ u(z.span, { id: l.textId, ...a, ref: m }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? fo.createPortal(a.children, s.valueNode) : null
    ] });
  }
);
Kd.displayName = un;
var qd = "SelectItemIndicator", Xd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Ud(qd, n).isSelected ? /* @__PURE__ */ u(z.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
Xd.displayName = qd;
var Or = "SelectScrollUpButton", Zd = d.forwardRef((e, t) => {
  const n = wt(Or, e.__scopeSelect), o = _a(Or, e.__scopeSelect), [r, a] = d.useState(!1), s = U(t, o.onScrollButtonChange);
  return pe(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const c = l.scrollTop > 0;
        a(c);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ u(
    Jd,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Zd.displayName = Or;
var Nr = "SelectScrollDownButton", Qd = d.forwardRef((e, t) => {
  const n = wt(Nr, e.__scopeSelect), o = _a(Nr, e.__scopeSelect), [r, a] = d.useState(!1), s = U(t, o.onScrollButtonChange);
  return pe(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const c = l.scrollHeight - l.clientHeight, p = Math.ceil(l.scrollTop) < c;
        a(p);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ u(
    Jd,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Qd.displayName = Nr;
var Jd = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, a = wt("SelectScrollButton", n), s = d.useRef(null), i = Fo(n), l = d.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return d.useEffect(() => () => l(), [l]), pe(() => {
    i().find((p) => p.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ u(
    z.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: N(r.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(o, 50));
      }),
      onPointerMove: N(r.onPointerMove, () => {
        a.onItemLeave?.(), s.current === null && (s.current = window.setInterval(o, 50));
      }),
      onPointerLeave: N(r.onPointerLeave, () => {
        l();
      })
    }
  );
}), Xy = "SelectSeparator", eu = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ u(z.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
eu.displayName = Xy;
var Rr = "SelectArrow", Zy = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Lo(n), a = yt(Rr, n), s = wt(Rr, n);
    return a.open && s.position === "popper" ? /* @__PURE__ */ u(_o, { ...r, ...o, ref: t }) : null;
  }
);
Zy.displayName = Rr;
var Qy = "SelectBubbleInput", tu = d.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = d.useRef(null), a = U(o, r), s = xo(t);
    return d.useEffect(() => {
      const i = r.current;
      if (!i) return;
      const l = window.HTMLSelectElement.prototype, p = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== t && p) {
        const f = new Event("change", { bubbles: !0 });
        p.call(i, t), i.dispatchEvent(f);
      }
    }, [s, t]), /* @__PURE__ */ u(
      z.select,
      {
        ...n,
        style: { ...wi, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
tu.displayName = Qy;
function nu(e) {
  return e === "" || e === void 0;
}
function ou(e) {
  const t = ve(e), n = d.useRef(""), o = d.useRef(0), r = d.useCallback(
    (s) => {
      const i = n.current + s;
      t(i), (function l(c) {
        n.current = c, window.clearTimeout(o.current), c !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      })(i);
    },
    [t]
  ), a = d.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, a];
}
function ru(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = Jy(e, Math.max(a, 0));
  r.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Jy(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var ew = Od, tw = Rd, nw = Ad, ow = Id, rw = Wd, aw = Fd, sw = Bd, iw = Hd, lw = Vd, cw = jd, dw = Kd, uw = Xd, fw = Zd, pw = Qd, mw = eu, hw = "Separator", Rs = "horizontal", gw = ["horizontal", "vertical"], au = d.forwardRef((e, t) => {
  const { decorative: n, orientation: o = Rs, ...r } = e, a = vw(o) ? o : Rs, i = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ u(
    z.div,
    {
      "data-orientation": a,
      ...i,
      ...r,
      ref: t
    }
  );
});
au.displayName = hw;
function vw(e) {
  return gw.includes(e);
}
var bw = au, su = ["PageUp", "PageDown"], iu = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], lu = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, nn = "Slider", [Tr, yw, ww] = Sn(nn), [cu] = be(nn, [
  ww
]), [xw, zo] = cu(nn), du = d.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: o = 0,
      max: r = 100,
      step: a = 1,
      orientation: s = "horizontal",
      disabled: i = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [o],
      value: p,
      onValueChange: f = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: h = !1,
      form: b,
      ...g
    } = e, v = d.useRef(/* @__PURE__ */ new Set()), y = d.useRef(0), x = s === "horizontal" ? Sw : Cw, [S = [], k] = Se({
      prop: p,
      defaultProp: c,
      onChange: (A) => {
        [...v.current][y.current]?.focus(), f(A);
      }
    }), C = d.useRef(S);
    function P(A) {
      const Y = Dw(S, A);
      O(A, Y);
    }
    function M(A) {
      O(A, y.current);
    }
    function _() {
      const A = C.current[y.current];
      S[y.current] !== A && m(S);
    }
    function O(A, Y, { commit: G } = { commit: !1 }) {
      const H = Rw(a), j = Tw(Math.round((A - o) / a) * a + o, H), F = bn(j, [o, r]);
      k((V = []) => {
        const L = Ew(V, F, Y);
        if (Nw(L, l * a)) {
          y.current = L.indexOf(F);
          const R = String(L) !== String(V);
          return R && G && m(L), R ? L : V;
        } else
          return V;
      });
    }
    return /* @__PURE__ */ u(
      xw,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: i,
        min: o,
        max: r,
        valueIndexToChangeRef: y,
        thumbs: v.current,
        values: S,
        orientation: s,
        form: b,
        children: /* @__PURE__ */ u(Tr.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ u(Tr.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ u(
          x,
          {
            "aria-disabled": i,
            "data-disabled": i ? "" : void 0,
            ...g,
            ref: t,
            onPointerDown: N(g.onPointerDown, () => {
              i || (C.current = S);
            }),
            min: o,
            max: r,
            inverted: h,
            onSlideStart: i ? void 0 : P,
            onSlideMove: i ? void 0 : M,
            onSlideEnd: i ? void 0 : _,
            onHomeKeyDown: () => !i && O(o, 0, { commit: !0 }),
            onEndKeyDown: () => !i && O(r, S.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: A, direction: Y }) => {
              if (!i) {
                const j = su.includes(A.key) || A.shiftKey && iu.includes(A.key) ? 10 : 1, F = y.current, V = S[F], L = a * j * Y;
                O(V + L, F, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
du.displayName = nn;
var [uu, fu] = cu(nn, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Sw = d.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      dir: r,
      inverted: a,
      onSlideStart: s,
      onSlideMove: i,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...p
    } = e, [f, m] = d.useState(null), h = U(t, (x) => m(x)), b = d.useRef(void 0), g = Rt(r), v = g === "ltr", y = v && !a || !v && a;
    function w(x) {
      const S = b.current || f.getBoundingClientRect(), k = [0, S.width], P = Oa(k, y ? [n, o] : [o, n]);
      return b.current = S, P(x - S.left);
    }
    return /* @__PURE__ */ u(
      uu,
      {
        scope: e.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ u(
          pu,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...p,
            ref: h,
            style: {
              ...p.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (x) => {
              const S = w(x.clientX);
              s?.(S);
            },
            onSlideMove: (x) => {
              const S = w(x.clientX);
              i?.(S);
            },
            onSlideEnd: () => {
              b.current = void 0, l?.();
            },
            onStepKeyDown: (x) => {
              const k = lu[y ? "from-left" : "from-right"].includes(x.key);
              c?.({ event: x, direction: k ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Cw = d.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      inverted: r,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: i,
      onStepKeyDown: l,
      ...c
    } = e, p = d.useRef(null), f = U(t, p), m = d.useRef(void 0), h = !r;
    function b(g) {
      const v = m.current || p.current.getBoundingClientRect(), y = [0, v.height], x = Oa(y, h ? [o, n] : [n, o]);
      return m.current = v, x(g - v.top);
    }
    return /* @__PURE__ */ u(
      uu,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ u(
          pu,
          {
            "data-orientation": "vertical",
            ...c,
            ref: f,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const v = b(g.clientY);
              a?.(v);
            },
            onSlideMove: (g) => {
              const v = b(g.clientY);
              s?.(v);
            },
            onSlideEnd: () => {
              m.current = void 0, i?.();
            },
            onStepKeyDown: (g) => {
              const y = lu[h ? "from-bottom" : "from-top"].includes(g.key);
              l?.({ event: g, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), pu = d.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: o,
      onSlideMove: r,
      onSlideEnd: a,
      onHomeKeyDown: s,
      onEndKeyDown: i,
      onStepKeyDown: l,
      ...c
    } = e, p = zo(nn, n);
    return /* @__PURE__ */ u(
      z.span,
      {
        ...c,
        ref: t,
        onKeyDown: N(e.onKeyDown, (f) => {
          f.key === "Home" ? (s(f), f.preventDefault()) : f.key === "End" ? (i(f), f.preventDefault()) : su.concat(iu).includes(f.key) && (l(f), f.preventDefault());
        }),
        onPointerDown: N(e.onPointerDown, (f) => {
          const m = f.target;
          m.setPointerCapture(f.pointerId), f.preventDefault(), p.thumbs.has(m) ? m.focus() : o(f);
        }),
        onPointerMove: N(e.onPointerMove, (f) => {
          f.target.hasPointerCapture(f.pointerId) && r(f);
        }),
        onPointerUp: N(e.onPointerUp, (f) => {
          const m = f.target;
          m.hasPointerCapture(f.pointerId) && (m.releasePointerCapture(f.pointerId), a(f));
        })
      }
    );
  }
), mu = "SliderTrack", hu = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, r = zo(mu, n);
    return /* @__PURE__ */ u(
      z.span,
      {
        "data-disabled": r.disabled ? "" : void 0,
        "data-orientation": r.orientation,
        ...o,
        ref: t
      }
    );
  }
);
hu.displayName = mu;
var Ar = "SliderRange", gu = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, r = zo(Ar, n), a = fu(Ar, n), s = d.useRef(null), i = U(t, s), l = r.values.length, c = r.values.map(
      (m) => yu(m, r.min, r.max)
    ), p = l > 1 ? Math.min(...c) : 0, f = 100 - Math.max(...c);
    return /* @__PURE__ */ u(
      z.span,
      {
        "data-orientation": r.orientation,
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: i,
        style: {
          ...e.style,
          [a.startEdge]: p + "%",
          [a.endEdge]: f + "%"
        }
      }
    );
  }
);
gu.displayName = Ar;
var Ir = "SliderThumb", vu = d.forwardRef(
  (e, t) => {
    const n = yw(e.__scopeSlider), [o, r] = d.useState(null), a = U(t, (i) => r(i)), s = d.useMemo(
      () => o ? n().findIndex((i) => i.ref.current === o) : -1,
      [n, o]
    );
    return /* @__PURE__ */ u(kw, { ...e, ref: a, index: s });
  }
), kw = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: o, name: r, ...a } = e, s = zo(Ir, n), i = fu(Ir, n), [l, c] = d.useState(null), p = U(t, (w) => c(w)), f = l ? s.form || !!l.closest("form") : !0, m = So(l), h = s.values[o], b = h === void 0 ? 0 : yu(h, s.min, s.max), g = Pw(o, s.values.length), v = m?.[i.size], y = v ? _w(v, b, i.direction) : 0;
    return d.useEffect(() => {
      if (l)
        return s.thumbs.add(l), () => {
          s.thumbs.delete(l);
        };
    }, [l, s.thumbs]), /* @__PURE__ */ Q(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [i.startEdge]: `calc(${b}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ u(Tr.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ u(
            z.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || g,
              "aria-valuemin": s.min,
              "aria-valuenow": h,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...a,
              ref: p,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: N(e.onFocus, () => {
                s.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          f && /* @__PURE__ */ u(
            bu,
            {
              name: r ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: h
            },
            o
          )
        ]
      }
    );
  }
);
vu.displayName = Ir;
var Mw = "RadioBubbleInput", bu = d.forwardRef(
  ({ __scopeSlider: e, value: t, ...n }, o) => {
    const r = d.useRef(null), a = U(r, o), s = xo(t);
    return d.useEffect(() => {
      const i = r.current;
      if (!i) return;
      const l = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(l, "value").set;
      if (s !== t && p) {
        const f = new Event("input", { bubbles: !0 });
        p.call(i, t), i.dispatchEvent(f);
      }
    }, [s, t]), /* @__PURE__ */ u(
      z.input,
      {
        style: { display: "none" },
        ...n,
        ref: a,
        defaultValue: t
      }
    );
  }
);
bu.displayName = Mw;
function Ew(e = [], t, n) {
  const o = [...e];
  return o[n] = t, o.sort((r, a) => r - a);
}
function yu(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return bn(a, [0, 100]);
}
function Pw(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function Dw(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((r) => Math.abs(r - t)), o = Math.min(...n);
  return n.indexOf(o);
}
function _w(e, t, n) {
  const o = e / 2, a = Oa([0, 50], [0, o]);
  return (o - a(t) * n) * n;
}
function Ow(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function Nw(e, t) {
  if (t > 0) {
    const n = Ow(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Oa(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function Rw(e) {
  return (String(e).split(".")[1] || "").length;
}
function Tw(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var Aw = du, Iw = hu, Ww = gu, Fw = vu, $o = "Switch", [Lw] = be($o), [zw, $w] = Lw($o), wu = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: s,
      disabled: i,
      value: l = "on",
      onCheckedChange: c,
      form: p,
      ...f
    } = e, [m, h] = d.useState(null), b = U(t, (x) => h(x)), g = d.useRef(!1), v = m ? p || !!m.closest("form") : !0, [y, w] = Se({
      prop: r,
      defaultProp: a ?? !1,
      onChange: c,
      caller: $o
    });
    return /* @__PURE__ */ Q(zw, { scope: n, checked: y, disabled: i, children: [
      /* @__PURE__ */ u(
        z.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": s,
          "data-state": ku(y),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: l,
          ...f,
          ref: b,
          onClick: N(e.onClick, (x) => {
            w((S) => !S), v && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ u(
        Cu,
        {
          control: m,
          bubbles: !g.current,
          name: o,
          value: l,
          checked: y,
          required: s,
          disabled: i,
          form: p,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
wu.displayName = $o;
var xu = "SwitchThumb", Su = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = $w(xu, n);
    return /* @__PURE__ */ u(
      z.span,
      {
        "data-state": ku(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Su.displayName = xu;
var Bw = "SwitchBubbleInput", Cu = d.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const s = d.useRef(null), i = U(s, a), l = xo(n), c = So(t);
    return d.useEffect(() => {
      const p = s.current;
      if (!p) return;
      const f = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && h) {
        const b = new Event("click", { bubbles: o });
        h.call(p, n), p.dispatchEvent(b);
      }
    }, [l, n, o]), /* @__PURE__ */ u(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: i,
        style: {
          ...r.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Cu.displayName = Bw;
function ku(e) {
  return e ? "checked" : "unchecked";
}
var Yw = wu, Hw = Su, Mu = "Toggle", Na = d.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: o, onPressedChange: r, ...a } = e, [s, i] = Se({
    prop: n,
    onChange: r,
    defaultProp: o ?? !1,
    caller: Mu
  });
  return /* @__PURE__ */ u(
    z.button,
    {
      type: "button",
      "aria-pressed": s,
      "data-state": s ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: N(e.onClick, () => {
        e.disabled || i(!s);
      })
    }
  );
});
Na.displayName = Mu;
var Gw = Na, xt = "ToggleGroup", [Eu] = be(xt, [
  Oo
]), Pu = Oo(), Ra = D.forwardRef((e, t) => {
  const { type: n, ...o } = e;
  if (n === "single")
    return /* @__PURE__ */ u(Vw, { ...o, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ u(Uw, { ...o, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${xt}\``);
});
Ra.displayName = xt;
var [Du, _u] = Eu(xt), Vw = D.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [s, i] = Se({
    prop: n,
    defaultProp: o ?? "",
    onChange: r,
    caller: xt
  });
  return /* @__PURE__ */ u(
    Du,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: D.useMemo(() => s ? [s] : [], [s]),
      onItemActivate: i,
      onItemDeactivate: D.useCallback(() => i(""), [i]),
      children: /* @__PURE__ */ u(Ou, { ...a, ref: t })
    }
  );
}), Uw = D.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [s, i] = Se({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: xt
  }), l = D.useCallback(
    (p) => i((f = []) => [...f, p]),
    [i]
  ), c = D.useCallback(
    (p) => i((f = []) => f.filter((m) => m !== p)),
    [i]
  );
  return /* @__PURE__ */ u(
    Du,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: s,
      onItemActivate: l,
      onItemDeactivate: c,
      children: /* @__PURE__ */ u(Ou, { ...a, ref: t })
    }
  );
});
Ra.displayName = xt;
var [jw, Kw] = Eu(xt), Ou = D.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: o = !1,
      rovingFocus: r = !0,
      orientation: a,
      dir: s,
      loop: i = !0,
      ...l
    } = e, c = Pu(n), p = Rt(s), f = { role: "group", dir: p, ...l };
    return /* @__PURE__ */ u(jw, { scope: n, rovingFocus: r, disabled: o, children: r ? /* @__PURE__ */ u(
      dc,
      {
        asChild: !0,
        ...c,
        orientation: a,
        dir: p,
        loop: i,
        children: /* @__PURE__ */ u(z.div, { ...f, ref: t })
      }
    ) : /* @__PURE__ */ u(z.div, { ...f, ref: t }) });
  }
), co = "ToggleGroupItem", Nu = D.forwardRef(
  (e, t) => {
    const n = _u(co, e.__scopeToggleGroup), o = Kw(co, e.__scopeToggleGroup), r = Pu(e.__scopeToggleGroup), a = n.value.includes(e.value), s = o.disabled || e.disabled, i = { ...e, pressed: a, disabled: s }, l = D.useRef(null);
    return o.rovingFocus ? /* @__PURE__ */ u(
      uc,
      {
        asChild: !0,
        ...r,
        focusable: !s,
        active: a,
        ref: l,
        children: /* @__PURE__ */ u(Ts, { ...i, ref: t })
      }
    ) : /* @__PURE__ */ u(Ts, { ...i, ref: t });
  }
);
Nu.displayName = co;
var Ts = D.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: o, ...r } = e, a = _u(co, n), s = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, i = a.type === "single" ? s : void 0;
    return /* @__PURE__ */ u(
      Na,
      {
        ...i,
        ...r,
        ref: t,
        onPressedChange: (l) => {
          l ? a.onItemActivate(o) : a.onItemDeactivate(o);
        }
      }
    );
  }
), qw = Ra, Xw = Nu, [Bo] = be("Tooltip", [
  gt
]), Yo = gt(), Ru = "TooltipProvider", Zw = 700, Wr = "tooltip.open", [Qw, Ta] = Bo(Ru), Tu = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Zw,
    skipDelayDuration: o = 300,
    disableHoverableContent: r = !1,
    children: a
  } = e, s = d.useRef(!0), i = d.useRef(!1), l = d.useRef(0);
  return d.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ u(
    Qw,
    {
      scope: t,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(l.current), s.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          o
        );
      }, [o]),
      isPointerInTransitRef: i,
      onPointerInTransitChange: d.useCallback((c) => {
        i.current = c;
      }, []),
      disableHoverableContent: r,
      children: a
    }
  );
};
Tu.displayName = Ru;
var yn = "Tooltip", [Jw, Tn] = Bo(yn), Au = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    disableHoverableContent: s,
    delayDuration: i
  } = e, l = Ta(yn, e.__scopeTooltip), c = Yo(t), [p, f] = d.useState(null), m = Ee(), h = d.useRef(0), b = s ?? l.disableHoverableContent, g = i ?? l.delayDuration, v = d.useRef(!1), [y, w] = Se({
    prop: o,
    defaultProp: r ?? !1,
    onChange: (P) => {
      P ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Wr))) : l.onClose(), a?.(P);
    },
    caller: yn
  }), x = d.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), S = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, v.current = !1, w(!0);
  }, [w]), k = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, w(!1);
  }, [w]), C = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      v.current = !0, w(!0), h.current = 0;
    }, g);
  }, [g, w]);
  return d.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ u(En, { ...c, children: /* @__PURE__ */ u(
    Jw,
    {
      scope: t,
      contentId: m,
      open: y,
      stateAttribute: x,
      trigger: p,
      onTriggerChange: f,
      onTriggerEnter: d.useCallback(() => {
        l.isOpenDelayedRef.current ? C() : S();
      }, [l.isOpenDelayedRef, C, S]),
      onTriggerLeave: d.useCallback(() => {
        b ? k() : (window.clearTimeout(h.current), h.current = 0);
      }, [k, b]),
      onOpen: S,
      onClose: k,
      disableHoverableContent: b,
      children: n
    }
  ) });
};
Au.displayName = yn;
var Fr = "TooltipTrigger", Iu = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, r = Tn(Fr, n), a = Ta(Fr, n), s = Yo(n), i = d.useRef(null), l = U(t, i, r.onTriggerChange), c = d.useRef(!1), p = d.useRef(!1), f = d.useCallback(() => c.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ u(Pn, { asChild: !0, ...s, children: /* @__PURE__ */ u(
      z.button,
      {
        "aria-describedby": r.open ? r.contentId : void 0,
        "data-state": r.stateAttribute,
        ...o,
        ref: l,
        onPointerMove: N(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !p.current && !a.isPointerInTransitRef.current && (r.onTriggerEnter(), p.current = !0);
        }),
        onPointerLeave: N(e.onPointerLeave, () => {
          r.onTriggerLeave(), p.current = !1;
        }),
        onPointerDown: N(e.onPointerDown, () => {
          r.open && r.onClose(), c.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: N(e.onFocus, () => {
          c.current || r.onOpen();
        }),
        onBlur: N(e.onBlur, r.onClose),
        onClick: N(e.onClick, r.onClose)
      }
    ) });
  }
);
Iu.displayName = Fr;
var Aa = "TooltipPortal", [ex, tx] = Bo(Aa, {
  forceMount: void 0
}), Wu = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: o, container: r } = e, a = Tn(Aa, t);
  return /* @__PURE__ */ u(ex, { scope: t, forceMount: n, children: /* @__PURE__ */ u(xe, { present: n || a.open, children: /* @__PURE__ */ u(Qt, { asChild: !0, container: r, children: o }) }) });
};
Wu.displayName = Aa;
var Kt = "TooltipContent", Fu = d.forwardRef(
  (e, t) => {
    const n = tx(Kt, e.__scopeTooltip), { forceMount: o = n.forceMount, side: r = "top", ...a } = e, s = Tn(Kt, e.__scopeTooltip);
    return /* @__PURE__ */ u(xe, { present: o || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ u(Lu, { side: r, ...a, ref: t }) : /* @__PURE__ */ u(nx, { side: r, ...a, ref: t }) });
  }
), nx = d.forwardRef((e, t) => {
  const n = Tn(Kt, e.__scopeTooltip), o = Ta(Kt, e.__scopeTooltip), r = d.useRef(null), a = U(t, r), [s, i] = d.useState(null), { trigger: l, onClose: c } = n, p = r.current, { onPointerInTransitChange: f } = o, m = d.useCallback(() => {
    i(null), f(!1);
  }, [f]), h = d.useCallback(
    (b, g) => {
      const v = b.currentTarget, y = { x: b.clientX, y: b.clientY }, w = sx(y, v.getBoundingClientRect()), x = ix(y, w), S = lx(g.getBoundingClientRect()), k = dx([...x, ...S]);
      i(k), f(!0);
    },
    [f]
  );
  return d.useEffect(() => () => m(), [m]), d.useEffect(() => {
    if (l && p) {
      const b = (v) => h(v, p), g = (v) => h(v, l);
      return l.addEventListener("pointerleave", b), p.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", b), p.removeEventListener("pointerleave", g);
      };
    }
  }, [l, p, h, m]), d.useEffect(() => {
    if (s) {
      const b = (g) => {
        const v = g.target, y = { x: g.clientX, y: g.clientY }, w = l?.contains(v) || p?.contains(v), x = !cx(y, s);
        w ? m() : x && (m(), c());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [l, p, s, c, m]), /* @__PURE__ */ u(Lu, { ...e, ref: a });
}), [ox, rx] = Bo(yn, { isInside: !1 }), ax = /* @__PURE__ */ bi("TooltipContent"), Lu = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: o,
      "aria-label": r,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      ...i
    } = e, l = Tn(Kt, n), c = Yo(n), { onClose: p } = l;
    return d.useEffect(() => (document.addEventListener(Wr, p), () => document.removeEventListener(Wr, p)), [p]), d.useEffect(() => {
      if (l.trigger) {
        const f = (m) => {
          m.target?.contains(l.trigger) && p();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, p]), /* @__PURE__ */ u(
      Zt,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: s,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: p,
        children: /* @__PURE__ */ Q(
          Do,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...i,
            ref: t,
            style: {
              ...i.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u(ax, { children: o }),
              /* @__PURE__ */ u(ox, { scope: n, isInside: !0, children: /* @__PURE__ */ u(Yp, { id: l.contentId, role: "tooltip", children: r || o }) })
            ]
          }
        )
      }
    );
  }
);
Fu.displayName = Kt;
var zu = "TooltipArrow", $u = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, r = Yo(n);
    return rx(
      zu,
      n
    ).isInside ? null : /* @__PURE__ */ u(_o, { ...r, ...o, ref: t });
  }
);
$u.displayName = zu;
function sx(e, t) {
  const n = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, o, r, a)) {
    case a:
      return "left";
    case r:
      return "right";
    case n:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ix(e, t, n = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      o.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return o;
}
function lx(e) {
  const { top: t, right: n, bottom: o, left: r } = e;
  return [
    { x: r, y: t },
    { x: n, y: t },
    { x: n, y: o },
    { x: r, y: o }
  ];
}
function cx(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], l = t[s], c = i.x, p = i.y, f = l.x, m = l.y;
    p > o != m > o && n < (f - c) * (o - p) / (m - p) + c && (r = !r);
  }
  return r;
}
function dx(e) {
  const t = e.slice();
  return t.sort((n, o) => n.x < o.x ? -1 : n.x > o.x ? 1 : n.y < o.y ? -1 : n.y > o.y ? 1 : 0), ux(t);
}
function ux(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], s = t[t.length - 2];
      if ((a.x - s.x) * (r.y - s.y) >= (a.y - s.y) * (r.x - s.x)) t.pop();
      else break;
    }
    t.push(r);
  }
  t.pop();
  const n = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const r = e[o];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], s = n[n.length - 2];
      if ((a.x - s.x) * (r.y - s.y) >= (a.y - s.y) * (r.x - s.x)) n.pop();
      else break;
    }
    n.push(r);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var fx = Tu, px = Au, mx = Iu, hx = Wu, gx = Fu, vx = $u;
function bx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Zb,
    {
      "data-slot": "label",
      className: E(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
function yx({
  className: e,
  orientation: t = "horizontal",
  decorative: n = !0,
  ...o
}) {
  return /* @__PURE__ */ u(
    bw,
    {
      "data-slot": "separator",
      decorative: n,
      orientation: t,
      className: E(
        "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        e
      ),
      ...o
    }
  );
}
function nk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "fieldset",
    {
      "data-slot": "field-set",
      className: E(
        "flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3",
        e
      ),
      ...t
    }
  );
}
function ok({
  className: e,
  variant: t = "legend",
  ...n
}) {
  return /* @__PURE__ */ u(
    "legend",
    {
      "data-slot": "field-legend",
      "data-variant": t,
      className: E(
        "mb-1.5 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base",
        e
      ),
      ...n
    }
  );
}
function rk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "field-group",
      className: E(
        "group/field-group @container/field-group flex w-full flex-col gap-5 data-[slot=checkbox-group]:gap-3 *:data-[slot=field-group]:gap-4",
        e
      ),
      ...t
    }
  );
}
const wx = Xt(
  "group/field flex w-full gap-2 data-[invalid=true]:text-destructive",
  {
    variants: {
      orientation: {
        vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
        horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
        responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
      }
    },
    defaultVariants: {
      orientation: "vertical"
    }
  }
);
function xx({
  className: e,
  orientation: t = "vertical",
  ...n
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      role: "group",
      "data-slot": "field",
      "data-orientation": t,
      className: E(wx({ orientation: t }), e),
      ...n
    }
  );
}
function ak({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "field-content",
      className: E(
        "group/field-content flex flex-1 flex-col gap-0.5 leading-snug",
        e
      ),
      ...t
    }
  );
}
function sk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    bx,
    {
      "data-slot": "field-label",
      className: E(
        "group/field-label peer/field-label flex w-fit gap-2 leading-snug group-data-[disabled=true]/field:opacity-50 has-data-checked:border-primary/30 has-data-checked:bg-primary/5 has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border *:data-[slot=field]:p-2.5 dark:has-data-checked:border-primary/20 dark:has-data-checked:bg-primary/10",
        "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col",
        e
      ),
      ...t
    }
  );
}
function ik({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "field-label",
      className: E(
        "flex w-fit items-center gap-2 text-sm leading-snug font-medium group-data-[disabled=true]/field:opacity-50",
        e
      ),
      ...t
    }
  );
}
function lk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "p",
    {
      "data-slot": "field-description",
      className: E(
        "text-left text-sm leading-normal font-normal text-muted-foreground group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5",
        "last:mt-0 nth-last-2:-mt-1",
        "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary",
        e
      ),
      ...t
    }
  );
}
function ck({
  children: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ Q(
    "div",
    {
      "data-slot": "field-separator",
      "data-content": !!e,
      className: E(
        "relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2",
        t
      ),
      ...n,
      children: [
        /* @__PURE__ */ u(yx, { className: "absolute inset-0 top-1/2" }),
        e && /* @__PURE__ */ u(
          "span",
          {
            className: "relative mx-auto block w-fit bg-background px-2 text-muted-foreground",
            "data-slot": "field-separator-content",
            children: e
          }
        )
      ]
    }
  );
}
function dk({
  className: e,
  children: t,
  errors: n,
  ...o
}) {
  const r = mn(() => {
    if (t)
      return t;
    if (!n?.length)
      return null;
    const a = [
      ...new Map(n.map((s) => [s?.message, s])).values()
    ];
    return a?.length === 1 ? a[0]?.message : /* @__PURE__ */ u("ul", { className: "ml-4 flex list-disc flex-col gap-1", children: a.map(
      (s, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no stable key available for error list
        s?.message && /* @__PURE__ */ u("li", { children: s.message }, i)
      )
    ) });
  }, [t, n]);
  return r ? /* @__PURE__ */ u(
    "div",
    {
      role: "alert",
      "data-slot": "field-error",
      className: E("text-sm font-normal text-destructive", e),
      ...o,
      children: r
    }
  ) : null;
}
const Lr = Xt(
  "group/button inline-flex shrink-0 cursor-pointer items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  // override: added cursor-pointer so buttons always show a pointer cursor
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
        ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
        destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
        xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
        lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
        icon: "size-8",
        "icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
        "icon-lg": "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function St({
  className: e,
  variant: t = "default",
  size: n = "default",
  asChild: o = !1,
  ...r
}) {
  return /* @__PURE__ */ u(
    o ? gi : "button",
    {
      "data-slot": "button",
      "data-variant": t,
      "data-size": n,
      className: E(Lr({ variant: t, size: n, className: e })),
      ...r
    }
  );
}
function uk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "button-group",
      role: "group",
      className: E(
        "flex h-7 items-center -space-x-px [&>*:first-child]:rounded-l-md [&>*:first-child]:rounded-r-none [&>*:last-child]:rounded-l-none [&>*:last-child]:rounded-r-md [&>*:not(:first-child):not(:last-child)]:rounded-none",
        e
      ),
      ...t
    }
  );
}
const Bu = (...e) => e.filter((t, n, o) => !!t && t.trim() !== "" && o.indexOf(t) === n).join(" ").trim();
const Sx = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const Cx = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, o) => o ? o.toUpperCase() : n.toLowerCase()
);
const As = (e) => {
  const t = Cx(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
};
var fr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const kx = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
}, Mx = Qs({}), Ex = () => Zs(Mx), Px = Js(
  ({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: o, className: r = "", children: a, iconNode: s, ...i }, l) => {
    const {
      size: c = 24,
      strokeWidth: p = 2,
      absoluteStrokeWidth: f = !1,
      color: m = "currentColor",
      className: h = ""
    } = Ex() ?? {}, b = o ?? f ? Number(n ?? p) * 24 / Number(t ?? c) : n ?? p;
    return br(
      "svg",
      {
        ref: l,
        ...fr,
        width: t ?? c ?? fr.width,
        height: t ?? c ?? fr.height,
        stroke: e ?? m,
        strokeWidth: b,
        className: Bu("lucide", h, r),
        ...!a && !kx(i) && { "aria-hidden": "true" },
        ...i
      },
      [
        ...s.map(([g, v]) => br(g, v)),
        ...Array.isArray(a) ? a : [a]
      ]
    );
  }
);
const Ct = (e, t) => {
  const n = Js(
    ({ className: o, ...r }, a) => br(Px, {
      ref: a,
      iconNode: t,
      className: Bu(
        `lucide-${Sx(As(e))}`,
        `lucide-${e}`,
        o
      ),
      ...r
    })
  );
  return n.displayName = As(e), n;
};
const Dx = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], _x = Ct("calendar", Dx);
const Ox = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ho = Ct("check", Ox);
const Nx = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Go = Ct("chevron-down", Nx);
const Rx = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Yu = Ct("chevron-left", Rx);
const Tx = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Ia = Ct("chevron-right", Tx);
const Ax = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Hu = Ct("chevron-up", Ax);
const Ix = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], Wx = Ct("ellipsis", Ix);
const Fx = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Gu = Ct("x", Fx);
function fk({
  ...e
}) {
  return /* @__PURE__ */ u(ew, { "data-slot": "select", ...e });
}
function pk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    iw,
    {
      "data-slot": "select-group",
      className: E("scroll-my-1 p-1", e),
      ...t
    }
  );
}
function mk({
  ...e
}) {
  return /* @__PURE__ */ u(nw, { "data-slot": "select-value", ...e });
}
function hk({
  className: e,
  size: t = "default",
  children: n,
  ...o
}) {
  return /* @__PURE__ */ Q(
    tw,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: E(
        "flex w-fit items-center justify-between gap-1.5 rounded-lg border border-input bg-transparent py-2 pr-2 pl-2.5 text-sm whitespace-nowrap transition-colors outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground data-[size=default]:h-8 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-1.5 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ u(ow, { asChild: !0, children: /* @__PURE__ */ u(Go, { className: "pointer-events-none size-4 text-muted-foreground" }) })
      ]
    }
  );
}
function gk({
  className: e,
  children: t,
  position: n = "item-aligned",
  align: o = "center",
  ...r
}) {
  return /* @__PURE__ */ u(rw, { children: /* @__PURE__ */ Q(
    aw,
    {
      "data-slot": "select-content",
      "data-align-trigger": n === "item-aligned",
      className: E(
        "relative z-50 max-h-(--radix-select-content-available-height) min-w-36 origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: o,
      ...r,
      children: [
        /* @__PURE__ */ u(Lx, {}),
        /* @__PURE__ */ u(
          sw,
          {
            "data-position": n,
            className: E(
              "data-[position=popper]:h-(--radix-select-trigger-height) data-[position=popper]:w-full data-[position=popper]:min-w-(--radix-select-trigger-width)",
              n === "popper" && ""
            ),
            children: t
          }
        ),
        /* @__PURE__ */ u(zx, {})
      ]
    }
  ) });
}
function vk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    lw,
    {
      "data-slot": "select-label",
      className: E("px-1.5 py-1 text-xs text-muted-foreground", e),
      ...t
    }
  );
}
function bk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ Q(
    cw,
    {
      "data-slot": "select-item",
      className: E(
        "relative flex w-full cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ u("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center", children: /* @__PURE__ */ u(uw, { children: /* @__PURE__ */ u(Ho, { className: "pointer-events-none" }) }) }),
        /* @__PURE__ */ u(dw, { children: t })
      ]
    }
  );
}
function yk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    mw,
    {
      "data-slot": "select-separator",
      className: E("pointer-events-none -mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function Lx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    fw,
    {
      "data-slot": "select-scroll-up-button",
      className: E(
        "z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(Hu, {})
    }
  );
}
function zx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    pw,
    {
      "data-slot": "select-scroll-down-button",
      className: E(
        "z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(Go, {})
    }
  );
}
function wk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Rl,
    {
      "data-slot": "checkbox",
      className: E(
        "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(
        Al,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none [&>svg]:size-3.5",
          children: /* @__PURE__ */ u(Ho, {})
        }
      )
    }
  );
}
function xk({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ u(
    Yw,
    {
      "data-slot": "switch",
      "data-size": t,
      className: E(
        "peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-[18.4px] data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:bg-primary data-unchecked:bg-input dark:data-unchecked:bg-input/80 data-disabled:cursor-not-allowed data-disabled:opacity-50",
        e
      ),
      ...n,
      children: /* @__PURE__ */ u(
        Hw,
        {
          "data-slot": "switch-thumb",
          className: "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] dark:data-checked:bg-primary-foreground group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-unchecked:bg-foreground"
        }
      )
    }
  );
}
function Sk({
  className: e,
  defaultValue: t,
  value: n,
  min: o = 0,
  max: r = 100,
  ...a
}) {
  const s = d.useMemo(
    () => Array.isArray(n) ? n : Array.isArray(t) ? t : [o, r],
    [n, t, o, r]
  );
  return /* @__PURE__ */ Q(
    Aw,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: n,
      min: o,
      max: r,
      className: E(
        "relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ u(
          Iw,
          {
            "data-slot": "slider-track",
            className: "relative grow overflow-hidden rounded-full bg-muted data-horizontal:h-1 data-horizontal:w-full data-vertical:h-full data-vertical:w-1",
            children: /* @__PURE__ */ u(
              Ww,
              {
                "data-slot": "slider-range",
                className: "absolute bg-primary select-none data-horizontal:h-full data-vertical:w-full"
              }
            )
          }
        ),
        Array.from({ length: s.length }, (i, l) => /* @__PURE__ */ u(
          Fw,
          {
            "data-slot": "slider-thumb",
            className: "relative block size-3 shrink-0 rounded-full border border-ring bg-white ring-ring/50 transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:ring-3 focus-visible:ring-3 focus-visible:outline-hidden active:ring-3 disabled:pointer-events-none disabled:opacity-50"
          },
          l
        ))
      ]
    }
  );
}
function $x({ className: e, type: t, ...n }) {
  return /* @__PURE__ */ u(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: E(
        "h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...n
    }
  );
}
function Bx({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "textarea",
    {
      "data-slot": "textarea",
      className: E(
        "flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
function Yx({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: E(
        "group/input-group relative flex h-7 w-full min-w-0 items-center rounded-md border border-input transition-colors outline-none in-data-[slot=combobox-content]:focus-within:border-inherit in-data-[slot=combobox-content]:focus-within:ring-0 has-disabled:bg-input/50 has-disabled:opacity-50 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-3 has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-3 has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>textarea]:h-auto dark:bg-input/30 dark:has-disabled:bg-input/80 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 has-[>[data-align=block-end]]:[&>input]:pt-3 has-[>[data-align=block-start]]:[&>input]:pb-3 has-[>[data-align=inline-end]]:[&>input]:pr-1.5 has-[>[data-align=inline-start]]:[&>input]:pl-1.5",
        e
      ),
      ...t
    }
  );
}
const Hx = Xt(
  "flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4",
  {
    variants: {
      align: {
        "inline-start": "order-first pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem]",
        "inline-end": "order-last pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem]",
        "block-start": "order-first w-full justify-start px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2",
        "block-end": "order-last w-full justify-start px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function Gx({
  className: e,
  align: t = "inline-start",
  ...n
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: E(Hx({ align: t }), e),
      onClick: (o) => {
        o.target.closest("button") || o.currentTarget.parentElement?.querySelector("input")?.focus();
      },
      ...n
    }
  );
}
const Vx = Xt(
  "flex items-center gap-2 text-sm shadow-none",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 rounded-[calc(var(--radius)-3px)] px-1.5 [&>svg:not([class*='size-'])]:size-3.5",
        sm: "",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function Ux({
  className: e,
  type: t = "button",
  variant: n = "ghost",
  size: o = "xs",
  ...r
}) {
  return /* @__PURE__ */ u(
    St,
    {
      type: t,
      "data-size": o,
      variant: n,
      className: E(Vx({ size: o }), e),
      ...r
    }
  );
}
function Ck({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "span",
    {
      className: E(
        "flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function jx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    $x,
    {
      "data-slot": "input-group-control",
      className: E(
        "flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function kk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Bx,
    {
      "data-slot": "input-group-control",
      className: E(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-2 shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function Mk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    mm,
    {
      "data-slot": "accordion",
      className: E("flex w-full flex-col", e),
      ...t
    }
  );
}
function Ek({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    hm,
    {
      "data-slot": "accordion-item",
      className: E("not-last:border-b", e),
      ...t
    }
  );
}
function Pk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ u(gm, { className: "flex", children: /* @__PURE__ */ Q(
    vm,
    {
      "data-slot": "accordion-trigger",
      className: E(
        "group/accordion-trigger relative flex flex-1 items-start justify-between rounded-lg border border-transparent py-2.5 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:after:border-ring disabled:pointer-events-none disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 **:data-[slot=accordion-trigger-icon]:text-muted-foreground",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ u(
          Go,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
          }
        ),
        /* @__PURE__ */ u(
          Hu,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
          }
        )
      ]
    }
  ) });
}
function Dk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ u(
    bm,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-open:animate-accordion-down data-closed:animate-accordion-up",
      ...n,
      children: /* @__PURE__ */ u(
        "div",
        {
          className: E(
            "h-(--radix-accordion-content-height) pt-0 pb-2.5 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4",
            e
          ),
          children: t
        }
      )
    }
  );
}
function _k({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card",
      "data-size": t,
      className: E(
        "group/card flex flex-col gap-4 overflow-hidden rounded-xl bg-card py-4 text-sm text-card-foreground ring-1 ring-foreground/10 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl",
        e
      ),
      ...n
    }
  );
}
function Ok({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-header",
      className: E(
        "group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3",
        e
      ),
      ...t
    }
  );
}
function Nk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-title",
      className: E(
        "text-base leading-snug font-medium group-data-[size=sm]/card:text-sm",
        e
      ),
      ...t
    }
  );
}
function Rk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-description",
      className: E("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Tk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-action",
      className: E(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function Ak({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-content",
      className: E("px-4 group-data-[size=sm]/card:px-3", e),
      ...t
    }
  );
}
function Ik({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-footer",
      className: E(
        "flex items-center rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/card:p-3",
        e
      ),
      ...t
    }
  );
}
function Wk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ Q(
    Ny,
    {
      "data-slot": "scroll-area",
      type: "always",
      className: E("relative flex flex-col overflow-hidden", e),
      ...n,
      children: [
        /* @__PURE__ */ u(
          Ry,
          {
            "data-slot": "scroll-area-viewport",
            className: "w-full grow rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ u(Kx, {}),
        /* @__PURE__ */ u(Ty, {})
      ]
    }
  );
}
function Kx({
  className: e,
  orientation: t = "vertical",
  ...n
}) {
  return /* @__PURE__ */ u(
    xd,
    {
      "data-slot": "scroll-area-scrollbar",
      "data-orientation": t,
      orientation: t,
      className: E(
        "flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent",
        e
      ),
      ...n,
      children: /* @__PURE__ */ u(
        Md,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-full bg-border"
        }
      )
    }
  );
}
function Fk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "skeleton",
      className: E("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
function Lk({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ u(
    og,
    {
      "data-slot": "avatar",
      "data-size": t,
      className: E(
        "group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten",
        e
      ),
      ...n
    }
  );
}
function zk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    rg,
    {
      "data-slot": "avatar-image",
      className: E(
        "aspect-square size-full rounded-full object-cover",
        e
      ),
      ...t
    }
  );
}
function $k({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ag,
    {
      "data-slot": "avatar-fallback",
      className: E(
        "flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs",
        e
      ),
      ...t
    }
  );
}
function Bk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "span",
    {
      "data-slot": "avatar-badge",
      className: E(
        "absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground bg-blend-color ring-2 ring-background select-none",
        "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden",
        "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2",
        "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2",
        e
      ),
      ...t
    }
  );
}
function Yk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "avatar-group",
      className: E(
        "group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background",
        e
      ),
      ...t
    }
  );
}
function Hk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "avatar-group-count",
      className: E(
        "relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3",
        e
      ),
      ...t
    }
  );
}
function Gk({
  className: e,
  value: t,
  ...n
}) {
  const [o, r] = d.useState(0);
  return d.useEffect(() => {
    const a = requestAnimationFrame(() => r(t || 0));
    return () => cancelAnimationFrame(a);
  }, [t]), /* @__PURE__ */ u(
    by,
    {
      "data-slot": "progress",
      value: t,
      className: E(
        "relative flex h-1 w-full items-center overflow-x-hidden rounded-full bg-muted",
        e
      ),
      ...n,
      children: /* @__PURE__ */ u(
        yy,
        {
          "data-slot": "progress-indicator",
          className: "size-full flex-1 bg-primary transition-all",
          style: { transform: `translateX(-${100 - o}%)` }
        }
      )
    }
  );
}
const qx = Xt(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-4xl border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        secondary: "bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80",
        destructive: "bg-destructive/10 text-destructive focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:focus-visible:ring-destructive/40 [a]:hover:bg-destructive/20",
        outline: "border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground",
        ghost: "hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50",
        link: "text-primary underline-offset-4 hover:underline"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Vk({
  className: e,
  variant: t = "default",
  asChild: n = !1,
  ...o
}) {
  return /* @__PURE__ */ u(
    n ? gi : "span",
    {
      "data-slot": "badge",
      "data-variant": t,
      className: E(qx({ variant: t }), e),
      ...o
    }
  );
}
const Vu = Xt(
  "group/toggle inline-flex items-center justify-center gap-1 rounded-lg text-sm font-medium whitespace-nowrap transition-all outline-none hover:bg-muted hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-pressed:bg-muted data-[state=on]:bg-muted dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-muted"
      },
      size: {
        default: "h-8 min-w-8 px-2",
        sm: "h-7 min-w-7 rounded-[min(var(--radius-md),12px)] px-1.5 text-[0.8rem]",
        lg: "h-9 min-w-9 px-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Uk({
  className: e,
  variant: t = "default",
  size: n = "default",
  ...o
}) {
  return /* @__PURE__ */ u(
    Gw,
    {
      "data-slot": "toggle",
      className: E(Vu({ variant: t, size: n, className: e })),
      ...o
    }
  );
}
const Uu = d.createContext({
  size: "default",
  variant: "default",
  spacing: 0,
  orientation: "horizontal"
});
function jk({
  className: e,
  variant: t,
  size: n,
  spacing: o = 0,
  orientation: r = "horizontal",
  children: a,
  ...s
}) {
  return /* @__PURE__ */ u(
    qw,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": n,
      "data-spacing": o,
      "data-orientation": r,
      style: { "--gap": o },
      className: E(
        "group/toggle-group flex w-fit flex-row items-center bg-background shadow-lg p-1 ring-1 ring-border gap-[--spacing(var(--gap))] rounded-xl data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-vertical:flex-col data-vertical:items-stretch",
        e
      ),
      ...s,
      children: /* @__PURE__ */ u(
        Uu.Provider,
        {
          value: { variant: t, size: n, spacing: o, orientation: r },
          children: a
        }
      )
    }
  );
}
function Kk({
  className: e,
  children: t,
  variant: n = "default",
  size: o = "default",
  ...r
}) {
  const a = d.useContext(Uu);
  return /* @__PURE__ */ u(
    Xw,
    {
      "data-slot": "toggle-group-item",
      "data-variant": a.variant || n,
      "data-size": a.size || o,
      "data-spacing": a.spacing,
      className: E(
        "shrink-0 group-data-[spacing=0]/toggle-group:rounded-none group-data-[spacing=0]/toggle-group:px-2 focus:z-10 focus-visible:z-10 group-data-horizontal/toggle-group:data-[spacing=0]:first:rounded-l-lg group-data-vertical/toggle-group:data-[spacing=0]:first:rounded-t-lg group-data-horizontal/toggle-group:data-[spacing=0]:last:rounded-r-lg group-data-vertical/toggle-group:data-[spacing=0]:last:rounded-b-lg group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:border-l-0 group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:border-t-0 group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-l group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-t",
        Vu({
          variant: a.variant || n,
          size: a.size || o
        }),
        e
      ),
      ...r,
      children: t
    }
  );
}
function qk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "table-container",
      className: "relative w-full overflow-x-auto",
      children: /* @__PURE__ */ u(
        "table",
        {
          "data-slot": "table",
          className: E("w-full caption-bottom text-sm", e),
          ...t
        }
      )
    }
  );
}
function Xk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "thead",
    {
      "data-slot": "table-header",
      className: E("[&_tr]:border-b", e),
      ...t
    }
  );
}
function Zk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "tbody",
    {
      "data-slot": "table-body",
      className: E("[&_tr:last-child]:border-0", e),
      ...t
    }
  );
}
function Qk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "tfoot",
    {
      "data-slot": "table-footer",
      className: E(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        e
      ),
      ...t
    }
  );
}
function Jk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "tr",
    {
      "data-slot": "table-row",
      className: E(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        e
      ),
      ...t
    }
  );
}
function eM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "th",
    {
      "data-slot": "table-head",
      className: E(
        "h-10 px-2 text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function tM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "td",
    {
      "data-slot": "table-cell",
      className: E(
        "p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function nM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "caption",
    {
      "data-slot": "table-caption",
      className: E("mt-4 text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function oM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "nav",
    {
      "aria-label": "pagination",
      "data-slot": "pagination",
      className: E("mx-auto flex w-full justify-center", e),
      ...t
    }
  );
}
function rM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "ul",
    {
      "data-slot": "pagination-content",
      className: E("flex items-center gap-0.5", e),
      ...t
    }
  );
}
function aM({ ...e }) {
  return /* @__PURE__ */ u("li", { "data-slot": "pagination-item", ...e });
}
function ju({
  className: e,
  isActive: t,
  size: n = "icon",
  ...o
}) {
  return /* @__PURE__ */ u(
    St,
    {
      asChild: !0,
      variant: t ? "outline" : "ghost",
      size: n,
      className: E(e),
      children: /* @__PURE__ */ u(
        "a",
        {
          "aria-current": t ? "page" : void 0,
          "data-slot": "pagination-link",
          "data-active": t,
          ...o
        }
      )
    }
  );
}
function sM({
  className: e,
  text: t = "Previous",
  ...n
}) {
  return /* @__PURE__ */ Q(
    ju,
    {
      "aria-label": "Go to previous page",
      size: "default",
      className: E("pl-1.5!", e),
      ...n,
      children: [
        /* @__PURE__ */ u(Yu, { "data-icon": "inline-start" }),
        /* @__PURE__ */ u("span", { className: "hidden sm:block", children: t })
      ]
    }
  );
}
function iM({
  className: e,
  text: t = "Next",
  ...n
}) {
  return /* @__PURE__ */ Q(
    ju,
    {
      "aria-label": "Go to next page",
      size: "default",
      className: E("pr-1.5!", e),
      ...n,
      children: [
        /* @__PURE__ */ u("span", { className: "hidden sm:block", children: t }),
        /* @__PURE__ */ u(Ia, { "data-icon": "inline-end" })
      ]
    }
  );
}
function lM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ Q(
    "span",
    {
      "aria-hidden": !0,
      "data-slot": "pagination-ellipsis",
      className: E(
        "flex size-8 items-center justify-center [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ u(Wx, {}),
        /* @__PURE__ */ u("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
function cM({
  ...e
}) {
  return /* @__PURE__ */ u(zh, { "data-slot": "alert-dialog", ...e });
}
function dM({
  ...e
}) {
  return /* @__PURE__ */ u($h, { "data-slot": "alert-dialog-trigger", ...e });
}
function Xx({
  ...e
}) {
  return /* @__PURE__ */ u(Bh, { "data-slot": "alert-dialog-portal", ...e });
}
function Zx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Yh,
    {
      "data-slot": "alert-dialog-overlay",
      className: E(
        "fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function uM({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ Q(Xx, { children: [
    /* @__PURE__ */ u(Zx, {}),
    /* @__PURE__ */ u(
      Hh,
      {
        "data-slot": "alert-dialog-content",
        "data-size": t,
        className: E(
          "group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...n
      }
    )
  ] });
}
function fM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: E(
        "grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-4 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]",
        e
      ),
      ...t
    }
  );
}
function pM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: E(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function mM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "alert-dialog-media",
      className: E(
        "mb-2 inline-flex size-10 items-center justify-center rounded-md bg-muted sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-6",
        e
      ),
      ...t
    }
  );
}
function hM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Uh,
    {
      "data-slot": "alert-dialog-title",
      className: E(
        "text-base font-medium sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2",
        e
      ),
      ...t
    }
  );
}
function gM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    jh,
    {
      "data-slot": "alert-dialog-description",
      className: E(
        "text-sm text-balance text-muted-foreground md:text-pretty *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function vM({
  className: e,
  variant: t = "default",
  size: n = "default",
  ...o
}) {
  return /* @__PURE__ */ u(St, { variant: t, size: n, asChild: !0, children: /* @__PURE__ */ u(
    Gh,
    {
      "data-slot": "alert-dialog-action",
      className: E(e),
      ...o
    }
  ) });
}
function bM({
  className: e,
  variant: t = "outline",
  size: n = "default",
  ...o
}) {
  return /* @__PURE__ */ u(St, { variant: t, size: n, asChild: !0, children: /* @__PURE__ */ u(
    Vh,
    {
      "data-slot": "alert-dialog-cancel",
      className: E(e),
      ...o
    }
  ) });
}
function Qx({
  ...e
}) {
  return /* @__PURE__ */ u(ly, { "data-slot": "popover", ...e });
}
function Jx({
  ...e
}) {
  return /* @__PURE__ */ u(cy, { "data-slot": "popover-trigger", ...e });
}
function eS({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...o
}) {
  return /* @__PURE__ */ u(dy, { children: /* @__PURE__ */ u(
    uy,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: E(
        "z-50 flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...o
    }
  ) });
}
function yM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "popover-header",
      className: E("flex flex-col gap-0.5 text-sm", e),
      ...t
    }
  );
}
function wM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "popover-title",
      className: E("font-medium", e),
      ...t
    }
  );
}
function xM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "p",
    {
      "data-slot": "popover-description",
      className: E("text-muted-foreground", e),
      ...t
    }
  );
}
function SM({ ...e }) {
  return /* @__PURE__ */ u(Qr, { "data-slot": "sheet", ...e });
}
function CM({
  ...e
}) {
  return /* @__PURE__ */ u(Jr, { "data-slot": "sheet-trigger", ...e });
}
function kM({
  ...e
}) {
  return /* @__PURE__ */ u(Tt, { "data-slot": "sheet-close", ...e });
}
function tS({
  ...e
}) {
  return /* @__PURE__ */ u(ea, { "data-slot": "sheet-portal", ...e });
}
function nS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ta,
    {
      "data-slot": "sheet-overlay",
      className: E(
        "fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function MM({
  className: e,
  children: t,
  side: n = "right",
  showCloseButton: o = !0,
  ...r
}) {
  return /* @__PURE__ */ Q(tS, { children: [
    /* @__PURE__ */ u(nS, {}),
    /* @__PURE__ */ Q(
      na,
      {
        "data-slot": "sheet-content",
        "data-side": n,
        className: E(
          "fixed z-50 flex flex-col gap-4 bg-popover bg-clip-padding text-sm text-popover-foreground shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-[side=bottom]:data-open:slide-in-from-bottom-10 data-[side=left]:data-open:slide-in-from-left-10 data-[side=right]:data-open:slide-in-from-right-10 data-[side=top]:data-open:slide-in-from-top-10 data-closed:animate-out data-closed:fade-out-0 data-[side=bottom]:data-closed:slide-out-to-bottom-10 data-[side=left]:data-closed:slide-out-to-left-10 data-[side=right]:data-closed:slide-out-to-right-10 data-[side=top]:data-closed:slide-out-to-top-10",
          e
        ),
        ...r,
        children: [
          t,
          o && /* @__PURE__ */ u(Tt, { "data-slot": "sheet-close", asChild: !0, children: /* @__PURE__ */ Q(
            St,
            {
              variant: "ghost",
              className: "absolute top-3 right-3",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ u(Gu, {}),
                /* @__PURE__ */ u("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function EM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sheet-header",
      className: E("flex flex-col gap-0.5 p-4", e),
      ...t
    }
  );
}
function PM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sheet-footer",
      className: E("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function DM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    oa,
    {
      "data-slot": "sheet-title",
      className: E("text-base font-medium text-foreground", e),
      ...t
    }
  );
}
function _M({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ra,
    {
      "data-slot": "sheet-description",
      className: E("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function OM({
  ...e
}) {
  return /* @__PURE__ */ u(Mi, { "data-slot": "collapsible", ...e });
}
function NM({
  ...e
}) {
  return /* @__PURE__ */ u(
    Yr,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function RM({
  ...e
}) {
  return /* @__PURE__ */ u(
    Gr,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function TM({
  // Override: default delay is 700ms; 0 gives instant tooltips app-wide
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ u(
    fx,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function AM({
  ...e
}) {
  return /* @__PURE__ */ u(px, { "data-slot": "tooltip", ...e });
}
function IM({
  ...e
}) {
  return /* @__PURE__ */ u(mx, { "data-slot": "tooltip-trigger", ...e });
}
function WM({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ u(hx, { children: /* @__PURE__ */ Q(
    gx,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: E(
        "z-50 inline-flex w-fit max-w-xs origin-(--radix-tooltip-content-transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ u(vx, { className: "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" })
      ]
    }
  ) });
}
function FM({
  ...e
}) {
  return /* @__PURE__ */ u(Qr, { "data-slot": "dialog", ...e });
}
function LM({
  ...e
}) {
  return /* @__PURE__ */ u(Jr, { "data-slot": "dialog-trigger", ...e });
}
function oS({
  ...e
}) {
  return /* @__PURE__ */ u(ea, { "data-slot": "dialog-portal", ...e });
}
function zM({
  ...e
}) {
  return /* @__PURE__ */ u(Tt, { "data-slot": "dialog-close", ...e });
}
function rS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ta,
    {
      "data-slot": "dialog-overlay",
      className: E(
        "fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function $M({
  className: e,
  children: t,
  showCloseButton: n = !0,
  ...o
}) {
  return /* @__PURE__ */ Q(oS, { children: [
    /* @__PURE__ */ u(rS, {}),
    /* @__PURE__ */ Q(
      na,
      {
        "data-slot": "dialog-content",
        className: E(
          "fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...o,
        children: [
          t,
          n && /* @__PURE__ */ u(Tt, { "data-slot": "dialog-close", asChild: !0, children: /* @__PURE__ */ Q(
            St,
            {
              variant: "ghost",
              className: "absolute top-2 right-2",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ u(Gu, {}),
                /* @__PURE__ */ u("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function BM({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "dialog-header",
      className: E("flex flex-col gap-2", e),
      ...t
    }
  );
}
function YM({
  className: e,
  showCloseButton: t = !1,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ Q(
    "div",
    {
      "data-slot": "dialog-footer",
      className: E(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 sm:flex-row sm:justify-end",
        e
      ),
      ...o,
      children: [
        n,
        t && /* @__PURE__ */ u(Tt, { asChild: !0, children: /* @__PURE__ */ u(St, { variant: "outline", children: "Close" }) })
      ]
    }
  );
}
function HM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    oa,
    {
      "data-slot": "dialog-title",
      className: E(
        "cn-font-heading text-base leading-none font-medium",
        e
      ),
      ...t
    }
  );
}
function GM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ra,
    {
      "data-slot": "dialog-description",
      className: E(
        "text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function VM({
  ...e
}) {
  return /* @__PURE__ */ u(Fb, { "data-slot": "dropdown-menu", ...e });
}
function UM({
  ...e
}) {
  return /* @__PURE__ */ u(ed, { "data-slot": "dropdown-menu-portal", ...e });
}
function jM({
  ...e
}) {
  return /* @__PURE__ */ u(
    Lb,
    {
      "data-slot": "dropdown-menu-trigger",
      ...e
    }
  );
}
function KM({
  className: e,
  align: t = "start",
  sideOffset: n = 4,
  ...o
}) {
  return /* @__PURE__ */ u(ed, { children: /* @__PURE__ */ u(
    zb,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: n,
      align: t,
      className: E(
        "z-50 max-h-(--radix-dropdown-menu-content-available-height) w-(--radix-dropdown-menu-trigger-width) min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:overflow-hidden data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...o
    }
  ) });
}
function qM({
  ...e
}) {
  return /* @__PURE__ */ u($b, { "data-slot": "dropdown-menu-group", ...e });
}
function XM({
  className: e,
  inset: t,
  variant: n = "default",
  ...o
}) {
  return /* @__PURE__ */ u(
    Yb,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": n,
      className: E(
        "group/dropdown-menu-item relative flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive",
        e
      ),
      ...o
    }
  );
}
function ZM({
  className: e,
  children: t,
  checked: n,
  inset: o,
  ...r
}) {
  return /* @__PURE__ */ Q(
    Hb,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      "data-inset": o,
      className: E(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ u(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-checkbox-item-indicator",
            children: /* @__PURE__ */ u(td, { children: /* @__PURE__ */ u(Ho, {}) })
          }
        ),
        t
      ]
    }
  );
}
function QM({
  ...e
}) {
  return /* @__PURE__ */ u(
    Gb,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function JM({
  className: e,
  children: t,
  inset: n,
  ...o
}) {
  return /* @__PURE__ */ Q(
    Vb,
    {
      "data-slot": "dropdown-menu-radio-item",
      "data-inset": n,
      className: E(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        /* @__PURE__ */ u(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-radio-item-indicator",
            children: /* @__PURE__ */ u(td, { children: /* @__PURE__ */ u(Ho, {}) })
          }
        ),
        t
      ]
    }
  );
}
function eE({
  className: e,
  inset: t,
  ...n
}) {
  return /* @__PURE__ */ u(
    Bb,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: E(
        "px-1.5 py-1 text-xs font-medium text-muted-foreground data-inset:pl-7",
        e
      ),
      ...n
    }
  );
}
function tE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ub,
    {
      "data-slot": "dropdown-menu-separator",
      className: E("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function nE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: E(
        "ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground",
        e
      ),
      ...t
    }
  );
}
function oE({
  ...e
}) {
  return /* @__PURE__ */ u(jb, { "data-slot": "dropdown-menu-sub", ...e });
}
function rE({
  className: e,
  inset: t,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ Q(
    Kb,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: E(
        "flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ u(Ia, { className: "cn-rtl-flip ml-auto" })
      ]
    }
  );
}
function aE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    qb,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: E(
        "z-50 min-w-[96px] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-lg bg-popover p-1 text-popover-foreground shadow-lg ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...t
    }
  );
}
function aS(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const sS = {}, fn = {};
function Je(e, t) {
  try {
    const o = (sS[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return o in fn ? fn[o] : Is(o, o.split(":"));
  } catch {
    if (e in fn) return fn[e];
    const n = e?.match(iS);
    return n ? Is(e, n.slice(1)) : NaN;
  }
}
const iS = /([+-]\d\d):?(\d\d)?/;
function Is(e, t) {
  const n = +(t[0] || 0), o = +(t[1] || 0), r = +(t[2] || 0) / 60;
  return fn[e] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class je extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Je(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Ku(this, t)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new je(...n, t) : new je(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new je(+this, t);
  }
  getTimezoneOffset() {
    const t = -Je(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), uo(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new je(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Ws = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Ws.test(e)) return;
  const t = e.replace(Ws, "$1UTC");
  je.prototype[t] && (e.startsWith("get") ? je.prototype[e] = function() {
    return this.internal[t]();
  } : (je.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), lS(this), +this;
  }, je.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), uo(this), +this;
  }));
});
function uo(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-Je(e.timeZone, e) * 60));
}
function lS(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Ku(e);
}
function Ku(e, t) {
  const n = Array.isArray(t) ? cS(t) : +e.internal, o = Je(e.timeZone, e), r = o > 0 ? Math.floor(o) : Math.ceil(o), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), l = s - i;
  let c = s;
  if (l && s !== r) {
    const _ = Date.prototype.getHours.apply(e), O = Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours();
    if (_ !== O) {
      const A = /* @__PURE__ */ new Date(+e), Y = s - r;
      Y && A.setUTCMinutes(A.getUTCMinutes() + Y);
      const G = Je(e.timeZone, A);
      (G > 0 ? Math.floor(G) : Math.ceil(G)) === r && (c = i);
    }
  }
  const p = c - r;
  p && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + p);
  const f = /* @__PURE__ */ new Date(+e);
  f.setUTCSeconds(0);
  const m = s > 0 ? f.getSeconds() : (f.getSeconds() - 60) % 60, h = Math.round(-(Je(e.timeZone, e) * 60)) % 60;
  (h || m) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + h + m);
  const b = Je(e.timeZone, e), g = b > 0 ? Math.floor(b) : Math.ceil(b), y = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - g, w = g !== r, x = y - p, S = g - r, k = n - g * 60 * 1e3, C = S > 0 && Fs(e) - n === S * 60 * 1e3 && Fs(e, k) !== n;
  if (w && x && !C) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x);
    const _ = Je(e.timeZone, e), O = _ > 0 ? Math.floor(_) : Math.ceil(_), A = g - O;
    A && x < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + A);
  }
  uo(e);
  const M = (t ? n : n + h * 1e3) - +e.internal;
  M && Math.abs(M) < 1800 * 1e3 && (Date.prototype.setTime.call(e, +e + M), uo(e));
}
function cS(e) {
  return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function Fs(e, t) {
  const n = new Date(t ?? +e);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-Je(e.timeZone, n) * 60)), +n;
}
class ke extends je {
  //#region static
  static tz(t, ...n) {
    return n.length ? new ke(...n, t) : new ke(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, o] = this.tzComponents(), r = `${t}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, o, r] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${t} GMT${n}${o}${r} (${aS(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", o = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), r = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(t) {
    return new ke(+this, t);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new ke(+new Date(t), this.timeZone);
  }
  //#endregion
}
const qu = 6048e5, dS = 864e5, Ls = /* @__PURE__ */ Symbol.for("constructDateFrom");
function he(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Ls in e ? e[Ls](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ce(e, t) {
  return he(t || e, e);
}
function Xu(e, t, n) {
  const o = ce(e, n?.in);
  return isNaN(t) ? he(e, NaN) : (t && o.setDate(o.getDate() + t), o);
}
function Zu(e, t, n) {
  const o = ce(e, n?.in);
  if (isNaN(t)) return he(e, NaN);
  if (!t)
    return o;
  const r = o.getDate(), a = he(e, o.getTime());
  a.setMonth(o.getMonth() + t + 1, 0);
  const s = a.getDate();
  return r >= s ? a : (o.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    r
  ), o);
}
let uS = {};
function An() {
  return uS;
}
function qt(e, t) {
  const n = An(), o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = ce(e, t?.in), a = r.getDay(), s = (a < o ? 7 : 0) + a - o;
  return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function wn(e, t) {
  return qt(e, { ...t, weekStartsOn: 1 });
}
function Qu(e, t) {
  const n = ce(e, t?.in), o = n.getFullYear(), r = he(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = wn(r), s = he(n, 0);
  s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0);
  const i = wn(s);
  return n.getTime() >= a.getTime() ? o + 1 : n.getTime() >= i.getTime() ? o : o - 1;
}
function zs(e) {
  const t = ce(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function on(e, ...t) {
  const n = he.bind(
    null,
    t.find((o) => typeof o == "object")
  );
  return t.map(n);
}
function xn(e, t) {
  const n = ce(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Wa(e, t, n) {
  const [o, r] = on(
    n?.in,
    e,
    t
  ), a = xn(o), s = xn(r), i = +a - zs(a), l = +s - zs(s);
  return Math.round((i - l) / dS);
}
function fS(e, t) {
  const n = Qu(e, t), o = he(e, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), wn(o);
}
function pS(e, t, n) {
  return Xu(e, t * 7, n);
}
function mS(e, t, n) {
  return Zu(e, t * 12, n);
}
function hS(e, t) {
  let n, o = t?.in;
  return e.forEach((r) => {
    !o && typeof r == "object" && (o = he.bind(null, r));
    const a = ce(r, o);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), he(o, n || NaN);
}
function gS(e, t) {
  let n, o = t?.in;
  return e.forEach((r) => {
    !o && typeof r == "object" && (o = he.bind(null, r));
    const a = ce(r, o);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), he(o, n || NaN);
}
function vS(e, t, n) {
  const [o, r] = on(
    n?.in,
    e,
    t
  );
  return +xn(o) == +xn(r);
}
function Ju(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function bS(e) {
  return !(!Ju(e) && typeof e != "number" || isNaN(+ce(e)));
}
function ef(e, t, n) {
  const [o, r] = on(
    n?.in,
    e,
    t
  ), a = o.getFullYear() - r.getFullYear(), s = o.getMonth() - r.getMonth();
  return a * 12 + s;
}
function yS(e, t) {
  const n = ce(e, t?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function tf(e, t) {
  const [n, o] = on(e, t.start, t.end);
  return { start: n, end: o };
}
function wS(e, t) {
  const { start: n, end: o } = tf(t?.in, e);
  let r = +n > +o;
  const a = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let i = 1;
  const l = [];
  for (; +s <= a; )
    l.push(he(n, s)), s.setMonth(s.getMonth() + i);
  return r ? l.reverse() : l;
}
function xS(e, t) {
  const n = ce(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function SS(e, t) {
  const n = ce(e, t?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function nf(e, t) {
  const n = ce(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function CS(e, t) {
  const { start: n, end: o } = tf(t?.in, e);
  let r = +n > +o;
  const a = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let i = 1;
  const l = [];
  for (; +s <= a; )
    l.push(he(n, s)), s.setFullYear(s.getFullYear() + i);
  return r ? l.reverse() : l;
}
function of(e, t) {
  const n = An(), o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = ce(e, t?.in), a = r.getDay(), s = (a < o ? -7 : 0) + 6 - (a - o);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function kS(e, t) {
  return of(e, { ...t, weekStartsOn: 1 });
}
const MS = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ES = (e, t, n) => {
  let o;
  const r = MS[e];
  return typeof r == "string" ? o = r : t === 1 ? o = r.one : o = r.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function pr(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const PS = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, DS = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, _S = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, OS = {
  date: pr({
    formats: PS,
    defaultWidth: "full"
  }),
  time: pr({
    formats: DS,
    defaultWidth: "full"
  }),
  dateTime: pr({
    formats: _S,
    defaultWidth: "full"
  })
}, NS = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, RS = (e, t, n, o) => NS[e];
function ln(e) {
  return (t, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, i = n?.width ? String(n.width) : s;
      r = e.formattingValues[i] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, i = n?.width ? String(n.width) : e.defaultWidth;
      r = e.values[i] || e.values[s];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[a];
  };
}
const TS = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, AS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, IS = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, WS = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, FS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, LS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, zS = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, $S = {
  ordinalNumber: zS,
  era: ln({
    values: TS,
    defaultWidth: "wide"
  }),
  quarter: ln({
    values: AS,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ln({
    values: IS,
    defaultWidth: "wide"
  }),
  day: ln({
    values: WS,
    defaultWidth: "wide"
  }),
  dayPeriod: ln({
    values: FS,
    defaultWidth: "wide",
    formattingValues: LS,
    defaultFormattingWidth: "wide"
  })
};
function cn(e) {
  return (t, n = {}) => {
    const o = n.width, r = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], a = t.match(r);
    if (!a)
      return null;
    const s = a[0], i = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(i) ? YS(i, (f) => f.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      BS(i, (f) => f.test(s))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const p = t.slice(s.length);
    return { value: c, rest: p };
  };
}
function BS(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function YS(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function HS(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const r = o[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let s = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const i = t.slice(r.length);
    return { value: s, rest: i };
  };
}
const GS = /^(\d+)(th|st|nd|rd)?/i, VS = /\d+/i, US = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, jS = {
  any: [/^b/i, /^(a|c)/i]
}, KS = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, qS = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, XS = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ZS = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, QS = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, JS = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, eC = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, tC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, nC = {
  ordinalNumber: HS({
    matchPattern: GS,
    parsePattern: VS,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: cn({
    matchPatterns: US,
    defaultMatchWidth: "wide",
    parsePatterns: jS,
    defaultParseWidth: "any"
  }),
  quarter: cn({
    matchPatterns: KS,
    defaultMatchWidth: "wide",
    parsePatterns: qS,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: cn({
    matchPatterns: XS,
    defaultMatchWidth: "wide",
    parsePatterns: ZS,
    defaultParseWidth: "any"
  }),
  day: cn({
    matchPatterns: QS,
    defaultMatchWidth: "wide",
    parsePatterns: JS,
    defaultParseWidth: "any"
  }),
  dayPeriod: cn({
    matchPatterns: eC,
    defaultMatchWidth: "any",
    parsePatterns: tC,
    defaultParseWidth: "any"
  })
}, Bt = {
  code: "en-US",
  formatDistance: ES,
  formatLong: OS,
  formatRelative: RS,
  localize: $S,
  match: nC,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function oC(e, t) {
  const n = ce(e, t?.in);
  return Wa(n, nf(n)) + 1;
}
function Fa(e, t) {
  const n = ce(e, t?.in), o = +wn(n) - +fS(n);
  return Math.round(o / qu) + 1;
}
function rf(e, t) {
  const n = ce(e, t?.in), o = n.getFullYear(), r = An(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = he(t?.in || e, 0);
  s.setFullYear(o + 1, 0, a), s.setHours(0, 0, 0, 0);
  const i = qt(s, t), l = he(t?.in || e, 0);
  l.setFullYear(o, 0, a), l.setHours(0, 0, 0, 0);
  const c = qt(l, t);
  return +n >= +i ? o + 1 : +n >= +c ? o : o - 1;
}
function rC(e, t) {
  const n = An(), o = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = rf(e, t), a = he(t?.in || e, 0);
  return a.setFullYear(r, 0, o), a.setHours(0, 0, 0, 0), qt(a, t);
}
function La(e, t) {
  const n = ce(e, t?.in), o = +qt(n, t) - +rC(n, t);
  return Math.round(o / qu) + 1;
}
function ie(e, t) {
  const n = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return n + o;
}
const lt = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
    return ie(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ie(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ie(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ie(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ie(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ie(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ie(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, o = e.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return ie(r, t.length);
  }
}, zt = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, $s = {
  // Era
  G: function(e, t, n) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const o = e.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return lt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, o) {
    const r = rf(e, o), a = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const s = a % 100;
      return ie(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : ie(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Qu(e);
    return ie(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ie(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return ie(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return ie(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return lt.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return ie(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, o) {
    const r = La(e, o);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : ie(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const o = Fa(e);
    return t === "Io" ? n.ordinalNumber(o, { unit: "week" }) : ie(o, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : lt.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const o = oC(e);
    return t === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : ie(o, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const o = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, o) {
    const r = e.getDay(), a = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return ie(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, o) {
    const r = e.getDay(), a = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return ie(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const o = e.getDay(), r = o === 0 ? 7 : o;
    switch (t) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return ie(r, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const o = e.getHours();
    let r;
    switch (o === 12 ? r = zt.noon : o === 0 ? r = zt.midnight : r = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const o = e.getHours();
    let r;
    switch (o >= 17 ? r = zt.evening : o >= 12 ? r = zt.afternoon : o >= 4 ? r = zt.morning : r = zt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return lt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : lt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const o = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : ie(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : ie(o, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : lt.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : lt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return lt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Ys(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Et(o);
      // Hours and minutes with `:` delimiter
      default:
        return Et(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Ys(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Et(o);
      // Hours and minutes with `:` delimiter
      default:
        return Et(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Bs(o, ":");
      default:
        return "GMT" + Et(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Bs(o, ":");
      default:
        return "GMT" + Et(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const o = Math.trunc(+e / 1e3);
    return ie(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return ie(+e, t.length);
  }
};
function Bs(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = Math.trunc(o / 60), a = o % 60;
  return a === 0 ? n + String(r) : n + String(r) + t + ie(a, 2);
}
function Ys(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ie(Math.abs(e) / 60, 2) : Et(e, t);
}
function Et(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = ie(Math.trunc(o / 60), 2), a = ie(o % 60, 2);
  return n + r + t + a;
}
const Hs = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, af = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, aC = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return Hs(e, t);
  let a;
  switch (o) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Hs(o, t)).replace("{{time}}", af(r, t));
}, sC = {
  p: af,
  P: aC
}, iC = /^D+$/, lC = /^Y+$/, cC = ["D", "DD", "YY", "YYYY"];
function dC(e) {
  return iC.test(e);
}
function uC(e) {
  return lC.test(e);
}
function fC(e, t, n) {
  const o = pC(e, t, n);
  if (console.warn(o), cC.includes(e)) throw new RangeError(o);
}
function pC(e, t, n) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const mC = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, hC = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gC = /^'([^]*?)'?$/, vC = /''/g, bC = /[a-zA-Z]/;
function pn(e, t, n) {
  const o = An(), r = n?.locale ?? o.locale ?? Bt, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, i = ce(e, n?.in);
  if (!bS(i))
    throw new RangeError("Invalid time value");
  let l = t.match(hC).map((p) => {
    const f = p[0];
    if (f === "p" || f === "P") {
      const m = sC[f];
      return m(p, r.formatLong);
    }
    return p;
  }).join("").match(mC).map((p) => {
    if (p === "''")
      return { isToken: !1, value: "'" };
    const f = p[0];
    if (f === "'")
      return { isToken: !1, value: yC(p) };
    if ($s[f])
      return { isToken: !0, value: p };
    if (f.match(bC))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: p };
  });
  r.localize.preprocessor && (l = r.localize.preprocessor(i, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: r
  };
  return l.map((p) => {
    if (!p.isToken) return p.value;
    const f = p.value;
    (!n?.useAdditionalWeekYearTokens && uC(f) || !n?.useAdditionalDayOfYearTokens && dC(f)) && fC(f, t, String(e));
    const m = $s[f[0]];
    return m(i, f, r.localize, c);
  }).join("");
}
function yC(e) {
  const t = e.match(gC);
  return t ? t[1].replace(vC, "'") : e;
}
function wC(e, t) {
  const n = ce(e, t?.in), o = n.getFullYear(), r = n.getMonth(), a = he(n, 0);
  return a.setFullYear(o, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function xC(e, t) {
  return ce(e, t?.in).getMonth();
}
function SC(e, t) {
  return ce(e, t?.in).getFullYear();
}
function CC(e, t) {
  return +ce(e) > +ce(t);
}
function kC(e, t) {
  return +ce(e) < +ce(t);
}
function MC(e, t, n) {
  const [o, r] = on(
    n?.in,
    e,
    t
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function EC(e, t, n) {
  const [o, r] = on(
    n?.in,
    e,
    t
  );
  return o.getFullYear() === r.getFullYear();
}
function PC(e, t, n) {
  const o = ce(e, n?.in), r = o.getFullYear(), a = o.getDate(), s = he(e, 0);
  s.setFullYear(r, t, 15), s.setHours(0, 0, 0, 0);
  const i = wC(s);
  return o.setMonth(t, Math.min(a, i)), o;
}
function DC(e, t, n) {
  const o = ce(e, n?.in);
  return isNaN(+o) ? he(e, NaN) : (o.setFullYear(t), o);
}
const Gs = 5, _C = 4;
function OC(e, t) {
  const n = t.startOfMonth(e), o = n.getDay() > 0 ? n.getDay() : 7, r = t.addDays(e, -o + 1), a = t.addDays(r, Gs * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? Gs : _C;
}
function sf(e, t) {
  const n = t.startOfMonth(e), o = n.getDay();
  return o === 1 ? n : o === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (o - 1));
}
function NC(e, t) {
  const n = sf(e, t), o = OC(e, t);
  return t.addDays(n, o * 7 - 1);
}
const lf = {
  ...Bt,
  labels: {
    labelDayButton: (e, t, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, i) => pn(s, i, { locale: Bt, ...n });
      let a = r(e, "PPPP");
      return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, a) => pn(r, a, { locale: Bt, ...t }), o(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, i) => pn(s, i, { locale: Bt, ...n });
      let a = r(e, "PPPP");
      return t?.today && (a = `Today, ${a}`), a;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, a) => pn(r, a, { locale: Bt, ...t }), o(e, "cccc");
    }
  }
};
class Ne {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.today = () => {
      if (this.overrides?.today)
        return this.overrides.today();
      if (this.options.timeZone)
        return ke.tz(this.options.timeZone);
      const o = this.options.Date ?? Date;
      return new o();
    }, this.newDate = (o, r, a) => this.overrides?.newDate ? this.overrides.newDate(o, r, a) : this.options.timeZone ? new ke(o, r, a, this.options.timeZone) : new Date(o, r, a), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : Xu(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : Zu(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : pS(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : mS(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : Wa(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : ef(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : wS(o), this.eachYearOfInterval = (o) => {
      const r = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(o) : CS(o), a = new Set(r.map((i) => this.getYear(i)));
      if (a.size === r.length)
        return r;
      const s = [];
      return a.forEach((i) => {
        s.push(new Date(i, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : NC(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : kS(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : yS(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : of(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : SS(o), this.format = (o, r, a) => {
      const s = this.overrides?.format ? this.overrides.format(o, r, this.options) : pn(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : Fa(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : xC(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : SC(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : La(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : CC(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : kC(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : Ju(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : vS(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : MC(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : EC(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : hS(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : gS(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : PC(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : DC(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : sf(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : xn(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : wn(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : xS(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : qt(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : nf(o), this.options = { locale: lf, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && Ne.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: o, numerals: r } = this.options, a = n?.code;
    if (a && Ne.yearFirstLocales.has(a))
      try {
        return new Intl.DateTimeFormat(a, {
          month: "long",
          year: "numeric",
          timeZone: o,
          numberingSystem: r
        }).format(t);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, s);
  }
}
Ne.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Ze = new Ne();
class cf {
  constructor(t, n, o = Ze) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(t, n)), this.dateLib = o, this.isoDate = o.format(t, "yyyy-MM-dd"), this.displayMonthId = o.format(n, "yyyy-MM"), this.dateMonthId = o.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class RC {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class TC {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function AC(e) {
  return D.createElement("span", { ...e });
}
function IC(e) {
  const { size: t = 24, orientation: n = "left", className: o, style: r } = e;
  return D.createElement(
    "svg",
    { className: o, style: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && D.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && D.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && D.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && D.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function WC(e) {
  const { day: t, modifiers: n, ...o } = e;
  return D.createElement("td", { ...o });
}
function FC(e) {
  const { day: t, modifiers: n, ...o } = e, r = D.useRef(null);
  return D.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), D.createElement("button", { ref: r, ...o });
}
var W;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(W || (W = {}));
var ue;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(ue || (ue = {}));
var Le;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Le || (Le = {}));
var De;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(De || (De = {}));
const df = Qs(void 0);
function Vo() {
  const e = Zs(df);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function LC(e) {
  const { options: t, className: n, ...o } = e, { classNames: r, components: a, styles: s } = Vo(), i = [r[W.Dropdown], n].join(" "), l = t?.find(({ value: c }) => c === o.value);
  return D.createElement(
    "span",
    { "data-disabled": o.disabled, className: r[W.DropdownRoot], style: s?.[W.DropdownRoot] },
    D.createElement(a.Select, { className: i, ...o }, t?.map(({ value: c, label: p, disabled: f }) => D.createElement(a.Option, { key: c, value: c, disabled: f }, p))),
    D.createElement(
      "span",
      { className: r[W.CaptionLabel], style: s?.[W.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      D.createElement(a.Chevron, { orientation: "down", size: 18, className: r[W.Chevron], style: s?.[W.Chevron] })
    )
  );
}
function zC(e) {
  return D.createElement("div", { ...e });
}
function $C(e) {
  return D.createElement("div", { ...e });
}
function BC(e) {
  const { calendarMonth: t, displayIndex: n, ...o } = e;
  return D.createElement("div", { ...o }, e.children);
}
function YC(e) {
  const { calendarMonth: t, displayIndex: n, ...o } = e;
  return D.createElement("div", { ...o });
}
function HC(e) {
  return D.createElement("table", { ...e });
}
function GC(e) {
  return D.createElement("div", { ...e });
}
function VC(e) {
  const { components: t } = Vo();
  return D.createElement(t.Dropdown, { ...e });
}
function UC(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: o, nextMonth: r, ...a } = e, { components: s, classNames: i, styles: l, labels: { labelPrevious: c, labelNext: p } } = Vo(), f = Re((h) => {
    r && n?.(h);
  }, [r, n]), m = Re((h) => {
    o && t?.(h);
  }, [o, t]);
  return D.createElement(
    "nav",
    { ...a },
    D.createElement(
      s.PreviousMonthButton,
      { type: "button", className: i[W.PreviousMonthButton], style: l?.[W.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: m },
      D.createElement(s.Chevron, { disabled: o ? void 0 : !0, className: i[W.Chevron], style: l?.[W.Chevron], orientation: "left" })
    ),
    D.createElement(
      s.NextMonthButton,
      { type: "button", className: i[W.NextMonthButton], style: l?.[W.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": p(r), onClick: f },
      D.createElement(s.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: i[W.Chevron], style: l?.[W.Chevron] })
    )
  );
}
function jC(e) {
  return D.createElement("button", { ...e });
}
function KC(e) {
  return D.createElement("option", { ...e });
}
function qC(e) {
  return D.createElement("button", { ...e });
}
function XC(e) {
  const { rootRef: t, ...n } = e;
  return D.createElement("div", { ...n, ref: t });
}
function ZC(e) {
  return D.createElement("select", { ...e });
}
function QC(e) {
  const { week: t, ...n } = e;
  return D.createElement("tr", { ...n });
}
function JC(e) {
  return D.createElement("th", { ...e });
}
function e0(e) {
  return D.createElement(
    "thead",
    { "aria-hidden": !0 },
    D.createElement("tr", { ...e })
  );
}
function t0(e) {
  const { week: t, ...n } = e;
  return D.createElement("th", { ...n });
}
function n0(e) {
  return D.createElement("th", { ...e });
}
function o0(e) {
  return D.createElement("tbody", { ...e });
}
function r0(e) {
  const { components: t } = Vo();
  return D.createElement(t.Dropdown, { ...e });
}
const a0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptionLabel: AC,
  Chevron: IC,
  Day: WC,
  DayButton: FC,
  Dropdown: LC,
  DropdownNav: zC,
  Footer: $C,
  Month: BC,
  MonthCaption: YC,
  MonthGrid: HC,
  Months: GC,
  MonthsDropdown: VC,
  Nav: UC,
  NextMonthButton: jC,
  Option: KC,
  PreviousMonthButton: qC,
  Root: XC,
  Select: ZC,
  Week: QC,
  WeekNumber: t0,
  WeekNumberHeader: n0,
  Weekday: JC,
  Weekdays: e0,
  Weeks: o0,
  YearsDropdown: r0
}, Symbol.toStringTag, { value: "Module" }));
function et(e, t, n = !1, o = Ze) {
  let { from: r, to: a } = e;
  const { differenceInCalendarDays: s, isSameDay: i } = o;
  return r && a ? (s(a, r) < 0 && ([r, a] = [a, r]), s(t, r) >= (n ? 1 : 0) && s(a, t) >= (n ? 1 : 0)) : !n && a ? i(a, t) : !n && r ? i(r, t) : !1;
}
function za(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Uo(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function $a(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Ba(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function uf(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function ff(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function tt(e, t, n = Ze) {
  const o = Array.isArray(t) ? t : [t], { isSameDay: r, differenceInCalendarDays: a, isAfter: s } = n;
  return o.some((i) => {
    if (typeof i == "boolean")
      return i;
    if (n.isDate(i))
      return r(e, i);
    if (ff(i, n))
      return i.some((l) => r(e, l));
    if (Uo(i))
      return et(i, e, !1, n);
    if (uf(i))
      return Array.isArray(i.dayOfWeek) ? i.dayOfWeek.includes(e.getDay()) : i.dayOfWeek === e.getDay();
    if (za(i)) {
      const l = a(i.before, e), c = a(i.after, e), p = l > 0, f = c < 0;
      return s(i.before, i.after) ? f && p : p || f;
    }
    return $a(i) ? a(e, i.after) > 0 : Ba(i) ? a(i.before, e) > 0 : typeof i == "function" ? i(e) : !1;
  });
}
function s0(e, t, n, o, r) {
  const { disabled: a, hidden: s, modifiers: i, showOutsideDays: l, broadcastCalendar: c, today: p = r.today() } = t, { isSameDay: f, isSameMonth: m, startOfMonth: h, isBefore: b, endOfMonth: g, isAfter: v } = r, y = n && h(n), w = o && g(o), x = {
    [ue.focused]: [],
    [ue.outside]: [],
    [ue.disabled]: [],
    [ue.hidden]: [],
    [ue.today]: []
  }, S = {};
  for (const k of e) {
    const { date: C, displayMonth: P } = k, M = !!(P && !m(C, P)), _ = !!(y && b(C, y)), O = !!(w && v(C, w)), A = !!(a && tt(C, a, r)), Y = !!(s && tt(C, s, r)) || _ || O || // Broadcast calendar will show outside days as default
    !c && !l && M || c && l === !1 && M, G = f(C, p);
    M && x.outside.push(k), A && x.disabled.push(k), Y && x.hidden.push(k), G && x.today.push(k), i && Object.keys(i).forEach((H) => {
      const j = i?.[H];
      j && tt(C, j, r) && (S[H] ? S[H].push(k) : S[H] = [k]);
    });
  }
  return (k) => {
    const C = {
      [ue.focused]: !1,
      [ue.disabled]: !1,
      [ue.hidden]: !1,
      [ue.outside]: !1,
      [ue.today]: !1
    }, P = {};
    for (const M in x) {
      const _ = x[M];
      C[M] = _.some((O) => O === k);
    }
    for (const M in S)
      P[M] = S[M].some((_) => _ === k);
    return {
      ...C,
      // custom modifiers should override all the previous ones
      ...P
    };
  };
}
function i0(e, t, n = {}) {
  return Object.entries(e).filter(([, r]) => r === !0).reduce((r, [a]) => (n[a] ? r.push(n[a]) : t[ue[a]] ? r.push(t[ue[a]]) : t[Le[a]] && r.push(t[Le[a]]), r), [t[W.Day]]);
}
function l0(e) {
  return {
    ...a0,
    ...e
  };
}
function c0(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, o]) => {
    n.startsWith("data-") && (t[n] = o);
  }), t;
}
function Ya() {
  const e = {};
  for (const t in W)
    e[W[t]] = `rdp-${W[t]}`;
  for (const t in ue)
    e[ue[t]] = `rdp-${ue[t]}`;
  for (const t in Le)
    e[Le[t]] = `rdp-${Le[t]}`;
  for (const t in De)
    e[De[t]] = `rdp-${De[t]}`;
  return e;
}
function d0(e, t, n) {
  return (n ?? new Ne(t)).formatMonthYear(e);
}
function u0(e, t, n) {
  return (n ?? new Ne(t)).format(e, "d");
}
function f0(e, t = Ze) {
  return t.format(e, "LLLL");
}
function p0(e, t, n) {
  return (n ?? new Ne(t)).format(e, "cccccc");
}
function m0(e, t = Ze) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function h0() {
  return "";
}
function g0(e, t = Ze) {
  return t.format(e, "yyyy");
}
const v0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: d0,
  formatDay: u0,
  formatMonthDropdown: f0,
  formatWeekNumber: m0,
  formatWeekNumberHeader: h0,
  formatWeekdayName: p0,
  formatYearDropdown: g0
}, Symbol.toStringTag, { value: "Module" }));
function b0(e) {
  return {
    ...v0,
    ...e
  };
}
function pf(e, t, n, o) {
  let r = (o ?? new Ne(n)).format(e, "PPPP");
  return t.today && (r = `Today, ${r}`), t.selected && (r = `${r}, selected`), r;
}
function mf(e, t, n) {
  return (n ?? new Ne(t)).formatMonthYear(e);
}
function hf(e, t, n, o) {
  let r = (o ?? new Ne(n)).format(e, "PPPP");
  return t?.today && (r = `Today, ${r}`), r;
}
function gf(e) {
  return "Choose the Month";
}
function vf() {
  return "";
}
const y0 = "Go to the Next Month";
function bf(e, t) {
  return y0;
}
function yf(e) {
  return "Go to the Previous Month";
}
function wf(e, t, n) {
  return (n ?? new Ne(t)).format(e, "cccc");
}
function xf(e, t) {
  return `Week ${e}`;
}
function Sf(e) {
  return "Week Number";
}
function Cf(e) {
  return "Choose the Year";
}
const w0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelDayButton: pf,
  labelGrid: mf,
  labelGridcell: hf,
  labelMonthDropdown: gf,
  labelNav: vf,
  labelNext: bf,
  labelPrevious: yf,
  labelWeekNumber: xf,
  labelWeekNumberHeader: Sf,
  labelWeekday: wf,
  labelYearDropdown: Cf
}, Symbol.toStringTag, { value: "Module" })), We = (e, t, n) => t || (n ? typeof n == "function" ? n : (...o) => n : e);
function x0(e, t) {
  const n = t.locale?.labels ?? {};
  return {
    ...w0,
    ...e ?? {},
    labelDayButton: We(pf, e?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: We(gf, e?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: We(bf, e?.labelNext, n.labelNext),
    labelPrevious: We(yf, e?.labelPrevious, n.labelPrevious),
    labelWeekNumber: We(xf, e?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: We(Cf, e?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: We(mf, e?.labelGrid, n.labelGrid),
    labelGridcell: We(hf, e?.labelGridcell, n.labelGridcell),
    labelNav: We(vf, e?.labelNav, n.labelNav),
    labelWeekNumberHeader: We(Sf, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: We(wf, e?.labelWeekday, n.labelWeekday)
  };
}
function S0(e, t, n, o, r) {
  const { startOfMonth: a, startOfYear: s, endOfYear: i, eachMonthOfInterval: l, getMonth: c } = r;
  return l({
    start: s(e),
    end: i(e)
  }).map((m) => {
    const h = o.formatMonthDropdown(m, r), b = c(m), g = t && m < a(t) || n && m > a(n) || !1;
    return { value: b, label: h, disabled: g };
  });
}
function C0(e, t = {}, n = {}) {
  let o = { ...t?.[W.Day] };
  return Object.entries(e).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function k0(e, t, n, o) {
  const r = o ?? e.today(), a = n ? e.startOfBroadcastWeek(r, e) : t ? e.startOfISOWeek(r) : e.startOfWeek(r), s = [];
  for (let i = 0; i < 7; i++) {
    const l = e.addDays(a, i);
    s.push(l);
  }
  return s;
}
function M0(e, t, n, o, r = !1) {
  if (!e || !t)
    return;
  const { startOfYear: a, endOfYear: s, eachYearOfInterval: i, getYear: l } = o, c = a(e), p = s(t), f = i({ start: c, end: p });
  return r && f.reverse(), f.map((m) => {
    const h = n.formatYearDropdown(m, o);
    return {
      value: l(m),
      label: h,
      disabled: !1
    };
  });
}
function E0(e, t = {}) {
  const { weekStartsOn: n, locale: o } = t, r = n ?? o?.options?.weekStartsOn ?? 0, a = (i) => {
    const l = typeof i == "number" || typeof i == "string" ? new Date(i) : i;
    return new ke(l.getFullYear(), l.getMonth(), l.getDate(), 12, 0, 0, e);
  }, s = (i) => {
    const l = a(i);
    return new Date(l.getFullYear(), l.getMonth(), l.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => a(ke.tz(e)),
    newDate: (i, l, c) => new ke(i, l, c, 12, 0, 0, e),
    startOfDay: (i) => a(i),
    startOfWeek: (i, l) => {
      const c = a(i), p = l?.weekStartsOn ?? r, f = (c.getDay() - p + 7) % 7;
      return c.setDate(c.getDate() - f), c;
    },
    startOfISOWeek: (i) => {
      const l = a(i), c = (l.getDay() - 1 + 7) % 7;
      return l.setDate(l.getDate() - c), l;
    },
    startOfMonth: (i) => {
      const l = a(i);
      return l.setDate(1), l;
    },
    startOfYear: (i) => {
      const l = a(i);
      return l.setMonth(0, 1), l;
    },
    endOfWeek: (i, l) => {
      const c = a(i), m = (((l?.weekStartsOn ?? r) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + m), c;
    },
    endOfISOWeek: (i) => {
      const l = a(i), c = (7 - l.getDay()) % 7;
      return l.setDate(l.getDate() + c), l;
    },
    endOfMonth: (i) => {
      const l = a(i);
      return l.setMonth(l.getMonth() + 1, 0), l;
    },
    endOfYear: (i) => {
      const l = a(i);
      return l.setMonth(11, 31), l;
    },
    eachMonthOfInterval: (i) => {
      const l = a(i.start), c = a(i.end), p = [], f = new ke(l.getFullYear(), l.getMonth(), 1, 12, 0, 0, e), m = c.getFullYear() * 12 + c.getMonth();
      for (; f.getFullYear() * 12 + f.getMonth() <= m; )
        p.push(new ke(f, e)), f.setMonth(f.getMonth() + 1, 1);
      return p;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (i, l) => {
      const c = a(i);
      return c.setDate(c.getDate() + l), c;
    },
    addWeeks: (i, l) => {
      const c = a(i);
      return c.setDate(c.getDate() + l * 7), c;
    },
    addMonths: (i, l) => {
      const c = a(i);
      return c.setMonth(c.getMonth() + l), c;
    },
    addYears: (i, l) => {
      const c = a(i);
      return c.setFullYear(c.getFullYear() + l), c;
    },
    eachYearOfInterval: (i) => {
      const l = a(i.start), c = a(i.end), p = [], f = new ke(l.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; f.getFullYear() <= c.getFullYear(); )
        p.push(new ke(f, e)), f.setFullYear(f.getFullYear() + 1, 0, 1);
      return p;
    },
    getWeek: (i, l) => {
      const c = s(i);
      return La(c, {
        weekStartsOn: l?.weekStartsOn ?? r,
        firstWeekContainsDate: l?.firstWeekContainsDate ?? o?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (i) => {
      const l = s(i);
      return Fa(l);
    },
    differenceInCalendarDays: (i, l) => {
      const c = s(i), p = s(l);
      return Wa(c, p);
    },
    differenceInCalendarMonths: (i, l) => {
      const c = s(i), p = s(l);
      return ef(c, p);
    }
  };
}
const In = (e) => e instanceof HTMLElement ? e : null, mr = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], P0 = (e) => In(e.querySelector("[data-animated-month]")), hr = (e) => In(e.querySelector("[data-animated-caption]")), gr = (e) => In(e.querySelector("[data-animated-weeks]")), D0 = (e) => In(e.querySelector("[data-animated-nav]")), _0 = (e) => In(e.querySelector("[data-animated-weekdays]"));
function O0(e, t, { classNames: n, months: o, focused: r, dateLib: a }) {
  const s = Vn(null), i = Vn(o), l = Vn(!1);
  Xs(() => {
    const c = i.current;
    if (i.current = o, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || c.length === 0 || o.length !== c.length)
      return;
    const p = a.isSameMonth(o[0].date, c[0].date), f = a.isAfter(o[0].date, c[0].date), m = f ? n[De.caption_after_enter] : n[De.caption_before_enter], h = f ? n[De.weeks_after_enter] : n[De.weeks_before_enter], b = s.current, g = e.current.cloneNode(!0);
    if (g instanceof HTMLElement ? (mr(g).forEach((x) => {
      if (!(x instanceof HTMLElement))
        return;
      const S = P0(x);
      S && x.contains(S) && x.removeChild(S);
      const k = hr(x);
      k && k.classList.remove(m);
      const C = gr(x);
      C && C.classList.remove(h);
    }), s.current = g) : s.current = null, l.current || p || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const v = b instanceof HTMLElement ? mr(b) : [], y = mr(e.current);
    if (y?.every((w) => w instanceof HTMLElement) && v?.every((w) => w instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const w = D0(e.current);
      w && (w.style.zIndex = "1"), y.forEach((x, S) => {
        const k = v[S];
        if (!k)
          return;
        x.style.position = "relative", x.style.overflow = "hidden";
        const C = hr(x);
        C && C.classList.add(m);
        const P = gr(x);
        P && P.classList.add(h);
        const M = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), w && (w.style.zIndex = ""), C && C.classList.remove(m), P && P.classList.remove(h), x.style.position = "", x.style.overflow = "", x.contains(k) && x.removeChild(k);
        };
        k.style.pointerEvents = "none", k.style.position = "absolute", k.style.overflow = "hidden", k.setAttribute("aria-hidden", "true");
        const _ = _0(k);
        _ && (_.style.opacity = "0");
        const O = hr(k);
        O && (O.classList.add(f ? n[De.caption_before_exit] : n[De.caption_after_exit]), O.addEventListener("animationend", M));
        const A = gr(k);
        A && A.classList.add(f ? n[De.weeks_before_exit] : n[De.weeks_after_exit]), x.insertBefore(k, x.firstChild);
      });
    }
  });
}
function N0(e, t, n, o) {
  const r = e[0], a = e[e.length - 1], { ISOWeek: s, fixedWeeks: i, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: p, differenceInCalendarMonths: f, endOfBroadcastWeek: m, endOfISOWeek: h, endOfMonth: b, endOfWeek: g, isAfter: v, startOfBroadcastWeek: y, startOfISOWeek: w, startOfWeek: x } = o, S = l ? y(r, o) : s ? w(r) : x(r), k = l ? m(a) : s ? h(b(a)) : g(b(a)), C = t && (l ? m(t) : s ? h(t) : g(t)), P = C && v(k, C) ? C : k, M = p(P, S), _ = f(a, r) + 1, O = [];
  for (let G = 0; G <= M; G++) {
    const H = c(S, G);
    O.push(H);
  }
  const Y = (l ? 35 : 42) * _;
  if (i && O.length < Y) {
    const G = Y - O.length;
    for (let H = 0; H < G; H++) {
      const j = c(O[O.length - 1], 1);
      O.push(j);
    }
  }
  return O;
}
function R0(e) {
  const t = [];
  return e.reduce((n, o) => {
    const r = o.weeks.reduce((a, s) => a.concat(s.days.slice()), t.slice());
    return n.concat(r.slice());
  }, t.slice());
}
function T0(e, t, n, o) {
  const { numberOfMonths: r = 1 } = n, a = [];
  for (let s = 0; s < r; s++) {
    const i = o.addMonths(e, s);
    if (t && i > t)
      break;
    a.push(i);
  }
  return a;
}
function Vs(e, t, n, o) {
  const { month: r, defaultMonth: a, today: s = o.today(), numberOfMonths: i = 1 } = e;
  let l = r || a || s;
  const { differenceInCalendarMonths: c, addMonths: p, startOfMonth: f } = o;
  if (n && c(n, l) < i - 1) {
    const m = -1 * (i - 1);
    l = p(n, m);
  }
  return t && c(l, t) < 0 && (l = t), f(l);
}
function A0(e, t, n, o) {
  const { addDays: r, endOfBroadcastWeek: a, endOfISOWeek: s, endOfMonth: i, endOfWeek: l, getISOWeek: c, getWeek: p, startOfBroadcastWeek: f, startOfISOWeek: m, startOfWeek: h } = o, b = e.reduce((g, v) => {
    const y = n.broadcastCalendar ? f(v, o) : n.ISOWeek ? m(v) : h(v), w = n.broadcastCalendar ? a(v) : n.ISOWeek ? s(i(v)) : l(i(v)), x = t.filter((P) => P >= y && P <= w), S = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && x.length < S) {
      const P = t.filter((M) => {
        const _ = S - x.length;
        return M > w && M <= r(w, _);
      });
      x.push(...P);
    }
    const k = x.reduce((P, M) => {
      const _ = n.ISOWeek ? c(M) : p(M), O = P.find((Y) => Y.weekNumber === _), A = new cf(M, v, o);
      return O ? O.days.push(A) : P.push(new TC(_, [A])), P;
    }, []), C = new RC(v, k);
    return g.push(C), g;
  }, []);
  return n.reverseMonths ? b.reverse() : b;
}
function I0(e, t) {
  let { startMonth: n, endMonth: o } = e;
  const { startOfYear: r, startOfDay: a, startOfMonth: s, endOfMonth: i, addYears: l, endOfYear: c, today: p } = t, f = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = s(n) : !n && f && (n = r(l(e.today ?? p(), -100))), o ? o = i(o) : !o && f && (o = c(e.today ?? p())), [
    n && a(n),
    o && a(o)
  ];
}
function W0(e, t, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: a = 1 } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: l } = o, c = r ? a : 1, p = s(e);
  if (!t)
    return i(p, c);
  if (!(l(t, e) < a))
    return i(p, c);
}
function F0(e, t, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: a } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: l } = o, c = r ? a ?? 1 : 1, p = s(e);
  if (!t)
    return i(p, -c);
  if (!(l(p, t) <= 0))
    return i(p, -c);
}
function L0(e) {
  const t = [];
  return e.reduce((n, o) => n.concat(o.weeks.slice()), t.slice());
}
function jo(e, t) {
  const [n, o] = qn(e);
  return [t === void 0 ? n : t, o];
}
function z0(e, t) {
  const [n, o] = I0(e, t), { startOfMonth: r, endOfMonth: a } = t, s = Vs(e, n, o, t), [i, l] = jo(
    s,
    // initialMonth is always computed from props.month if provided
    e.month ? s : void 0
  );
  Vf(() => {
    const S = Vs(e, n, o, t);
    l(S);
  }, [e.timeZone]);
  const { months: c, weeks: p, days: f, previousMonth: m, nextMonth: h } = mn(() => {
    const S = T0(i, o, { numberOfMonths: e.numberOfMonths }, t), k = N0(S, e.endMonth ? a(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), C = A0(S, k, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), P = L0(C), M = R0(C), _ = F0(i, n, e, t), O = W0(i, o, e, t);
    return {
      months: C,
      weeks: P,
      days: M,
      previousMonth: _,
      nextMonth: O
    };
  }, [
    t,
    i.getTime(),
    o?.getTime(),
    n?.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    e.endMonth?.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: b, onMonthChange: g } = e, v = (S) => p.some((k) => k.days.some((C) => C.isEqualTo(S))), y = (S) => {
    if (b)
      return;
    let k = r(S);
    n && k < r(n) && (k = r(n)), o && k > r(o) && (k = r(o)), l(k), g?.(k);
  };
  return {
    months: c,
    weeks: p,
    days: f,
    navStart: n,
    navEnd: o,
    previousMonth: m,
    nextMonth: h,
    goToMonth: y,
    goToDay: (S) => {
      v(S) || y(S.date);
    }
  };
}
var Ge;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Ge || (Ge = {}));
function Us(e) {
  return !e[ue.disabled] && !e[ue.hidden] && !e[ue.outside];
}
function $0(e, t, n, o) {
  let r, a = -1;
  for (const s of e) {
    const i = t(s);
    Us(i) && (i[ue.focused] && a < Ge.FocusedModifier ? (r = s, a = Ge.FocusedModifier) : o?.isEqualTo(s) && a < Ge.LastFocused ? (r = s, a = Ge.LastFocused) : n(s.date) && a < Ge.Selected ? (r = s, a = Ge.Selected) : i[ue.today] && a < Ge.Today && (r = s, a = Ge.Today));
  }
  return r || (r = e.find((s) => Us(t(s)))), r;
}
function B0(e, t, n, o, r, a, s) {
  const { ISOWeek: i, broadcastCalendar: l } = a, { addDays: c, addMonths: p, addWeeks: f, addYears: m, endOfBroadcastWeek: h, endOfISOWeek: b, endOfWeek: g, max: v, min: y, startOfBroadcastWeek: w, startOfISOWeek: x, startOfWeek: S } = s;
  let C = {
    day: c,
    week: f,
    month: p,
    year: m,
    startOfWeek: (P) => l ? w(P, s) : i ? x(P) : S(P),
    endOfWeek: (P) => l ? h(P) : i ? b(P) : g(P)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && o ? C = v([o, C]) : t === "after" && r && (C = y([r, C])), C;
}
function kf(e, t, n, o, r, a, s, i = 0) {
  if (i > 365)
    return;
  const l = B0(e, t, n.date, o, r, a, s), c = !!(a.disabled && tt(l, a.disabled, s)), p = !!(a.hidden && tt(l, a.hidden, s)), f = l, m = new cf(l, f, s);
  return !c && !p ? m : kf(e, t, m, o, r, a, s, i + 1);
}
function Y0(e, t, n, o, r) {
  const { autoFocus: a } = e, [s, i] = qn(), l = $0(t.days, n, o || (() => !1), s), [c, p] = qn(a ? l : void 0);
  return {
    isFocusTarget: (g) => !!l?.isEqualTo(g),
    setFocused: p,
    focused: c,
    blur: () => {
      i(c), p(void 0);
    },
    moveFocus: (g, v) => {
      if (!c)
        return;
      const y = kf(g, v, c, t.navStart, t.navEnd, e, r);
      y && (e.disableNavigation && !t.days.some((x) => x.isEqualTo(y)) || (t.goToDay(y), p(y)));
    }
  };
}
function H0(e, t) {
  const { selected: n, required: o, onSelect: r } = e, [a, s] = jo(n, r ? n : void 0), i = r ? n : a, { isSameDay: l } = t, c = (h) => i?.some((b) => l(b, h)) ?? !1, { min: p, max: f } = e;
  return {
    selected: i,
    select: (h, b, g) => {
      let v = [...i ?? []];
      if (c(h)) {
        if (i?.length === p || o && i?.length === 1)
          return;
        v = i?.filter((y) => !l(y, h));
      } else
        i?.length === f ? v = [h] : v = [...v, h];
      return r || s(v), r?.(v, h, b, g), v;
    },
    isSelected: c
  };
}
function G0(e, t, n = 0, o = 0, r = !1, a = Ze) {
  const { from: s, to: i } = t || {}, { isSameDay: l, isAfter: c, isBefore: p } = a;
  let f;
  if (!s && !i)
    f = { from: e, to: n > 0 ? void 0 : e };
  else if (s && !i)
    l(s, e) ? n === 0 ? f = { from: s, to: e } : r ? f = { from: s, to: void 0 } : f = void 0 : p(e, s) ? f = { from: e, to: s } : f = { from: s, to: e };
  else if (s && i)
    if (l(s, e) && l(i, e))
      r ? f = { from: s, to: i } : f = void 0;
    else if (l(s, e))
      f = { from: s, to: n > 0 ? void 0 : e };
    else if (l(i, e))
      f = { from: e, to: n > 0 ? void 0 : e };
    else if (p(e, s))
      f = { from: e, to: i };
    else if (c(e, s))
      f = { from: s, to: e };
    else if (c(e, i))
      f = { from: s, to: e };
    else
      throw new Error("Invalid range");
  if (f?.from && f?.to) {
    const m = a.differenceInCalendarDays(f.to, f.from);
    o > 0 && m > o ? f = { from: e, to: void 0 } : n > 1 && m < n && (f = { from: e, to: void 0 });
  }
  return f;
}
function V0(e, t, n = Ze) {
  const o = Array.isArray(t) ? t : [t];
  let r = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), s = Math.min(a, 6);
  for (let i = 0; i <= s; i++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function js(e, t, n = Ze) {
  return et(e, t.from, !1, n) || et(e, t.to, !1, n) || et(t, e.from, !1, n) || et(t, e.to, !1, n);
}
function U0(e, t, n = Ze) {
  const o = Array.isArray(t) ? t : [t];
  if (o.filter((i) => typeof i != "function").some((i) => typeof i == "boolean" ? i : n.isDate(i) ? et(e, i, !1, n) : ff(i, n) ? i.some((l) => et(e, l, !1, n)) : Uo(i) ? i.from && i.to ? js(e, { from: i.from, to: i.to }, n) : !1 : uf(i) ? V0(e, i.dayOfWeek, n) : za(i) ? n.isAfter(i.before, i.after) ? js(e, {
    from: n.addDays(i.after, 1),
    to: n.addDays(i.before, -1)
  }, n) : tt(e.from, i, n) || tt(e.to, i, n) : $a(i) || Ba(i) ? tt(e.from, i, n) || tt(e.to, i, n) : !1))
    return !0;
  const s = o.filter((i) => typeof i == "function");
  if (s.length) {
    let i = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (s.some((p) => p(i)))
        return !0;
      i = n.addDays(i, 1);
    }
  }
  return !1;
}
function j0(e, t) {
  const { disabled: n, excludeDisabled: o, resetOnSelect: r, selected: a, required: s, onSelect: i } = e, [l, c] = jo(a, i ? a : void 0), p = i ? a : l;
  return {
    selected: p,
    select: (h, b, g) => {
      const { min: v, max: y } = e;
      let w;
      if (h) {
        const x = p?.from, S = p?.to, k = !!x && !!S, C = !!x && !!S && t.isSameDay(x, S) && t.isSameDay(h, x);
        r && (k || !p?.from) ? !s && C ? w = void 0 : w = { from: h, to: void 0 } : w = G0(h, p, v, y, s, t);
      }
      return o && n && w?.from && w.to && U0({ from: w.from, to: w.to }, n, t) && (w.from = h, w.to = void 0), i || c(w), i?.(w, h, b, g), w;
    },
    isSelected: (h) => p && et(p, h, !1, t)
  };
}
function K0(e, t) {
  const { selected: n, required: o, onSelect: r } = e, [a, s] = jo(n, r ? n : void 0), i = r ? n : a, { isSameDay: l } = t;
  return {
    selected: i,
    select: (f, m, h) => {
      let b = f;
      return !o && i && i && l(f, i) && (b = void 0), r || s(b), r?.(b, f, m, h), b;
    },
    isSelected: (f) => i ? l(i, f) : !1
  };
}
function q0(e, t) {
  const n = K0(e, t), o = H0(e, t), r = j0(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function Te(e, t) {
  return e instanceof ke && e.timeZone === t ? e : new ke(e, t);
}
function $t(e, t, n) {
  return Te(e, t);
}
function Ks(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? $t(e, t) : Array.isArray(e) ? e.map((o) => o instanceof Date ? $t(o, t) : o) : Uo(e) ? {
    ...e,
    from: e.from ? Te(e.from, t) : e.from,
    to: e.to ? Te(e.to, t) : e.to
  } : za(e) ? {
    before: $t(e.before, t),
    after: $t(e.after, t)
  } : $a(e) ? {
    after: $t(e.after, t)
  } : Ba(e) ? {
    before: $t(e.before, t)
  } : e;
}
function vr(e, t, n) {
  return e && (Array.isArray(e) ? e.map((o) => Ks(o, t)) : Ks(e, t));
}
function X0(e) {
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = Te(t.today, n)), t.month && (t.month = Te(t.month, n)), t.defaultMonth && (t.defaultMonth = Te(t.defaultMonth, n)), t.startMonth && (t.startMonth = Te(t.startMonth, n)), t.endMonth && (t.endMonth = Te(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = Te(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((K) => Te(K, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? Te(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? Te(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = vr(t.disabled, n)), t.hidden !== void 0 && (t.hidden = vr(t.hidden, n)), t.modifiers)) {
    const K = {};
    Object.keys(t.modifiers).forEach((J) => {
      K[J] = vr(t.modifiers?.[J], n);
    }), t.modifiers = K;
  }
  const { components: o, formatters: r, labels: a, dateLib: s, locale: i, classNames: l } = mn(() => {
    const K = { ...lf, ...t.locale }, J = t.broadcastCalendar ? 1 : t.weekStartsOn, X = t.noonSafe && t.timeZone ? E0(t.timeZone, {
      weekStartsOn: J,
      locale: K
    }) : void 0, fe = t.dateLib && X ? { ...X, ...t.dateLib } : t.dateLib ?? X, re = new Ne({
      locale: K,
      weekStartsOn: J,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, fe);
    return {
      dateLib: re,
      components: l0(t.components),
      formatters: b0(t.formatters),
      labels: x0(t.labels, re.options),
      locale: K,
      classNames: { ...Ya(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: s.today() });
  const { captionLayout: c, mode: p, navLayout: f, numberOfMonths: m = 1, onDayBlur: h, onDayClick: b, onDayFocus: g, onDayKeyDown: v, onDayMouseEnter: y, onDayMouseLeave: w, onNextClick: x, onPrevClick: S, showWeekNumber: k, styles: C } = t, { formatCaption: P, formatDay: M, formatMonthDropdown: _, formatWeekNumber: O, formatWeekNumberHeader: A, formatWeekdayName: Y, formatYearDropdown: G } = r, H = z0(t, s), { days: j, months: F, navStart: V, navEnd: L, previousMonth: R, nextMonth: T, goToMonth: le } = H, ye = s0(j, t, V, L, s), { isSelected: Ce, select: me, selected: ae } = q0(t, s) ?? {}, { blur: te, focused: I, isFocusTarget: se, moveFocus: Z, setFocused: ee } = Y0(t, H, ye, Ce ?? (() => !1), s), { labelDayButton: oe, labelGridcell: de, labelGrid: we, labelMonthDropdown: Pe, labelNav: It, labelPrevious: rn, labelNext: an, labelWeekday: Mf, labelWeekNumber: Ef, labelWeekNumberHeader: Pf, labelYearDropdown: Df } = a, _f = mn(() => k0(s, t.ISOWeek, t.broadcastCalendar, t.today), [s, t.ISOWeek, t.broadcastCalendar, t.today]), Ha = p !== void 0 || b !== void 0, Ko = Re(() => {
    R && (le(R), S?.(R));
  }, [R, le, S]), qo = Re(() => {
    T && (le(T), x?.(T));
  }, [le, T, x]), Of = Re((K, J) => (X) => {
    X.preventDefault(), X.stopPropagation(), ee(K), !J.disabled && (me?.(K.date, J, X), b?.(K.date, J, X));
  }, [me, b, ee]), Nf = Re((K, J) => (X) => {
    ee(K), g?.(K.date, J, X);
  }, [g, ee]), Rf = Re((K, J) => (X) => {
    te(), h?.(K.date, J, X);
  }, [te, h]), Tf = Re((K, J) => (X) => {
    const fe = {
      ArrowLeft: [
        X.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        X.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [X.shiftKey ? "year" : "week", "after"],
      ArrowUp: [X.shiftKey ? "year" : "week", "before"],
      PageUp: [X.shiftKey ? "year" : "month", "before"],
      PageDown: [X.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (fe[X.key]) {
      X.preventDefault(), X.stopPropagation();
      const [re, He] = fe[X.key];
      Z(re, He);
    }
    v?.(K.date, J, X);
  }, [Z, v, t.dir]), Af = Re((K, J) => (X) => {
    y?.(K.date, J, X);
  }, [y]), If = Re((K, J) => (X) => {
    w?.(K.date, J, X);
  }, [w]), Wf = Re((K, J) => (X) => {
    const fe = Number(X.target.value), re = s.setMonth(s.startOfMonth(K), fe);
    le(s.addMonths(re, -J));
  }, [s, le]), Ff = Re((K, J) => (X) => {
    const fe = Number(X.target.value), re = s.setYear(s.startOfMonth(K), fe);
    le(s.addMonths(re, -J));
  }, [s, le]), { className: Lf, style: zf } = mn(() => ({
    className: [l[W.Root], t.className].filter(Boolean).join(" "),
    style: { ...C?.[W.Root], ...t.style }
  }), [l, t.className, t.style, C]), $f = c0(t), Ga = (K) => {
    const J = C?.[W.Dropdown], X = C?.[K];
    if (!(!J && !X))
      return {
        ...J,
        ...X
      };
  }, Va = Vn(null);
  O0(Va, !!t.animate, {
    classNames: l,
    months: F,
    focused: I,
    dateLib: s
  });
  const Bf = {
    dayPickerProps: t,
    selected: ae,
    select: me,
    isSelected: Ce,
    months: F,
    nextMonth: T,
    previousMonth: R,
    goToMonth: le,
    getModifiers: ye,
    components: o,
    classNames: l,
    styles: C,
    labels: a,
    formatters: r
  };
  return D.createElement(
    df.Provider,
    { value: Bf },
    D.createElement(
      o.Root,
      { rootRef: t.animate ? Va : void 0, className: Lf, style: zf, dir: t.dir, id: t.id, lang: t.lang ?? i.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...$f },
      D.createElement(
        o.Months,
        { className: l[W.Months], style: C?.[W.Months] },
        !t.hideNavigation && !f && D.createElement(o.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[W.Nav], style: C?.[W.Nav], "aria-label": It(), onPreviousClick: Ko, onNextClick: qo, previousMonth: R, nextMonth: T }),
        F.map((K, J) => {
          const X = t.reverseMonths ? F.length - 1 - J : J;
          return D.createElement(
            o.Month,
            {
              "data-animated-month": t.animate ? "true" : void 0,
              className: l[W.Month],
              style: C?.[W.Month],
              // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
              key: J,
              displayIndex: J,
              calendarMonth: K
            },
            f === "around" && !t.hideNavigation && J === 0 && D.createElement(
              o.PreviousMonthButton,
              { type: "button", className: l[W.PreviousMonthButton], style: C?.[W.PreviousMonthButton], tabIndex: R ? void 0 : -1, "aria-disabled": R ? void 0 : !0, "aria-label": rn(R), onClick: Ko, "data-animated-button": t.animate ? "true" : void 0 },
              D.createElement(o.Chevron, { disabled: R ? void 0 : !0, className: l[W.Chevron], style: C?.[W.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            D.createElement(o.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: l[W.MonthCaption], style: C?.[W.MonthCaption], calendarMonth: K, displayIndex: J }, c?.startsWith("dropdown") ? D.createElement(
              o.DropdownNav,
              { className: l[W.Dropdowns], style: C?.[W.Dropdowns] },
              (() => {
                const fe = c === "dropdown" || c === "dropdown-months" ? D.createElement(o.MonthsDropdown, { key: "month", className: l[W.MonthsDropdown], "aria-label": Pe(), disabled: !!t.disableNavigation, onChange: Wf(K.date, X), options: S0(K.date, V, L, r, s), style: Ga(W.MonthsDropdown), value: s.getMonth(K.date) }) : D.createElement("span", { key: "month" }, _(K.date, s)), re = c === "dropdown" || c === "dropdown-years" ? D.createElement(o.YearsDropdown, { key: "year", className: l[W.YearsDropdown], "aria-label": Df(s.options), disabled: !!t.disableNavigation, onChange: Ff(K.date, X), options: M0(V, L, r, s, !!t.reverseYears), style: Ga(W.YearsDropdown), value: s.getYear(K.date) }) : D.createElement("span", { key: "year" }, G(K.date, s));
                return s.getMonthYearOrder() === "year-first" ? [re, fe] : [fe, re];
              })(),
              D.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, P(K.date, s.options, s))
            ) : D.createElement(o.CaptionLabel, { className: l[W.CaptionLabel], style: C?.[W.CaptionLabel], role: "status", "aria-live": "polite" }, P(K.date, s.options, s))),
            f === "around" && !t.hideNavigation && J === m - 1 && D.createElement(
              o.NextMonthButton,
              { type: "button", className: l[W.NextMonthButton], style: C?.[W.NextMonthButton], tabIndex: T ? void 0 : -1, "aria-disabled": T ? void 0 : !0, "aria-label": an(T), onClick: qo, "data-animated-button": t.animate ? "true" : void 0 },
              D.createElement(o.Chevron, { disabled: T ? void 0 : !0, className: l[W.Chevron], style: C?.[W.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            J === m - 1 && f === "after" && !t.hideNavigation && D.createElement(o.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[W.Nav], style: C?.[W.Nav], "aria-label": It(), onPreviousClick: Ko, onNextClick: qo, previousMonth: R, nextMonth: T }),
            D.createElement(
              o.MonthGrid,
              { role: "grid", "aria-multiselectable": p === "multiple" || p === "range", "aria-label": we(K.date, s.options, s) || void 0, className: l[W.MonthGrid], style: C?.[W.MonthGrid] },
              !t.hideWeekdays && D.createElement(
                o.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: l[W.Weekdays], style: C?.[W.Weekdays] },
                k && D.createElement(o.WeekNumberHeader, { "aria-label": Pf(s.options), className: l[W.WeekNumberHeader], style: C?.[W.WeekNumberHeader], scope: "col" }, A()),
                _f.map((fe) => D.createElement(o.Weekday, { "aria-label": Mf(fe, s.options, s), className: l[W.Weekday], key: String(fe), style: C?.[W.Weekday], scope: "col" }, Y(fe, s.options, s)))
              ),
              D.createElement(o.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: l[W.Weeks], style: C?.[W.Weeks] }, K.weeks.map((fe) => D.createElement(
                o.Week,
                { className: l[W.Week], key: fe.weekNumber, style: C?.[W.Week], week: fe },
                k && D.createElement(o.WeekNumber, { week: fe, style: C?.[W.WeekNumber], "aria-label": Ef(fe.weekNumber, {
                  locale: i
                }), className: l[W.WeekNumber], scope: "row", role: "rowheader" }, O(fe.weekNumber, s)),
                fe.days.map((re) => {
                  const { date: He } = re, ne = ye(re);
                  if (ne[ue.focused] = !ne.hidden && !!I?.isEqualTo(re), ne[Le.selected] = Ce?.(He) || ne.selected, Uo(ae)) {
                    const { from: Xo, to: Zo } = ae;
                    ne[Le.range_start] = !!(Xo && Zo && s.isSameDay(He, Xo)), ne[Le.range_end] = !!(Xo && Zo && s.isSameDay(He, Zo)), ne[Le.range_middle] = et(ae, He, !0, s);
                  }
                  const Yf = C0(ne, C, t.modifiersStyles), Hf = i0(ne, l, t.modifiersClassNames), Gf = !Ha && !ne.hidden ? de(He, ne, s.options, s) : void 0;
                  return D.createElement(o.Day, { key: `${re.isoDate}_${re.displayMonthId}`, day: re, modifiers: ne, className: Hf.join(" "), style: Yf, role: "gridcell", "aria-selected": ne.selected || void 0, "aria-label": Gf, "data-day": re.isoDate, "data-month": re.outside ? re.dateMonthId : void 0, "data-selected": ne.selected || void 0, "data-disabled": ne.disabled || void 0, "data-hidden": ne.hidden || void 0, "data-outside": re.outside || void 0, "data-focused": ne.focused || void 0, "data-today": ne.today || void 0 }, !ne.hidden && Ha ? D.createElement(o.DayButton, { className: l[W.DayButton], style: C?.[W.DayButton], type: "button", day: re, modifiers: ne, disabled: !ne.focused && ne.disabled || void 0, "aria-disabled": ne.focused && ne.disabled || void 0, tabIndex: se(re) ? 0 : -1, "aria-label": oe(He, ne, s.options, s), onClick: Of(re, ne), onBlur: Rf(re, ne), onFocus: Nf(re, ne), onKeyDown: Tf(re, ne), onMouseEnter: Af(re, ne), onMouseLeave: If(re, ne) }, M(He, s.options, s)) : !ne.hidden && M(re.date, s.options, s));
                })
              )))
            )
          );
        })
      ),
      t.footer && D.createElement(o.Footer, { className: l[W.Footer], style: C?.[W.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function Z0({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: o = "label",
  buttonVariant: r = "ghost",
  locale: a,
  formatters: s,
  components: i,
  ...l
}) {
  const c = Ya();
  return /* @__PURE__ */ u(
    X0,
    {
      showOutsideDays: n,
      className: E(
        "group/calendar bg-background p-2 [--cell-radius:var(--radius-md)] [--cell-size:--spacing(7)] in-data-[slot=card-content]:bg-transparent in-data-[slot=popover-content]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: o,
      locale: a,
      formatters: {
        formatMonthDropdown: (p) => p.toLocaleString(a?.code, { month: "short" }),
        ...s
      },
      classNames: {
        root: E("w-fit", c.root),
        months: E(
          "relative flex flex-col gap-4 md:flex-row",
          c.months
        ),
        month: E("flex w-full flex-col gap-4", c.month),
        nav: E(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          c.nav
        ),
        button_previous: E(
          Lr({ variant: r }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          c.button_previous
        ),
        button_next: E(
          Lr({ variant: r }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          c.button_next
        ),
        month_caption: E(
          "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
          c.month_caption
        ),
        dropdowns: E(
          "flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium",
          c.dropdowns
        ),
        dropdown_root: E(
          "relative rounded-(--cell-radius)",
          c.dropdown_root
        ),
        dropdown: E(
          "absolute inset-0 bg-popover opacity-0",
          c.dropdown
        ),
        caption_label: E(
          "font-medium select-none",
          o === "label" ? "text-sm" : "flex items-center gap-1 rounded-(--cell-radius) text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground",
          c.caption_label
        ),
        month_grid: E("w-full border-collapse", c.month_grid),
        weekdays: E("flex", c.weekdays),
        weekday: E(
          "flex-1 rounded-(--cell-radius) text-[0.8rem] font-normal text-muted-foreground select-none",
          c.weekday
        ),
        week: E("mt-2 flex w-full", c.week),
        week_number_header: E(
          "w-(--cell-size) select-none",
          c.week_number_header
        ),
        week_number: E(
          "text-[0.8rem] text-muted-foreground select-none",
          c.week_number
        ),
        day: E(
          "group/day relative aspect-square h-full w-full rounded-(--cell-radius) p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-(--cell-radius)",
          l.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-(--cell-radius)" : "[&:first-child[data-selected=true]_button]:rounded-l-(--cell-radius)",
          c.day
        ),
        range_start: E(
          "relative isolate z-0 rounded-l-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:right-0 after:w-4 after:bg-muted",
          c.range_start
        ),
        range_middle: E("rounded-none", c.range_middle),
        range_end: E(
          "relative isolate z-0 rounded-r-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:left-0 after:w-4 after:bg-muted",
          c.range_end
        ),
        today: E(
          "rounded-(--cell-radius) bg-muted text-foreground data-[selected=true]:rounded-none",
          c.today
        ),
        outside: E(
          "text-muted-foreground aria-selected:text-muted-foreground",
          c.outside
        ),
        disabled: E(
          "text-muted-foreground opacity-50",
          c.disabled
        ),
        hidden: E("invisible", c.hidden),
        ...t
      },
      components: {
        Root: ({ className: p, rootRef: f, ...m }) => /* @__PURE__ */ u(
          "div",
          {
            "data-slot": "calendar",
            ref: f,
            className: E(p),
            ...m
          }
        ),
        Chevron: ({ className: p, orientation: f, ...m }) => f === "left" ? /* @__PURE__ */ u(Yu, { className: E("size-4", p), ...m }) : f === "right" ? /* @__PURE__ */ u(Ia, { className: E("size-4", p), ...m }) : /* @__PURE__ */ u(Go, { className: E("size-4", p), ...m }),
        DayButton: ({ ...p }) => /* @__PURE__ */ u(Q0, { locale: a, ...p }),
        WeekNumber: ({ children: p, ...f }) => /* @__PURE__ */ u("td", { ...f, children: /* @__PURE__ */ u("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: p }) }),
        ...i
      },
      ...l
    }
  );
}
function Q0({
  className: e,
  day: t,
  modifiers: n,
  locale: o,
  ...r
}) {
  const a = Ya(), s = d.useRef(null);
  return d.useEffect(() => {
    n.focused && s.current?.focus();
  }, [n.focused]), /* @__PURE__ */ u(
    St,
    {
      ref: s,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(o?.code),
      "data-selected-single": n.selected && !n.range_start && !n.range_end && !n.range_middle,
      "data-range-start": n.range_start,
      "data-range-end": n.range_end,
      "data-range-middle": n.range_middle,
      className: E(
        "relative isolate z-10 flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 border-0 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-(--cell-radius) data-[range-end=true]:rounded-r-(--cell-radius) data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-muted data-[range-middle=true]:text-foreground data-[range-start=true]:rounded-(--cell-radius) data-[range-start=true]:rounded-l-(--cell-radius) data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-foreground [&>span]:text-xs [&>span]:opacity-70",
        a.day,
        e
      ),
      ...r
    }
  );
}
function sE({
  value: e,
  onChange: t,
  disabled: n
}) {
  const [o, r] = d.useState(!1), a = d.useMemo(() => new Date(e), [e]), [s, i] = d.useState(a), l = qs(a, !0), c = d.useRef(null);
  return /* @__PURE__ */ u(xx, { className: "w-full", children: /* @__PURE__ */ Q(Yx, { children: [
    /* @__PURE__ */ u(
      jx,
      {
        id: "date-required",
        value: l,
        readOnly: !0,
        disabled: n
      }
    ),
    /* @__PURE__ */ u(Gx, { align: "inline-end", children: /* @__PURE__ */ Q(Qx, { open: o, onOpenChange: r, children: [
      /* @__PURE__ */ u(Jx, { asChild: !0, children: /* @__PURE__ */ Q(
        Ux,
        {
          id: "date-picker",
          variant: "ghost",
          size: "icon-xs",
          "aria-label": "Select date",
          disabled: n,
          children: [
            /* @__PURE__ */ u(_x, {}),
            /* @__PURE__ */ u("span", { className: "sr-only", children: "Select date" })
          ]
        }
      ) }),
      /* @__PURE__ */ u(
        eS,
        {
          ref: c,
          className: "w-auto overflow-hidden p-0 h-[295px]",
          align: "end",
          alignOffset: -8,
          sideOffset: 10,
          onFocusOutside: (f) => f.preventDefault(),
          onInteractOutside: (f) => {
            const m = f.target;
            m && c.current?.contains(m) && f.preventDefault();
          },
          children: /* @__PURE__ */ u(
            Z0,
            {
              mode: "single",
              selected: a,
              month: s,
              onMonthChange: i,
              onSelect: (f) => {
                if (!f) {
                  r(!1);
                  return;
                }
                r(!1), t?.(qs(f));
              }
            }
          )
        }
      )
    ] }) })
  ] }) });
}
function qs(e, t = !1) {
  if (!e)
    return "";
  if (t)
    return e.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  const n = e.getFullYear(), o = String(e.getMonth() + 1).padStart(2, "0"), r = String(e.getDate()).padStart(2, "0");
  return `${n}-${o}-${r}`;
}
export {
  Mk as Accordion,
  Dk as AccordionContent,
  Ek as AccordionItem,
  Pk as AccordionTrigger,
  cM as AlertDialog,
  vM as AlertDialogAction,
  bM as AlertDialogCancel,
  uM as AlertDialogContent,
  gM as AlertDialogDescription,
  pM as AlertDialogFooter,
  fM as AlertDialogHeader,
  mM as AlertDialogMedia,
  hM as AlertDialogTitle,
  dM as AlertDialogTrigger,
  Lk as Avatar,
  Bk as AvatarBadge,
  $k as AvatarFallback,
  Yk as AvatarGroup,
  Hk as AvatarGroupCount,
  zk as AvatarImage,
  Vk as Badge,
  St as Button,
  uk as ButtonGroup,
  Z0 as Calendar,
  Q0 as CalendarDayButton,
  _k as Card,
  Tk as CardAction,
  Ak as CardContent,
  Rk as CardDescription,
  Ik as CardFooter,
  Ok as CardHeader,
  Nk as CardTitle,
  wk as Checkbox,
  OM as Collapsible,
  RM as CollapsibleContent,
  NM as CollapsibleTrigger,
  sE as DatePicker,
  FM as Dialog,
  zM as DialogClose,
  $M as DialogContent,
  GM as DialogDescription,
  YM as DialogFooter,
  BM as DialogHeader,
  rS as DialogOverlay,
  oS as DialogPortal,
  HM as DialogTitle,
  LM as DialogTrigger,
  VM as DropdownMenu,
  ZM as DropdownMenuCheckboxItem,
  KM as DropdownMenuContent,
  qM as DropdownMenuGroup,
  XM as DropdownMenuItem,
  eE as DropdownMenuLabel,
  UM as DropdownMenuPortal,
  QM as DropdownMenuRadioGroup,
  JM as DropdownMenuRadioItem,
  tE as DropdownMenuSeparator,
  nE as DropdownMenuShortcut,
  oE as DropdownMenuSub,
  aE as DropdownMenuSubContent,
  rE as DropdownMenuSubTrigger,
  jM as DropdownMenuTrigger,
  xx as Field,
  ak as FieldContent,
  lk as FieldDescription,
  dk as FieldError,
  rk as FieldGroup,
  sk as FieldLabel,
  ok as FieldLegend,
  ck as FieldSeparator,
  nk as FieldSet,
  ik as FieldTitle,
  $x as Input,
  Yx as InputGroup,
  Gx as InputGroupAddon,
  Ux as InputGroupButton,
  jx as InputGroupInput,
  Ck as InputGroupText,
  kk as InputGroupTextarea,
  bx as Label,
  oM as Pagination,
  rM as PaginationContent,
  lM as PaginationEllipsis,
  aM as PaginationItem,
  ju as PaginationLink,
  iM as PaginationNext,
  sM as PaginationPrevious,
  Qx as Popover,
  eS as PopoverContent,
  xM as PopoverDescription,
  yM as PopoverHeader,
  wM as PopoverTitle,
  Jx as PopoverTrigger,
  Gk as Progress,
  Wk as ScrollArea,
  Kx as ScrollBar,
  fk as Select,
  gk as SelectContent,
  pk as SelectGroup,
  bk as SelectItem,
  vk as SelectLabel,
  zx as SelectScrollDownButton,
  Lx as SelectScrollUpButton,
  yk as SelectSeparator,
  hk as SelectTrigger,
  mk as SelectValue,
  yx as Separator,
  SM as Sheet,
  kM as SheetClose,
  MM as SheetContent,
  _M as SheetDescription,
  PM as SheetFooter,
  EM as SheetHeader,
  DM as SheetTitle,
  CM as SheetTrigger,
  Fk as Skeleton,
  Sk as Slider,
  xk as Switch,
  qk as Table,
  Zk as TableBody,
  nM as TableCaption,
  tM as TableCell,
  Qk as TableFooter,
  eM as TableHead,
  Xk as TableHeader,
  Jk as TableRow,
  Bx as Textarea,
  Uk as Toggle,
  jk as ToggleGroup,
  Kk as ToggleGroupItem,
  AM as Tooltip,
  WM as TooltipContent,
  TM as TooltipProvider,
  IM as TooltipTrigger,
  qx as badgeVariants,
  Lr as buttonVariants,
  E as cn,
  Vu as toggleVariants
};
